/* global __APP__ */

import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue';
import $ from 'jquery';
import tether from 'tether';
import { ClientTable } from 'vue-tables-2';
import 'jquery.mmenu';
import 'slick-carousel';
import Cookies from 'js-cookie';
import * as api from './api';
import Paginate from 'vuejs-paginate';
import { jwt } from './api';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select';
import { VueperSlides, VueperSlide } from 'vueperslides';
import dayjs from 'dayjs';
import { Doughnut, Bar } from 'vue-chartjs';

window.jQuery = window.$ = $;
window.Tether = tether;
require('bootstrap');
require('air-datepicker');
require('air-datepicker/dist/js/i18n/datepicker.en');
require('vueperslides');

$(() => {
  // Global variable storing the interval ID that refreshes the
  // balance. Needs to be cleared on user log out.
  let balanceInterval;
  // Global variable storing the interval ID that refreshes the
  // jwt token. Needs to be cleared on user log out.
  let tokenInterval;

  // Global constants defining user roles
  const ROLE_USER = "10";
  const ROLE_CASHIER = "15";
  const ROLE_AGENT = "20";
  const ROLE_SUPER_AGENT = "30";
  const ROLE_PARTNER = "50";
  const ROLE_REPORTER = "90";
  const ROLE_OWNER = "100";

  const STATUS_WON = "won";
  const STATUS_LOST = "lost";
  const STATUS_OPEN = "open";
  const STATUS_CANCELED = "canceled";

  const PAIDOUT_YES = "1";
  const PAIDOUT_NO = "0";

   // Global constants for defining the Bonus Categories
   const SERVICE_BIA_TEXT = 'BIA';

  // Global constants for defining the casino games technology
  const FLASH = "1";
  const HTML5 = "2";

  // Minimum Deposit Withdrawal amount
  const MINIMUM_DEPOSIT_AMOUNT = 10;
  const MINIMUM_WITHDRAW_AMOUNT = 20;
  const MINIMUM_DEFAULT_AMOUNT = 1;
  const MAXIMUM_WITHDRAW_AMOUNT = 2000;
  const MAXIMUM_DEPOSIT_AMOUNT = 2000;

  // Timeout constants
  const AGENT_TRANSFER_V2_TYPING_TIMEOUTS = 250;
  const SUCCESS_MESSAGE_TIMEOUT = 3000;
  const SUBMIT_BUTTON_DEACTIVATION_TIMEOUT = 3000;

  const PRAXIS_CURRENCIES = ['EUR', 'USD', 'PEN', 'BRL'];

  // Global constant for defining unsupported casino providers 
  const UNSUPPORTED_CASINO_PROVIDERS = ['HOLLYWOOD TV'];

  // Currencies
  const CURRENCY_TND = "TND";

  // Global constant of fetching all category ids
  const CATEGORY_ALL_GAMES = -1;
  
  // Global constant for defining casino restrictions
  const CASINO_RESTRICTIONS = {
    "TND": [
      "ASIA GAMING"
    ],
  };

  /* -----------------------------------------
 	 Enable Bootstrap Tooltips
 	 ----------------------------------------- */
  $('[data-toggle="tooltip"]').tooltip();

  /* -----------------------------------------
 	 Initialize homepage slideshow
 	 ----------------------------------------- */
  $('.slideshow-main').slick({
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    dots: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
  });

  /* ----------------------------------------
  // Pagination registration component
   ----------------------------------------*/
   Vue.component('paginate', Paginate);

 /* -----------------------------------------
  // Set the component
  ------------------------------------------*/
  Vue.component('modal-link', {
    template: `<a href="#" :class="modalLinkClass" v-on:click.prevent="openModals">{{ openLinkText }}<i class="fa fa-external-link" aria-hidden="true"></i></a>`,
    props: ['modalLinkpagekey', 'modalLinktext', 'modalLinktype', 'modalClassname', 'modalCurrency', 'modalParams'],
    data() {
      return {
        openLinkModal: this.modalLinkpagekey,
        openLinkText: this.modalLinktext,
        openLinkType: this.modalLinktype,
        modalLinkClass: this.modalClassname,
        params: this.modalParams,
        currency: this.modalCurrency
      };
    },
    methods: {
      openModals() {
        $("#overlay").css("display", "block");
        switch(this.openLinkType) {
          case 'register':
            this.modalClass = "register-terms-link";
            api.modalPage(this.openLinkModal)
              .done(res => {
                $(".modal-title").html(res.title);
                $(".modal-body").html(res.main_text);
                $("#overlay").css("display", "none");
                $(".modal-page").modal('show');
              })
              .fail(({ responseJSON: res }) => {
                consoleLog("Error");
              });
            break;

          case 'report':
            this.modalClass = "casino-report-link";
            api.generateCasinoReportPerProvider(reverseDateFormat(this.params.datefrom), reverseDateFormat(this.params.dateto), this.params.userid)
              .done(res => {
                if( res.list !== undefined && res.list.length > 0 ) {                  
                  let providerResults = res.list.map(item => {
                    return {
                      'username': item.serviceName,
                      'stakes': swapCurrency(formatMoney(item.stakes, this.currency)),
                      'winnings': swapCurrency(formatMoney(item.winnings, this.currency)),
                      'net': swapCurrency(formatMoney(item.net, this.currency)),
                      'margin': item.margin
                    };
                  });
                  let bodyContent = '';
                  for (let i=0; i<providerResults.length; i++) {
                    bodyContent += '<div class="row">' +
                      '<div class="col-4 custom-cell">' + providerResults[i].username + '</div>' +
                      '<div class="col-2 custom-cell">' + providerResults[i].stakes + '</div>' +
                      '<div class="col-2 custom-cell">' + providerResults[i].winnings + '</div>' +
                      '<div class="col-2 custom-cell">' + providerResults[i].net + '</div>' +
                      '<div class="col-2 custom-cell">' + providerResults[i].margin + '%</div></div>';
                  }
                  let footerContent = '<div class="col-4 custom-cell">Totals</div>' +
                    '<div class="col-2 custom-cell">' + swapCurrency(formatMoney(res.summary.totalStakes, this.currency)) + '</div>' +
                    '<div class="col-2 custom-cell">' + swapCurrency(formatMoney(res.summary.totalWinnings, this.currency)) + '</div>' +
                    '<div class="col-2 custom-cell">' + swapCurrency(formatMoney(res.summary.net, this.currency)) + '</div>' +
                    '<div class="col-2 custom-cell">' + res.summary.margin + '%</div>';

                  $("#overlay").css("display", "none");
                  $(".modal-title").html(this.openLinkModal);
                  $("#providers-reports-table .custom-table-body").html(bodyContent);
                  $("#providers-reports-table .custom-table-footer").html(footerContent);
                  $(".modal-body").html($("#providers-reports-table").html());
                  $(".modal-page").modal('show');
                }
                else {
                  let bodyContent = '';
                    bodyContent += '<div class="row">' +
                      '<div class="col-12 custom-cell">' + __APP__.noData + '</div></div>';
  
                  $("#overlay").css("display", "none");
                  $(".modal-title").html(this.openLinkModal);
                  $("#providers-reports-table .custom-table-body").html(bodyContent);
                  $(".modal-body").html($("#providers-reports-table").html());
                  $(".modal-page").modal('show');
                }
              })
              .fail(({ responseJSON: res }) => {
                this.error = true;
                if (res.errors) {
                  this.errorMessage = res.errors[0].message;
                }
              })
            break;
        }
      }
    }
  });

      /* -----------------------------------------
  // Set the bar chart component
  ------------------------------------------*/
  Vue.component('bar-chart', {
    extends: Bar,
    props: ['dataCollection', 'chartOptions'],
    mounted () {
      let gradient1 = "#ddd";
      let gradient2 = "#ddd";
      this.dataCollection.datasets[0].data[0] = fromCents(this.dataCollection.datasets[0].data[0]);
      this.dataCollection.datasets[0].data[1] = fromCents(this.dataCollection.datasets[0].data[1]);
      if (this.dataCollection.datasets[0].data[0] !==0 || this.dataCollection.datasets[0].data[1] !==0) {
        let ctx = document.getElementById('bar-chart');
        gradient1 = ctx.getContext("2d").createLinearGradient(0, 0, 0, 120);
        gradient1.addColorStop(0, '#3171BC');
        gradient1.addColorStop(1, '#66A2E9');
        gradient2 = ctx.getContext("2d").createLinearGradient(0, 0, 0, 120);
        gradient2.addColorStop(0, "#40A82F");
        gradient2.addColorStop(1, "#AACF40");
      }
      this.chartOptions.scales = {
        x: {
          ticks: {
            autoSkip: false
          }
        },
      };
      this.dataCollection.datasets[0].backgroundColor[0] = gradient2;
      this.dataCollection.datasets[0].backgroundColor[1] = gradient1;
      this.renderChart(this.dataCollection, this.chartOptions);
    }
  });
  /* -----------------------------------------
  // Set the chart component
  ------------------------------------------*/
  Vue.component('doughnut-chart', {
    extends: Doughnut,
    props: ['dataCollection', 'chartOptions'],
    mounted () {
      let gradient1 = "#ddd";
      let gradient2 = "#ddd";
      this.dataCollection.datasets[0].data[2]=1;
      if (this.dataCollection.datasets[0].data[0]!==0 || this.dataCollection.datasets[0].data[1]!==0) {
        let ctx = document.getElementById('doughnut-chart');
        gradient1 = ctx.getContext("2d").createLinearGradient(0, 0, 0, 120);
        gradient1.addColorStop(0, '#3171BC');
        gradient1.addColorStop(1, '#66A2E9');
        gradient2 = ctx.getContext("2d").createLinearGradient(0, 0, 0, 120);
        gradient2.addColorStop(0, "#40A82F");
        gradient2.addColorStop(1, "#AACF40");
        this.dataCollection.datasets[0].data.pop();
      }
      this.dataCollection.datasets[0].backgroundColor[0] = gradient2;
      this.dataCollection.datasets[0].backgroundColor[1] = gradient1;
      this.renderChart(this.dataCollection, this.chartOptions);
    }
  });

  /* -----------------------------------------
  Set the widget sportsbook component
------------------------------------------*/
  Vue.component('sportsbook', {
    template: `<div id="bia-sports-frame"></div>`,
    props: ['args'],
    mounted() {
      let sbArgs = {
        page: this.args.page === 'prelive' ? 'overview' : this.args.page,
        lang: this.args.lang,
        sportId: this.gameId,
      };

      let locationHash = window.location.hash;
      let param = locationHash.split("/");

      if (param[1] === "championship") {
        let champIds = this.args.champids.toString();
        champIds = param[2].split(",").map((id) => {
          if (id > 0) {
            return parseInt(id);
        }
      });
        sbArgs = {...sbArgs, championshipIds: champIds};
      }
      else if (param[1] === "category") {
        let catIds = this.args.catids.toString();
        catIds = param[2].split(",").map((id) => {
          if (id > 0) {
            return parseInt(id);
          }
        });
        sbArgs = {...sbArgs, categoryIds: catIds};
      }
      else if (param[1] === "event") {
        let eventID = parseInt(param[2]);
          sbArgs = {...sbArgs, eventId: eventID};
      }
      else if (param[1] === "sport") {
        let sportID = parseInt(param[2]);
        sbArgs = {...sbArgs, sportId: sportID};
      }
      else if (param[1] === "liveEvent") {
        let liveEventID = parseInt(param[2]);
        sbArgs = {...sbArgs, eventId: liveEventID};
      }   
      else if(param[1] === "toto") {
        sbArgs.page = "toto";
      }

      window.ASB = window.altenarWSDK.addSportsBook({
        props: sbArgs,
        container: document.getElementById('bia-sports-frame')
      });
    }
  });
  const sportsbookContainer = new Vue({
    el: '#sportsbook-container',
    data() {
      return {
        args: $("#sportsbook-container").data("args")
      }
    },
    created() {
      if($("#sportsbook-container").length === 0) {
        return false;
      }
      api.getSportsBook(__APP__.loggedIn)
        .done(({tokenValue}) => {
          window.altenarWSDK.init({
            integration: "x2bet365",
            culture: this.args.lang,
            token: tokenValue,
          });
        })
        .fail(({ responseJSON: res }) => {
          consoleLog(res);
        });
    },
    mounted() {
      if($("#sportsbook-container").length === 0) {
        return false;
      }
    },
  });

   /* -----------------------------------------
  Agent Dashboard
  ----------------------------------------- */
  const AgentDashboard = new Vue({
    el: '.agent-dashboard-main',
    data: {
      fromDate: '',
      toDate: '',
      filters: [],
      picked: 'date_created',
      createdFrom: '',
      createdTo: '',
      settledFrom: '',
      settledTo: '',
      paidFrom: '',
      paidTo: '',
      charts: {
        turnover: {
          options: {},
          data: {},
          totals: {}
        },
        winnings: {
          options: {},
          data: {},
          totals: {}
        },
        profit: {
          options: {},
          data: {},
          totals: {}
        },
        selfTransactions: {
          options: {},
          data: {},
          totals: {}
        },
        networkTransactions: {
          options: {},
          data: {},
          totals: {}
        }
      },
      currency: "",
      loadCharts: 0,
      gradient: "",
      gradient1: "",
      error: false
    },
    computed: {
      turnoverSports() {
        return swapCurrency(formatMoney(parseInt(this.charts.turnover.data.datasets[0].data[0]), this.currency));
      },
      turnoverCasino() {
        return swapCurrency(formatMoney(parseInt(this.charts.turnover.data.datasets[0].data[1]), this.currency));
      },
      turnoverTotals() {
        return this.charts.turnover.totals;
      },
      winningsSports() {
        return swapCurrency(formatMoney(parseInt(this.charts.winnings.data.datasets[0].data[0]), this.currency));
      },
      winningsCasino() {
        return swapCurrency(formatMoney(parseInt(this.charts.winnings.data.datasets[0].data[1]), this.currency));
      },
      winningsTotals() {
        return this.charts.winnings.totals;
      },
      profitSports() {
        return swapCurrency(formatMoney(parseInt(this.charts.profit.data.datasets[0].data[0]), this.currency));
      },
      profitCasino() {
        return swapCurrency(formatMoney(parseInt(this.charts.profit.data.datasets[0].data[1]), this.currency));
      },
      profitTotals() {
        return this.charts.profit.totals;
      },
      selfTransactionsMoneyIn() {
        return swapCurrency(formatMoney(parseInt(this.charts.selfTransactions.data.datasets[0].data[0]), this.currency));
      },
      selfTransactionsMoneyOut() {
        return swapCurrency(formatMoney(parseInt(this.charts.selfTransactions.data.datasets[0].data[1]), this.currency));
      },
      selfTransactionsTotals() {
        return swapCurrency(formatMoney((parseInt(this.charts.selfTransactions.data.datasets[0].data[0]) - parseInt(this.charts.selfTransactions.data.datasets[0].data[1])), this.currency));
      },
      networkTransactionsMoneyIn() {
        return swapCurrency(formatMoney(parseInt(this.charts.networkTransactions.data.datasets[0].data[0]), this.currency));
      },
      networkTransactionsMoneyOut() {
        return swapCurrency(formatMoney(parseInt(this.charts.networkTransactions.data.datasets[0].data[1]), this.currency));
      },
      networkTransactionsTotals() {
        return swapCurrency(formatMoney((parseInt(this.charts.networkTransactions.data.datasets[0].data[0]) - parseInt(this.charts.networkTransactions.data.datasets[0].data[1])), this.currency));
      },
    },
    methods: {
      getChartsOptions() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            tooltip: {
              enabled: false
            },
            legend: {
              display: false,
            },
            title: {
              display: false,
              font: {
                size: 20
              },
            }
          }
        }
      },
      getChartsData(chartItemTitle1, chartItemTitle2, data) {
        return {
          labels: [ chartItemTitle1, chartItemTitle2],
          datasets: [
            {
              backgroundColor: ["", ""],
              data: data
            }
          ]
        }
      },
      setCharts() {
        let that = this;
        if (this.picked === 'date_created') {
          that.filters['picked'] = 'date_created';
          this.createdFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.createdTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.settledFrom = '';
          this.settledTo = '';
          this.paidFrom = '';
          this.paidTo = '';
          this.filters['settledFrom'] = '';
          this.filters['settledTo'] = '';
          that.filters['createdFrom'] = (this.createdFrom) ? this.createdFrom : '';
          that.filters['createdTo'] = (this.createdTo) ? this.createdTo : '';
          this.filters['paidFrom'] = '';
          this.filters['paidTo'] = '';
        }
        else if (this.picked === 'date_settled') {
          that.filters['picked'] = 'date_settled';
          this.createdFrom = '';
          this.createdTo = '';
          this.paidFrom = '';
          this.paidTo = '';
          this.settledFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.settledTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.filters['createdFrom'] = '';
          this.filters['createdTo'] = '';
          that.filters['settledFrom'] = (this.settledFrom) ? this.settledFrom : '';
          that.filters['settledTo'] = (this.settledTo) ? this.settledTo : '';
          this.filters['paidFrom'] = '';
          this.filters['paidTo'] = '';
        }
        else if (this.picked === 'date_paid') {
          that.filters['picked'] = 'date_paid';
          this.createdFrom = '';
          this.createdTo = '';
          this.settledFrom = '';
          this.settledTo = '';
          this.paidFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.paidTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.filters['createdFrom'] = '';
          this.filters['createdTo'] = '';
          this.filters['settledFrom'] = '';
          this.filters['settledTo'] = '';
          that.filters['paidFrom'] = (this.paidFrom) ? this.paidFrom : '';
          that.filters['paidTo'] = (this.paidTo) ? this.paidTo : '';
        }
        this.error = false;
        this.loadCharts = 0;
        api.getAgentOverall(reverseDateFormat(this.createdFrom), reverseDateFormat(this.createdTo), reverseDateFormat(this.settledFrom), reverseDateFormat(this.settledTo), reverseDateFormat(this.paidFrom), reverseDateFormat(this.paidTo))
          .done(res => {
            this.charts.turnover.options = this.getChartsOptions();
            this.charts.turnover.data = this.getChartsData($("#sports_string").text(), $("#casino_string").text(), [parseInt(res.overall.sbStakes), parseInt(res.overall.casinoStakes)]);
            this.charts.turnover.totals = swapCurrency(formatMoney(parseInt(res.overall.totalStakes), this.currency))
            this.charts.winnings.options = this.getChartsOptions();
            this.charts.winnings.data = this.getChartsData($("#sports_string").text(), $("#casino_string").text(), [parseInt(res.overall.sbWinnings), parseInt(res.overall.casinoWinnings)]);
            this.charts.winnings.totals = swapCurrency(formatMoney(parseInt(res.overall.totalWinnings), this.currency))
            this.charts.profit.options = this.getChartsOptions();
            this.charts.profit.data = this.getChartsData($("#sports_string").text(), $("#casino_string").text(), [parseInt(res.overall.sbNet), parseInt(res.overall.casinoNet)]);
            this.charts.profit.totals = swapCurrency(formatMoney(parseInt(res.overall.totalNet), this.currency))
            this.charts.networkTransactions.options = this.getChartsOptions();
            this.charts.networkTransactions.data = this.getChartsData($("#moneyIn_string").text(), $("#moneyOut_string").text(),[parseInt(res.overall.moneyIn), parseInt(res.overall.moneyOut)]);
          })
          .fail(({ responseJSON: error }) => {
            this.error = true;
          })
          .always(() => {
            this.loadCharts++;
          });
          api.getAgentMoneyActivity(reverseDateFormat(this.createdFrom), reverseDateFormat(this.createdTo), reverseDateFormat(this.settledFrom), reverseDateFormat(this.settledTo), reverseDateFormat(this.paidFrom), reverseDateFormat(this.paidTo))
          .done(res => {
            this.charts.selfTransactions.options = this.getChartsOptions();
            this.charts.selfTransactions.data = this.getChartsData($("#moneyIn_string").text(), $("#moneyOut_string").text(), [parseInt(res.moneyIn), parseInt(res.moneyOut)]);
          })
          .fail(({ responseJSON: error }) => {
            this.error = true;
          })
          .always(() => {
            this.loadCharts++;
          });
      }
    },
    created () {
      if (!document.getElementById('agent-dashboard-main')) {
        return;
      }
      setDate('week', this);
      api.getBalance()
        .done(res => {
          this.currency = res.currency;
          this.setCharts();
        });
    },
    mounted () {
      if (!document.getElementById('agent-dashboard-main')) {
        return;
      }
      // Initialize datepickers
      const that = this;
      const $startDate = $(this.$refs.fromDate);
      const $endDate = $(this.$refs.toDate);
      $startDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate, date) {
          that.fromDate = formattedDate;
          $endDate.datepicker().data('datepicker').update('minDate', date);
        },
      });
      $endDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate) {
          that.toDate = formattedDate;
        },
      });
    }
  });


  /* -----------------------------------------
 	 Initialize mobile menu
 	 ----------------------------------------- */
	var $mainMobileNav = $('#nav-mobile');
	var $userMobileNav = $('#nav-mobile-user');

	// Main mobile navigation
	$mainMobileNav.mmenu({
		offCanvas: {
			zposition: 'next'
		},
		navbars: [{
			position: 'top',
			'content': [
				'prev',
				'close'
			]
		}],
		extensions: [
			'effect-listitems-slide',
			'shadow-page'
		]
	});

	// User mobile navigation
	$userMobileNav.mmenu({
		offCanvas: {
			position: 'right',
			zposition: 'next'
		},
		navbars: [{
			position: 'top',
			'content': [
				'prev',
				'close'
			]
		}],
		extensions: [
			'effect-listitems-slide',
			'shadow-page'
		]
  });

  class FormatMoney {
    //TODO: Get constructor's params from skin's cms settings
    constructor(thousandsType=',', decimalsType='.') {
      this.thousands = thousandsType;
      this.decimals = decimalsType;
    }

    formatAmount(cents, currency) {
      const amount = fromCents(cents);
      let amount_parts = amount.toFixed(2).toString().split(this.decimals);
      amount_parts[0] = amount_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousands);

      return currency == null
        ? amount_parts.join(this.decimals)
        :`${currency} ${amount_parts.join(this.decimals)}`;
    }
  };

  const skinFormatMoney = new FormatMoney();

  const consoleLog = (message) => {
    if(__APP__.environment === 'development') {
      console.log(message);
    }
  }

  const toCents = (amount) => {
      return amount * 100;
  }

  const fromCents = (amount) => {
    return amount / 100;
  }

  const formatAmount = (amount) => {
    return parseFloat(amount).toFixed(2);
   }

  const formatMoney = (cents, currency) => {
    const amount = fromCents(cents);

    return currency == null
      ? amount.toFixed(2)
      : `${currency} ${amount.toFixed(2)}`;
  };

  const convertDate = (date) => {
    const d = new Date(date);
    return (d.getMonth() + 1) + "-" + d.getDate() + "-" + d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2);
  };

  // Validations
  const validateInteger = (number) => {
    const regex = /^[0-9]*$/;
    return regex.test(number) ? true : false;
  }

  /* -----------------------------------------
	 language menu
 	 ----------------------------------------- */
	$('#lang-drop').hide();
    $('#lang-trigger').click( function(){
        $('#lang-drop').slideToggle(150);
        return false;
    });
    $(document).click( function(){
        $('#lang-drop').hide();
    });

  /* -----------------------------------------
	 auto-close alerts
 	 ----------------------------------------- */
  $('.alert-dismissible').fadeTo(2000, 500).slideUp(500, function(){
    $('.alert-dismissible').alert('close');
  });

  /* -----------------------------------------
 	 Login Flow
 	 ----------------------------------------- */

  $(".toggle-password").on('click',function() {
    $(this).toggleClass("fa-eye fa-eye-slash");
    var input = $(".login-password");
    if (input.attr("type") === "password") {
      input.attr("type", "text");
    } else {
      input.attr("type", "password");
    }
  });

  $('.form-login').each(function () {
    const $this = $(this);
    const $btnLogin = $this.find('.btn-login-form');
    const $loginErrors = $this.find('.login-errors');

    $btnLogin.popover({
      content: $loginErrors,
      placement: 'bottom',
      animation: false,
      template: `
        <div class="popover popover-danger" role="tooltip">
          <div class="popover-arrow"></div>
          <div class="popover-content"></div>
        </div>`,
      trigger: 'focus',
    });

    $this.on('submit', function (event) {
      event.preventDefault();
      const $this = $(this);
      const login = $this.find('.login-username').val();
      const password = $this.find('.login-password').val();
      const platform = __APP__.device_string;
      const device = navigator.userAgent;
      const $btn = $this.find('[type="submit"]');
      $btn.addClass('btn-loading');
      $btnLogin.popover('hide');

      api.login(login, password, platform, device)
        .done(res => {
          if (res.errors) {
            let errorText = '';
            if(res.errors[0].errorCode == 112) { //redirect for old users
              location.replace(`${location.origin}/${__APP__.langShort}/old-users`);
              return;
            }
            else if (res.errors[0].errorCode == 102) {
              errorText = $("#wrong_credentials").val();
            }
            else if (res.errors[0].errorCode == 103) {
              errorText = $("#account_is_not_activated").val();
            }
            else {
              errorText = res.errors[0].message;
            }
            $loginErrors.text(errorText);
            $btn.removeClass('btn-loading');
            setTimeout(() => $btnLogin.popover('show'), 500);
            return;
          }

          const url = ( localStorage.getItem('redirectUrl') ) ? encodeURIComponent( localStorage.getItem('redirectUrl') ) : location.pathname;
          localStorage.removeItem('redirectUrl');
          localStorage.setItem('jwtToken', res.jwt);
          localStorage.setItem('role', res.role);
          localStorage.setItem('userSource', res.userSource);
          location.replace(`${location.origin}/${__APP__.langShort}/login/${res.language || __APP__.langShort}?jwt=${res.jwt}&url=${url}&role=${res.role}&userSource=${res.userSource}`);
        });
    });
  });

  /* -----------------------------------------
 	 Logout Flow
 	 ----------------------------------------- */
  const userLogout = event => {
    if (event) {
      event.preventDefault();
    }

    api.logout().done(() => {
      clearInterval(balanceInterval);
      clearInterval(tokenInterval);
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('redirectUrl');
      localStorage.removeItem('role');
      localStorage.removeItem('user_id');
      localStorage.removeItem('username');
      localStorage.removeItem('userSource');
      localStorage.removeItem('currency');
      location.replace(`${location.origin}/${__APP__.langShort}/logout`);
    });
  };

  $('.btn-logout').on('click', userLogout);

  /* -----------------------------------------
	 Refresh Token
 	 ----------------------------------------- */
  const refreshToken = () => {
    api.refreshToken()
      .done(res => {
        consoleLog(res);
        localStorage.setItem('jwtToken', res.jwt);
      })
      .fail(error => {
        consoleLog('cannot refresh jwt: ' + error);
      });
  };
  if (__APP__.loggedIn) { // refresh jwt is only for logged-in users
    refreshToken();
    tokenInterval = setInterval(refreshToken, 2700000); // 45 minutes
  }

  /* -----------------------------------------
  Modal Accept Terms and Conditions
  ----------------------------------------- */
  const ModalTerms = new Vue({
    el: '.form-modal-terms',
    data: {
      error: '',
      success: '',
      loading: false,
    },
    methods: {
      submit() {
        this.loading = true;

        api.acceptTC()
          .done((res) => {
            location.replace(`${location.origin}/${__APP__.langShort}`);
          })
          .fail((error) => {
            consoleLog(error);
          })
          .always(() => this.loading = false);
      }
    },
  });

  /* -----------------------------------------
 	 Get user info and populate the UI
 	 ----------------------------------------- */
  const updateUserInfo = () => {
    api.getPlayer().done(res => {
      $('.js-username').text(res.username);
      localStorage.setItem('user_id', res.user_id);
      localStorage.setItem('username', res.username);
      localStorage.setItem('currency', res.currency);
      if (res.language == null) {
        api.updateUserLanguage(__APP__.langShort);
      }

      if (res.tcAccepted == false) {
        if (window.location.href.indexOf("terms-conditions") > -1 || window.location.href.indexOf("privacy-policy") > -1) {
        } else {
          $('#modal-terms').modal('show');
          return;
        }
      }

    }).fail(() => userLogout());
  };

// This function filters Flexsy providers or games, depending on the "values"
  const filterFlexsy = (values) => {
    const FLEXSY_UNSUPPORTIVE_PROVIDERS = __APP__.environment !== 'development' ? ['143', '157', '156', '153', '154', '155', '158', '159', '76'] : ['110', '113', '97'];
    return values.filter(value => {
      return !FLEXSY_UNSUPPORTIVE_PROVIDERS.includes(value.provider_id ? value.provider_id : value.provider.id);
    });
  }

  /* -----------------------------------------
 	 Get user balance and populate the UI
 	 ----------------------------------------- */
  const $loggedOutCallout = $('.section-login-callout');
  const updateUserBalance = () => {
    if (__APP__.showBalance!== '0') {
      api.getBalance().done(res => {
        $('.js-balance-cash').text(`${formatMoney(res.cash, res.currency)}`);
        $('.js-sports-bonus').text(`${formatMoney(res.bonusBia, res.currency)}`);
        $('.js-user-balance').text(`${formatMoney(res.balance, res.currency)}`);
        // $('.js-cash-in-hand').text(`${formatMoney(res.cashInHand, res.currency)}`);
        // $('.js-mobile-cash-in-hand').text(`${formatMoney(res.cashInHand, res.currency)}`);
        localStorage.setItem('balance', res.balance);
      }).fail(() => userLogout());
    }
  };

  if (__APP__.loggedIn) {
	  	//run once
		updateUserBalance();
		updateUserInfo();

    if (__APP__.isMobile) {
		$('.btn-user-trigger').on('click', function(event) {
			event.preventDefault();
			updateUserBalance();
			updateUserInfo();
		});
	}
	else {
		// Update balance every some seconds
		balanceInterval = setInterval(updateUserBalance, 10000);
	}


	$('.btn-refresh').on('click', function(event) {
    event.stopPropagation();
    event.preventDefault();
		updateUserBalance();
		updateUserInfo();
	});


  } else {
    $loggedOutCallout.show();
  }

  /* -----------------------------------------
 	 Transfer money between wallets - Modal
 	 ----------------------------------------- */
  const transferMoneyModal = new Vue({
    el: '#transferModal',
    data: {
      error: '',
      success: '',
      loading: false,
      mainBalance: '',
      pokerBalance: '',
      currency: '',
      transferAmount: '',
      transferTo: 'fromMainWallet',
      transferFrom: 'toMainWallet',
    },
    methods: {
      refreshBalances() {
        api.getBalance().done(res => {
          this.currency = res.currency;
          this.mainBalance = formatMoney(res.cash, res.currency);
        });
        api.walletBalance().done(res => {
          this.pokerBalance = formatMoney(res.balance, 'USD');
        })
      },
      changeFrom() {
        if ( this.transferFrom === 'fromMainWallet' ) {
          this.transferTo = 'toMainWallet';
        }
        else {
          this.transferTo = 'fromMainWallet';
        }
      },
      changeTo() {
        if ( this.transferTo === 'fromMainWallet' ) {
          this.transferFrom = 'toMainWallet';
        }
        else {
          this.transferFrom = 'fromMainWallet';
        }
      },
      transfer() {
        const {
          transferAmount,
          transferTo,
          transferFrom,
        } = this;
        this.error = '';
        this.success = '';
        this.loading = true;
        if ( this.transferTo === this.transferFrom ) {
          this.error = 'different_wallets';
          this.loading = false;
          consoleLog(this.error);
          return;
        }
        api.walletTransfer(toCents(transferAmount), transferTo)
          .done(res => {
            this.error = '';
            this.success = true;
            this.refreshBalances();
          })
          .fail(res => {
            this.success = '';
            this.error = res.responseJSON.errors[0].errorCode;
            consoleLog(this.error);
            this.loading = false;
          })
          .always(() => this.loading = false);
      },
    },
    created() {
      if (!document.getElementById('transferModal')) {
        return;
      }

      this.refreshBalances();
    },
  });


  /* -----------------------------------------
 	 Transfer money between wallets - Full page
 	 ----------------------------------------- */
  const transferMoney = new Vue({
    el: '.form-wallet-transfer',
    data: {
      error: '',
      success: '',
      loading: false,
      mainBalance: '',
      pokerBalance: '',
      currency: '',
      transferAmount: '',
      transferTo: 'fromMainWallet',
      transferFrom: 'toMainWallet',
    },
    methods: {
      refreshBalances() {
        api.getBalance().done(res => {
          this.currency = res.currency;
          this.mainBalance = formatMoney(res.cash, res.currency);
        });
        api.walletBalance().done(res => {
          this.pokerBalance = formatMoney(res.balance, 'USD');
        })
      },
      changeFrom() {
        if ( this.transferFrom === 'fromMainWallet' ) {
          this.transferTo = 'toMainWallet';
        }
        else {
          this.transferTo = 'fromMainWallet';
        }
      },
      changeTo() {
        if ( this.transferTo === 'fromMainWallet' ) {
          this.transferFrom = 'toMainWallet';
        }
        else {
          this.transferFrom = 'fromMainWallet';
        }
      },
      transfer() {
        const {
          transferAmount,
          transferTo,
          transferFrom,
        } = this;
        this.loading = true;
        this.error = '';
        this.success = '';
        if ( this.transferTo === this.transferFrom ) {
          this.error = 'different_wallets';
          this.loading = false;
          return;
        }
        api.walletTransfer(toCents(transferAmount), transferTo)
          .done(res => {
            this.error = '';
            this.success = true;
            this.refreshBalances();
          })
          .fail(res => {
            this.success = '';
            this.error = res.responseJSON.errors[0].errorCode;
            consoleLog(this.error);
            this.loading = false;
          })
          .always(() => this.loading = false);
      },
    },
    created() {
      if (!document.getElementById('wallet-transfer-form')) {
        return;
      }

      this.refreshBalances();
    },
  });

  /* -----------------------------------------
 	 Language Change
 	 ----------------------------------------- */
  $('#lang-drop').find('a').on('click', function (event) {
    const $this = $(this);
    const lang = $this.data('lang');

    if (__APP__.loggedIn) { //updateUserLanguage is for logged-in users
		api.updateUserLanguage(lang)
		  .always(() => {
			Cookies.set('_lang', lang, { expires: 365 });
			location.href = $this.attr('href')
		  });
	}
	else {
		Cookies.set('_lang', lang, { expires: 365 });
		location.href = $this.attr('href')
	}

    event.preventDefault();
  });

  /* -----------------------------------------
 	 BIA SportsBook Loading
 	 ----------------------------------------- */
  const $biaFrame = $('#bia-sports-frame');

  const createBiaFrame = (token, walletcode) => {
    const args = $.extend({}, $biaFrame.data('args'), {
      token,
      walletcode,
      intervalDelay: 2,
      reloadCallback() { //fix for issue with user logged in on several skins sharing one browser from different tabs
        window.location.reload(true);
      },
      loadCallback() {
        $biaFrame.removeClass('frame-loading');
      }
    });

    let locationHash = window.location.hash;
    let param = locationHash.split("/");

    let championshipIds = param[1] === "tree" ? param[5] : param[2] === "tree" ? param[6] : '';
     args['champids'] =  championshipIds.split(",").map((id) => {
      if (id > 0) {
        return parseInt(id);
      }
    }).filter(Boolean); // Filter out undefined values
    
    let categoryIds = (param[1] === "tree") ? param[4] : (param[2] === "tree") ? param[5] : '';
    args['catids'] = categoryIds.split(",").map((id) => {
      if (id > 0) {
        return parseInt(id);
      }
    }).filter(Boolean); // Filter out undefined values
    
    // Redirection of live page to betting
    if (param[1] === "tree") {
      window.location.href = (args['champids'] && args['champids'].length > 0) 
                            ? location.origin + "/" + __APP__.langShort + "/betting#/tree/all/0/0/" + args['champids'] + "/0/outrights" 
                            : ((args['catids'] && args['catids'].length > 0) 
                            ? location.origin + "/" + __APP__.langShort + "/betting#/tree/all/0/" + args['catids'] + "/0/0/outrights" : '');
    }
    
    args['eventid'] = param[1] === "event" ? parseInt(param[6]) : param[2] === "event" ? parseInt(param[4]) : '';
    args['sportids']= param[1] === "sport" ? parseInt(param[2]) : param[2] === "sport" ? parseInt(param[3]) : '';

    if(param[1] === "live" && param[2] === "event") {
      window.location.href = location.origin + "/" + __APP__.langShort + "/live#/live/event/" + args['sportids'] + "/" + args['eventid'];
    }

    const bia = new AltenarSportsbook('#bia-sports-frame', args);
    $('body').on("click", '.add-odds-to-slip', function(e) {
      e.preventDefault();
      bia.setParam('betslipoddids', $(this).data('selection'));
    });
  };

  if ($biaFrame.length) {
    api.getSportsBook(__APP__.loggedIn)
      .done(({ jsUrl, mobileJsUrl, tokenValue, walletCode }) => {
        // TODO: Bia's scripts (jsUrl and mobileJsUrl) are being
        // fetched but they are currently incorrect.
        // Loading them directly via e.g. jQuery.getScript fails to
        // fetch the actual scripts inside them for some reason.
        // To overcome this currently BIA scripts are loader in footer.php
        // but it should be fixed so that they are properly and
        // asynchronously loaded via the platform.
        createBiaFrame(tokenValue, walletCode);
      })
      .fail(({ responseJSON: res }) => {
        consoleLog(res);
      });
  }

  /* -----------------------------------------
   Games (Vue.js)
   ----------------------------------------- */
  const store = {
    games: []
  };

  const GamesContainer = new Vue({
    el: '#section-games',
    data: {
      store,
      visibleLimit: 18,
      activeCategoryId: 1,
      providers: [],
      activeProvider: 'all',
      orderBy: 'popularity',
      searchFilter: '',
      categories: [],
      fetchGameError: '',
      loggedIn: __APP__.loggedIn,
      providers_map: new Map(),
      currency: localStorage.currency,
    },
    computed: {
      gamesFiltered() {
        return this.store.games
          .filter(game =>
            ((this.currency && CASINO_RESTRICTIONS[this.currency]) ? !CASINO_RESTRICTIONS[this.currency].includes(game.provider.name.toUpperCase()) : game)
            && game.categories.find(cat => cat.id === this.activeCategoryId)
            && game.name.toLowerCase().includes(this.searchFilter.toLowerCase())
            && ((this.activeProvider === 'all') ? true : game.provider.id === this.activeProvider)
          )
          .map(row => ({
            ...row,
            url: __APP__.loggedIn
              ? `${location.origin}/${__APP__.langShort}/game/live/${row.provider.game_id}/${row.provider.id}`
              : row.mode === 1
                ? `${location.origin}/${__APP__.langShort}/game/demo/${row.provider.game_id}/${row.provider.id}`
                : `game/live/${row.provider.game_id}/${row.provider.id}`,
            thumbnail: `${__APP__.casinoAssetsUrl}${row.thumbnail_name}`
          }));
      },
      gamesOrdered() {
        switch (this.orderBy) {
          case 'popularity':
            return this.gamesFiltered.sort(this.sortByKey('list'));
            break;
          case 'alphabetic':
            return this.gamesFiltered.sort(this.sortByKey('name'));
            break;
          default:
            return this.gamesFiltered.sort(this.sortByKey('id', true));
        }
      },
      gamesVisible() {
        return this.gamesOrdered.slice(0, this.visibleLimit);
      },
      allowedProviders() {
        // if this.currency truthy user is logged in
        if (this.currency && CASINO_RESTRICTIONS[this.currency]) {
          return this.providers.filter(provider => !CASINO_RESTRICTIONS[this.currency].includes(provider.provider_name.toUpperCase()));
        }
        else {
          return this.providers;
        }
      }
    },
    methods: {
      increaseVisibleGames() {
        this.visibleLimit += 18;
      },
      switchCategory(id) {
        this.activeCategoryId = id;
        this.searchFilter = '';
      },
      canPlayGame(gameId) {
        const game = this.store.games.find(x => x.id === gameId);

        if (game.mode === 0 && !this.loggedIn) {
          return false;
        }

        return true;
      },
      launchGame(url) {
        if (!this.loggedIn && url.indexOf('game/live') != -1) {
          localStorage.setItem('redirectUrl', url);
          $('#modal-login').modal('show');
          return;
        }
        location.href = url;
        return;
      },
      sortByKey(key, reverse) {
        return function (a, b) {
          if (
            Number.isNaN(parseInt(a[key], 10))
            && Number.isNaN(parseInt(b[key], 10))
          ) {
            return reverse
              ? b[key].localeCompare(a[key])
              : a[key].localeCompare(b[key]);
          }

          return reverse
            ? b[key] - a[key]
            : a[key] - b[key];
        }
      },
    },
    filters: {
      uppercase(str) {
        return str.toUpperCase();
      },
      categoryIconName(url) {
        const arr = url.split('/');
        const id = arr.pop();
        arr.push(`icon-game-category-${id}.svg`);

        return arr.join('/');
      }
    },
    created() {
      if (!document.getElementById('section-games')) {
         return;
       }

      api.fetchGameCategories().done(res => {
        consoleLog(res);
        this.categories = res;
        this.activeCategoryId = this.categories[0].id;
      })
        .fail(error => {
          consoleLog(error);
        });

      const CASINO_TYPE = 1;
      api.fetchGames(__APP__.country_2).done(res => {
          api.fetchGameProviders(CASINO_TYPE).done(res => {
          // store provider ids in map
          for ( const provider of res ) {
              this.providers_map.set(provider.provider_id, true);
          }
        });
        this.store.games = res;
        // add live casino providers to providers dropdown(this.providers)
        for (const game of this.store.games) {
          if(!this.providers_map.has(game.provider.id)){
              this.providers_map.set(game.provider.id, true);
              this.providers.push({
                provider_id: game.provider.id,
                provider_name: game.provider.name
            });
          }
        }
        this.providers = localStorage.currency === 'UAH' ? filterFlexsy(this.providers) : this.providers;
        this.store.games = localStorage.currency === 'UAH' ? filterFlexsy(this.store.games) : this.store.games;
      });
    },
  });

  /* -----------------------------------------
 	 Live Casino Page
 	 ----------------------------------------- */
  const LiveCasinoContainer = new Vue({
    el: '#section-live-casino',
    data: {
      store,
      providers: [],
      activeProvider: 'all',
      loggedIn: __APP__.loggedIn,
      currency: localStorage.currency,
      searchFilter: '',
    },
    computed: {
      gamesVisible() {
        return this.store.games
        .filter(game =>
          ((this.currency && CASINO_RESTRICTIONS[this.currency]) ? !CASINO_RESTRICTIONS[this.currency].includes(game.provider.name.toUpperCase()) : game)
          && (!UNSUPPORTED_CASINO_PROVIDERS.includes(game.provider.name.toUpperCase())) 
          && ((this.activeProvider === 'all') ? true : game.provider.id === this.activeProvider)
          && (game.name.toLowerCase().includes(this.searchFilter.toLowerCase()))
        )
          .map(row => ({
          ...row,
          url: __APP__.loggedIn
            ? `${location.origin}/${__APP__.langShort}/game/casino_live/${row.provider.game_id}/${row.provider.id}`
            : '',
            thumbnail: `${__APP__.casinoAssetsUrl}${row.thumbnail_name}`
        }));

      },
      allowedProviders() {
        // if this.currency truthy user is logged in
        if (this.currency && CASINO_RESTRICTIONS[this.currency]) {
          return this.providers.filter(provider => !CASINO_RESTRICTIONS[this.currency].includes(provider.provider_name.toUpperCase()));
        }
        else {
          return this.providers;
        }
      }
    },
    methods: {
      canPlayGame(gameId) {
        const game = this.store.games.find(x => x.id === gameId);

        if (game.mode === 0 && !this.loggedIn) {
          return false;
        }

        return true;
      },
      launchGame(url) {
        if (url==="") {
          $('#modal-login').modal('show');
          return;
        }
        location.href = url;
        return;
      },
      webSocketHandler() {
        // this is different per skin
        const CASINO_ID = __APP__.pragmatic_play_dga_casino_id;
        const SERVER    = __APP__.pragmatic_play_dga_url;
        // start connection
        dga.connect(SERVER);
   
        // set event listener and add actions after connection is done
        dga.onConnect = () => {
          dga.available(CASINO_ID);
        }
   
        // set event listener
        dga.onMessage = (data) => {
          if ( data.tableKey ) {
            data.tableKey.map(tableID => {
            this.store.games.find(game => {
              // subscribe only to fetched games
              if ( game.provider_game_id == tableID ) {
                dga.subscribe(CASINO_ID, tableID);
              }
            })
            })
          }
          else {
          // update thumbnail
          this.store.games.find((game, gameIndex) => {
            if ( data.tableId == game.provider_game_id ) {
              this.updateGameThumbnail(gameIndex, data);
            }
          });
          }
        }
      },
      updateGameThumbnail(gameIndex, dgaGameData) {
        let gameData = {};
        gameData.dealer             = dgaGameData.dealer.name;
        gameData.tableOpen          = dgaGameData.tableOpen;
        gameData.minBet             = dgaGameData.tableLimits.minBet;
        gameData.maxBet             = dgaGameData.tableLimits.maxBet;
        gameData.totalSeatedPlayers = dgaGameData.totalSeatedPlayers; // int/int or int how do I handle this?
        gameData.tableImage         = dgaGameData.tableImage;
        gameData = this.gameCategoryHandler(gameData, dgaGameData);
        Vue.set(this.store.games[gameIndex], 'dgaData', {...gameData});
      },
      gameCategoryHandler(gameData, dgaGameData) {
        const POKER_TABLE_ICON   = '/assets/images/poker-table-icon.svg';
        const POKER_TABLE_ICON_2 = '/assets/images/poker-table-2.svg';
        // 5 types here
        if ( dgaGameData.tableType === 'BACCARAT' ) {
          gameData.tableStatusIcon = POKER_TABLE_ICON_2;
          gameData.gameResults     = dgaGameData.gameResult.map(res => ({
            ...res,
            icon: res.winner.charAt(0),
            class: (res.winner.charAt(0) == 'B') ? 'dga-baccarat-win-banker' : (res.winner.charAt(0) == 'P') ? 'dga-baccarat-win-player' : 'dga-baccarat-win-tie'
          })).slice(0, 7);
        }
        else if ( dgaGameData.tableType === 'ROULETTE') {
          gameData.tableStatusIcon = POKER_TABLE_ICON;
          gameData.gameResults     = dgaGameData.last20Results.map(res => ({
            ...res,
            icon: res.result,
            class: (res.color === 'red') ? 'dga-roulette2-red' : ((res.color === 'black') ? 'dga-roulette2-black' : 'dga-roulette2-green')
          })).slice(0, 7);
        }
        else if ( dgaGameData.tableType === 'BOOMORBUST') {
          gameData.tableStatusIcon = POKER_TABLE_ICON;
          gameData.gameResults     = dgaGameData.gameResult.map(res => ({
            ...res,
            icon: res.result,
            class: 'dga-boom-city-white'
          })).slice(0, 7);
        }
        else if ( dgaGameData.tableType === 'ONEBJ' ) {
          gameData.tableStatusIcon = POKER_TABLE_ICON_2;
        }
        else if ( dgaGameData.tableType === 'MEGAWHEEL' ) {
          gameData.tableStatusIcon = POKER_TABLE_ICON;
          gameData.gameResults     = dgaGameData.last20Results.map(res => ({
            ...res,
            icon: res.result,
            class: `dga-mega-wheel-results dga-mega-wheel-result-${res.result}`
          })).slice(0, 7);
        }
        else {
          gameData.tableStatusIcon = POKER_TABLE_ICON;
        }
        // rest game table types
        return gameData;
      }
    },
   created() {
      if (!document.getElementById('section-live-casino')) {
        return;
      }
      
      api.fetchGameProviders(2).done(res => {
        this.providers = res.filter(provider => 
          !UNSUPPORTED_CASINO_PROVIDERS.includes(provider.provider_name.toUpperCase())
        )
        if (localStorage.currency === 'UAH') {
          this.providers = filterFlexsy(this.providers);
        }
      });

      api.fetchGames(__APP__.country_2, 13)
       .done(res => {
         this.store.games = localStorage.currency === 'UAH' ? filterFlexsy(res) : res;
         this.webSocketHandler();
       });
    },
  });

  /* -----------------------------------------
 	 Single Game Page
 	 ----------------------------------------- */
  const SingleGame = new Vue({
    el: '.section-game',
    data: {
      store: [],
      gameId: '',
      providerId: '',
      loggedIn: __APP__.loggedIn,
      activeGameUrl: '',
      activeGameLoader: '',
      activeGameId: null,
      activeGameBg: '',
      activeGameName: '',
      activeGameRatio: '',
      fetchGameError: '',
      enabledFlash: true,
	  timeValue: '',
	  searchFilter: '',
	  storedGames: [], //used for last games
      loading: true,
      inbetCasinoProvider: __APP__.inbetCasinoProvider,
      betsolutionsCasinoProvider: __APP__.betsolutionsCasinoProviderId,
      isFullScreen: false
    },
    methods: {
      canPlayGame(gameId) {
        const game = this.store.find(x => x.provider.game_id == gameId);

        if (game.mode === 0 && !this.loggedIn) {
          return false;
        }

        return true;
      },
      launchGame(gameId, providerId) {

        // We're setting activeGameId here so that this.sizeGameFrame
        // can have a reference to the game as soon as the modal opens
        // because resizing happens on modal show
        this.activeGameId = gameId;
        this.fetchGameError = ''; // Reset errors

        // if (!__APP__.isMobile) {
        //   $(this.$refs.gameModal).modal('show');
        // }

        api.fetchGame(gameId, __APP__.country_2) //fetchGame get info from cms
          .done(result => {
            this.loading = false;
            if (result[0].tech_id === FLASH && !__APP__.isMobile) {
              modalFlash();
            }
            if ( result.errors ) {
              this.fetchGameError = result.errors[0].errorCode == 'GameNotFound' ? result.errors[0].message : `This game is not available to your country.`;
              this.activeGameBg = null;
              return;
            }
            const isGameLive = this.loggedIn;
            this.activeGameBg = __APP__.casinoAssetsUrl + result[0].background_name;
            this.activeGameName = result[0].name;
            this.activeGameRatio = result[0].ratio;

            if (!this.canPlayGame(gameId)) {
              this.fetchGameError = `Please login to play the game`;
              return;
            }
            //consoleLog('calling API');
            api.getGame(gameId, isGameLive) //getGame get info from provider/Finnplay
              .done(res => {
                //consoleLog(res);
                if (res.error) {
                  this.fetchGameError = `Request to fetch game failed. Response: ${res.error} (${res.errorCode})`;
                }
                else {
                  if (this.providerId === __APP__.betsolutionsCasinoProviderId) {
                    let url = new URL(res.url);
                    let authUrl = res.url.split('?');

                    $("#iframeContainer").after('<script>var config = {\n' +
                      '        "Token": "' + url.searchParams.get("Token") + '",\n' +
                      '        "MerchantId":' + url.searchParams.get("MerchantId") + ',\n' +
                      '        "Lang": "' + url.searchParams.get("Lang") + '",\n' +
                      '        "GameId":' + url.searchParams.get("GameId") + ',\n' +
                      '        "ProductId":' + url.searchParams.get("ProductId") + ',\n' +
                      '        "IsFreeplay":' + url.searchParams.get("IsFreeplay") + ',\n' +
                      '        "Platform": "' + url.searchParams.get("Platform") + '",\n' +
                      '        "IframeContainerId": "iframeContainer",\n' +
                      '        "IframeId": "gameIFrame",\n' +
                      '        "GameOpenType": "iframe",\n' +
                      '        "AuthUrl": "' + authUrl[0] + '",\n' +
                      '        "WindowWidth": 1280,\n' +
                      '        "ResizeWindow": true\n' +
                      '    };\n' +
                      'Charismatic.Casino.GameStarter.startGame(config)</script>');
                  }
                  if (__APP__.isMobile) {
                    if (result[0].provider.id == 42) {
                      location.href = res.url.replace('/data/interfaces/netapartner.html', '/' + __APP__.langShort + '/netapartnerGame').replace('data/interfaces/netent.html', __APP__.langShort + '/netapartnerGame');
                    }
                    else if (result[0].provider.id == __APP__.inbetCasinoProvider && res.type === 'template' && res.templateId === 'inbet') {
                      this.activeGameLoader = res.options.loader;
					  window.init_loader({
					    path: this.activeGameLoader.path,
					    game: this.activeGameLoader.game,
					    billing: this.activeGameLoader.billing,
					    token: this.activeGameLoader.token,
					    kf: this.activeGameLoader.kf,
					    currency: this.activeGameLoader.currency,
					    language: this.activeGameLoader.language,
					    home_page: this.activeGameLoader.home_page
					  });
                    }
                    else {
                      location.href = res.url;
                    }
                    return;
                  }

                  if (result[0].provider.id == 42) {
                    this.activeGameUrl = res.url.replace('/netapartnerGame', '/' + __APP__.langShort + '/netapartnerGame');
                  }
                  else if (result[0].provider.id == __APP__.inbetCasinoProvider && res.type === 'template' && res.templateId === 'inbet') {
                    this.activeGameLoader = res.options.loader;
					window.init_loader({
					  path: this.activeGameLoader.path,
					  game: this.activeGameLoader.game,
					  billing: this.activeGameLoader.billing,
					  token: this.activeGameLoader.token,
					  kf: this.activeGameLoader.kf,
					  currency: this.activeGameLoader.currency,
					  language: this.activeGameLoader.language,
					  home_page: this.activeGameLoader.home_page
					});
                  }
                  else {
                    this.activeGameUrl = res.url;
                  }
                  //this.activeGameRatio = res.ratio;
				  //ensure that we have made the necessairy call to get the ratio eitherwise this will start with the default ratio
				  if(this.activeGameRatio !== '') {
					this.sizeGameFrame(this.activeGameRatio, $('.single-game-wrapper'));
				  }
                }
              })
              .fail(error => {
                consoleLog(error);
                const errorMessage = error;
                this.fetchGameError = `Request to fetch game failed. Response: ${errorMessage}`;
              });
          })
          .fail(error => {
            consoleLog(error);
            this.fetchGameError = `Could not validate game.`;
            this.loading = false;
          });
      },
      setGameModalDimensions(width = 'auto', height = '90vh') {
        const $gameModal = $('.single-game-wrapper');
        const modalHeaderHeight = $('.single-game-header').outerHeight();
        height = height === '90vh' ? height : height + modalHeaderHeight;
        //if height is less than 475px then add the height of the footer bar
        if(height <= 475) { height = height + 40; }

        $gameModal.css({
          width,
          height,
        });
      },
      sizeGameFrame(activeGameRatio, $iframe) {
        // Need to reset game modal to its original dimensions first
        // so that the game iframe itself can take max width / height.
        // Otherwise we'd have to calculate dimensions based on viewport width
        this.setGameModalDimensions();

        // Falsey ratio value assumes a default of 4 /3
        const ratio = activeGameRatio === 1 || !activeGameRatio ? 1.3333 : activeGameRatio;
        const wrapper = $iframe.parent();
        const width = wrapper.width();
        const height = wrapper.height();
        const optimalWidth = height * ratio;
        const maxWidth = Math.min(optimalWidth, width);
        const maxHeight = maxWidth / ratio;

        $iframe.css({ width: maxWidth, height: maxHeight });
        this.setGameModalDimensions(maxWidth, maxHeight);
      },
      setGameUrl(rows) {
        return rows.map(row => ({
          ...row,
          url: __APP__.loggedIn
            ? `${location.origin}/${__APP__.langShort}/game/live/${row.provider.game_id}/${row.provider.id}`
            : row.mode === 1
              ? `${location.origin}/${__APP__.langShort}/game/demo/${row.provider.game_id}/${row.provider.id}`
              : '#',
          thumbnail: `${__APP__.casinoAssetsUrl}${row.thumbnail_name}`
        }));
      },
      isFlashEnabled() {
        var hasFlash = false;
        try {
          hasFlash = Boolean(new ActiveXObject('ShockwaveFlash.ShockwaveFlash'));
        } catch(exception) {
        hasFlash = ('undefined' != typeof navigator.mimeTypes['application/x-shockwave-flash']);
        }
        return hasFlash;
      },

      cancelFullscreen() {
        if (document.cancelFullScreen) {
          this.isFullScreen = false;
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          this.isFullScreen = false;
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          this.isFullScreen = false;
          document.webkitCancelFullScreen();
        }
        $('.game-controls-full .fa').removeClass('fa-compress').addClass('fa-expand');
        $('a.game-fullscreen').show();
      },

      // game fullscreen 
      handleFullscreen(isFullscreen=false) {
        this.isFullScreen = isFullscreen;
        if(this.isFullScreen) {
          if (document.querySelector(".single-game-main").fullscreen ) {
            document.querySelector(".single-game-main").fullscreen ();
          } else if (document.querySelector(".single-game-main").mozRequestFullScreen) {
            document.querySelector(".single-game-main").mozRequestFullScreen();
          } else if (document.querySelector(".single-game-main").webkitRequestFullScreen) {
            document.querySelector(".single-game-main").webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
          }
        }
        else {
          this.cancelFullscreen();
        }
      },

      // modal fullscreen 
      handleModalscreen() {
        if ($('body').hasClass('fullscreen')) {
          this.cancelFullscreen();
        }
        else {
          $('.game-controls-full .fa').removeClass('fa-expand').addClass('fa-compress');
          $('a.game-fullscreen').hide();
          if (document.documentElement.requestFullScreen) {
            document.documentElement.requestFullScreen();
          } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
          } else if (document.documentElement.webkitRequestFullScreen) {
            document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
          }
        }
      }
    },
    created() {
      if (!document.getElementById('section-game')) {
        return;
      }
      //check if flash is enabled
      if (!__APP__.isMobile) {
        this.enabledFlash = this.isFlashEnabled();
      }
      this.gameId = $("#game_id").val();
      this.providerId = $("#provider_id").val();
	  //get all games and store it so we can make a search
      api.fetchGames(__APP__.country_2, -1)
        .done(res => {
          this.store = this.setGameUrl(res);
          //start the game
          this.launchGame(this.gameId, this.providerId);
          /**
           * set game to the local storage so we can show it
           * in the last played games section
           */
          this.storedGames = localStorage.getItem('games');
          //check if this is a real game id to proceed
          if(this.store.some(game => { return game.provider.game_id == this.gameId })) {
            if (this.storedGames !== null) {
              let gamesArray = JSON.parse(this.storedGames);
              // remove game if already present
              const index = gamesArray.indexOf(this.gameId);
              if (index > -1) {
                if (gamesArray.length > 1) {
                  gamesArray.splice(index, 1);
                }
                else {
                  gamesArray = [];
                }
              }
              // place game
              gamesArray.unshift(this.gameId);
              //limit array to size 10
              if (gamesArray.length > 10) {
                gamesArray.splice(10, 1);
              }
              localStorage.setItem('games', JSON.stringify(gamesArray));
            }
            else {
              this.storedGames = [this.gameId];
             localStorage.setItem('games', JSON.stringify(this.storedGames));
            }
          }
          //storedGames contains only the game id.
		  //So, from all games match the stored/last games
          this.storedGames = (JSON.parse(localStorage.getItem('games'))).map(row => {
            return this.store.find(function(game) { return game.provider.game_id == row })
          });
          //remove any games that doesn't match with current gamelist.
          //in localStorage the "faulty" game will still exist but not need to do further action
          //since it will eventually dropped-of the latest games list
          this.storedGames = this.storedGames.filter(function(n){ return n != undefined });
      });

      //resize event
      $(window).on('resize', () => {
        this.sizeGameFrame(this.activeGameRatio, $('.single-game-wrapper'));

        if ($('body').hasClass('fullscreen')) {
          $('body').removeClass('fullscreen');
          this.isFullScreen = false;
          $('a.game-fullscreen').show();
          $('.game-controls-full .fa').removeClass('fa-compress').addClass('fa-expand');
        }
        else {
          $('body').addClass('fullscreen');
        }
      });
    },
    mounted() {
      if (!document.getElementById('section-game')) {
        return;
      }
	  //set time
      setInterval(() => {
        this.timeValue = new Date().toLocaleTimeString('en-GB', {hour: 'numeric', minute: 'numeric'});
      }, 1000);
    },
    computed: {
      gamesFiltered() {
        return this.store.filter(game => {
          return game.name.toUpperCase().includes(this.searchFilter.toUpperCase());
		});
    },
    showFullButtons() {
      return this.isFullScreen;
    }
	}
  });

  /* -----------------------------------------
  Account - Personal Data Management
  ----------------------------------------- */
  const PersonalDataForm = new Vue({
    el: '.form-personal-data',
    data: {
      type: '',
      body: '',
      error: '',
      success: '',
      loading: false,
    },
    methods: {
      submit() {
        this.loading = true;
        const {
          type,
          body,
        } = this;

        api.privacyRequest(type, body)
          .done((res) => {
            consoleLog(res);
            this.error = false;
            this.success = true;
          })
          .fail((error) => {
            consoleLog(error);
            this.error = true;
            this.success = false;
          })
          .always(() => this.loading = false);
      }
    },
  });

  /* -----------------------------------------
 	 Account - Update User Details
 	 ----------------------------------------- */
  const UpdateUserForm = new Vue({
    el: '.form-user-details',
    data: {
      error: '',
      success: '',
      loading: false,
    },
    methods: {
      submit() {
        this.loading = true;
        const formData = $(this.$el)
          .serializeArray()
          .reduce((acc, val) => ({
            ...acc,
            [val.name]: val.value
          }));

        api.updateUserInfo(formData)
          .done(() => {
            this.error = '';
            this.success = true;
          })
          .fail(({ responseJSON: res }) => {
            this.error = true;
            this.success = false;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            } else {
              this.errorMessage = __APP__.default_error_message;
            }
          })
          .always(() => this.loading = false);
      },
      printData(event) {
        if (event) event.preventDefault();
        let listOfSelectors;
        listOfSelectors = document.querySelectorAll("button.no-print-data, div.no-print-data, div.custom-checkbox, div.alert-danger, div.alert-success");
        for (let i = 0; i < listOfSelectors.length; ++i) {
          listOfSelectors[i].classList.add("ignore-element");
        }
        window.print();
      }
    },
    filters: {
      parseError(error) {
        return error.split('/').join(', ');
      }
    }
  });

  /* -----------------------------------------
 	 Account - Change Password
 	 ----------------------------------------- */
  const ChangePasswordForm = new Vue({
    el: '.form-change-password',
    data: {
      birthDate: '',
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      error: '',
      loading: false,
      success: false,
      showRepeatPassword: true,
      oldPasswordFieldType: 'password',
      passwordFieldType: 'password',
      repeatPasswordFieldType: 'password',
      showOldPassword: true,
      showPassword: true,
      errorMessage: '',
      validationMessage: $("#pass_validation_text").val(),
      repeatPasswordMessage: $("#repeat_pass_validation_text").val(),
      defaultErrorMessage: __APP__.default_error_message,
    },
    methods: {
      toggleOldPasswordVisibility() {
        oldPasswordswitchVisibility(this, 'oldPasswordFieldType', 'showOldPassword');
      },
      togglePasswordVisibility() {
        switchVisibility(this, 'passwordFieldType', 'showPassword');
      },
      toggleRepeatPasswordVisibility() {
        repeatPasswordSwitchVisibility(this, 'repeatPasswordFieldType', 'showRepeatPassword');
      },
      ValidateInputPassword() {
        const cleanPassword = (password) => password.replace(/\s/g, "");
    
        this.newPassword = cleanPassword(this.newPassword);
        this.newPasswordConfirm = cleanPassword(this.newPasswordConfirm);
    
        const password = this.newPassword;
        const conditions = [
            { regex: /^.{8,}$/ },
            { regex: /[A-Z]/ },
            { regex: /[a-z]/ },
            { regex: /[0-9]/ },
            { regex: /[!@#$%^&*()\-+=@'";:\|/?.`,~<>_\[\]{}]/ },
            { regex: /^[^\s]*$/ }
        ];

        return !conditions.every(condition => condition.regex.test(password));
      },
      submit: function () {
        const {
          oldPassword,
          newPassword,
          newPasswordConfirm,
        } = this;
        this.loading = true;
        this.success = false;
        this.error = '';

        if (this.ValidateInputPassword()) {
          this.error = true;
          this.loading = false;
          this.errorMessage = $("#pass_validation_text").val();
          return;
        }

        if (newPassword !== newPasswordConfirm) {
          // Artificial small delay here to blink the error
          // in case the user makes this error sequentially
          setTimeout(() => {
            this.error = true;
            this.errorMessage = $("#pass_do_not_match").val();
            this.loading = false;
          }, 200);
          return;
        }

        api.updateUserPassword(oldPassword, newPassword, newPasswordConfirm)
          .done(res => this.success = true)
          .fail(({ responseJSON: res }) => {
              this.error = true;
              this.errorMessage = res[0] ? res[0].message : res.errors[0] ? res.errors[0].message : this.defaultErrorMessage;
              setTimeout(() => {
                this.error = false;
              }, 4000);
          })
          .always(() => this.loading = false);
      }
    },
    created() {
      if (!document.getElementById('change-password')) {
        return;
      }
      popoverInfoMessage(this.validationMessage, 'format-message');
      popoverInfoMessage(this.repeatPasswordMessage, 'repeat-password-message');
    },
    mounted() {
      // Initialize datepicker
      const that = this;
      const $datepicker = $(this.$refs.datepicker);
      $datepicker.datepicker({
        view: 'years',
        onSelect(formattedDate) {
          that.birthDate = formattedDate;
        }
      });
    }
  });

  /* -----------------------------------------
 	 Account - My Bonuses
 	 ----------------------------------------- */
  Vue.use(ClientTable);

  const MyBonuses = new Vue({
    el: '.my-bonuses',
    data: {
      sportsBonus: [],
      casinoBonus: {},
      available: [],
      currentPage: 1,
      maxPages: 0,
      isFetching: false,
      columns: ['createdDate', 'bonusName', 'amount', 'bonusCategory', 'closedDate'],
      tableData: [],
      options: {
        headings: {
          'createdDate' : $("#my_bonuses_createddate").val(),
          'bonusName' : $("#my_bonuses_bonusname").val(),
          'amount' : $("#my_bonuses_amount").val(),
          'bonusCategory' : $("#my_bonuses_category").val(),
          'closedDate' : $("#my_bonuses_closeddate").val(),
      },
      texts: {
        filter : $("#history_financial_filter_results").val(),
        filterPlaceholder : $("#history_financial_search_query").val(),
      },
        orderBy: {
          column: 'createdDate',
          ascending: false,
        },
        customSorting: {
          roundId: function (ascending) {
            return function (a, b) {
              return ascending
                ? a.roundId - b.roundId
                : b.roundId - a.roundId;
            }
          }
        },
        perPage: 9999,
        perPageValues: [],
        sortIcon: {
          base: '',
          up: 'fa fa-angle-up',
          down: 'fa fa-angle-down'
        },
      },
      error: '',
      success: '',
      loading: false,
    },
    methods: {
      transformResponse(rows) {
        return rows.map(row => ({
          ...row,
          createdDate: convertDate(row.createdDate),
          closedDate: convertDate(row.closedDate),
          amount: formatMoney(row.amount, row.currency),
        }));
      },
      fetchTransactions(page = 1) {
        this.isFetching = true;
        api.getBonusHistory(page)
          .done((res, textStatus, xhr) => {
            //consoleLog(res);
            if (page === 1) {
              this.tableData = this.transformResponse(res);
            } else {
              this.tableData = this.tableData.concat(this.transformResponse(res));
            }
            this.currentPage = page;
            this.maxPages = xhr.getResponseHeader('X-Pagination-Page-Count'); //res.pageCount;
            this.isFetching = false;
          })
          .fail(({ responseJSON: res }) => {
            consoleLog('get game transactions error', res);
          });
      },
      loadMoreTransactions() {
        this.fetchTransactions(this.currentPage + 1);
      },
    },
    created() {
      if (!document.getElementById('my-bonuses')) {
        return;
      }

      // find bonuses
      //const that = this;
      api.getActiveBonus()
        .done(res => {
          if (res.amount > 0) {
            this.sportsBonus.currentAmount = formatMoney(res.amount, res.currency);
            this.sportsBonus.initialAmount = formatMoney(res.initialAmount, res.currency);
            this.sportsBonus.rolloverRemaining = formatMoney(res.rolloverRemain, res.currency);
            this.sportsBonus.rolloverPercentage = (((res.rolloverRequired - res.rolloverRemain) / res.rolloverRequired)*100).toFixed(2);
            this.sportsBonus.rolloverWidth = this.sportsBonus.rolloverPercentage;
            this.sportsBonus.valueNow = this.sportsBonus.rolloverPercentage;
          }
		  else {
            this.sportsBonus = false;
		  }
        })
        .fail(error => {
          consoleLog('error getting bonus list: ', error);
        });
      // get promo transactions
      this.fetchTransactions();
      // find available bonuses
      api.getAvailableBonuses()
        .done(res => {
          if (res.length) {
            this.available = res;
          }
        })
        .fail(error => {
          consoleLog('error getting payment methods/campaigns: ', error);
        })
    },
  });

  /* -----------------------------------------
     Register Player
     ----------------------------------------- */
  const RegisterPlayerForm = new Vue({
    el: '.form-register-player',
    data: {
      userData: [],
      language: __APP__.langShort,
      email: '',
      userName: '',
      password: '',
      confirmPassword: '',
      showPassword: true,
      showRepeatPassword: true,
      passwordFieldType: 'password',
      repeatPasswordFieldType: 'password',
      birthDate: '',
      dayBirthDate: '',
      monthBirthDate: '',
      yearBirthDate: '',
      firstName: '',
      lastName: '',
      country: __APP__.country_2,
      currency: '',
      phoneNumber: '',
      maxPhoneNumberLength: 17,
      myCountryCode: '',
      countries: [],
      city: '',
      termsChecked: false,
      emailChecked: false,
      error: '',
      errorMessage: '',
      loading: false,
      success: false,
      processing: false, //prevent double submit
      currencies: [],
      repeatPasswordMessage: $("#enter_repeat_pass_validation_text").val(),
      validationMessage: $("#pass_validation_text").val(),
    },
    computed: {
      flagClass() {
        return ( this.myCountryCode !== '' ) ?
        'flag ' + 'flag-' +
        ( (this.countries.length == 0) ? '' : this.countries.find(country => country.countryCode == this.myCountryCode).code2.toLowerCase() )
        : ''
      },
    },
    methods: {
      togglePasswordVisibility() {
        switchVisibility(this, 'passwordFieldType', 'showPassword');
      },
      toggleRepeatPasswordVisibility() {
        repeatPasswordSwitchVisibility(this, 'repeatPasswordFieldType', 'showRepeatPassword');
      },
      ValidateInputPassword() {
        const cleanPassword = (password) => password.replace(/\s/g, "");
    
        this.password = cleanPassword(this.password);
        this.confirmPassword = cleanPassword(this.confirmPassword);
    
        const password = this.password;
        const conditions = [
            { regex: /^.{8,}$/ },
            { regex: /[A-Z]/ },
            { regex: /[a-z]/ },
            { regex: /[0-9]/ },
            { regex: /[!@#$%^&*()\-+=@'";:\|/?.`,~<>_\[\]{}]/ },
            { regex: /^[^\s]*$/ }
        ];

        return !conditions.every(condition => condition.regex.test(password));
      },
      submit() {
        if (this.processing === true) {
          return;
        }
        this.processing = true;
        this.loading = true;
        this.error = false;
        this.success = false;
        const formData = {
          "username": this.userName,
          "password": this.password,
          "email": this.email,
          "firstname": this.firstName,
          "lastname": this.lastName,
          "birthDate": this.yearBirthDate + '-' + ("0"+this.monthBirthDate).slice(-"00".length) + '-' +("0"+this.dayBirthDate).slice(-"00".length),
          "currency": this.currency,
          "country": this.country,
          "city": this.city,
          "phoneNumber": this.myCountryCode + this.phoneNumber,
          "termsChecked": this.termsChecked,
          "emailChecked": this.emailChecked,
          "language": this.language,
          "activatePlayer": true,
          "activateUrl":  location.origin + '/' + __APP__.langShort + '/activate',
          "ip": __APP__.IP,
          "country_code": __APP__.country_2,
          "platform": __APP__.device_string,
          "device": navigator.userAgent,
        };

        if (this.ValidateInputPassword()) {
          this.processing = false;
          this.error = true;
          this.loading = false;
          this.errorMessage = $("#pass_validation_text").val();
          return;
        }

        if (this.userName == this.password) {
          this.error = true;
          this.loading = false;
          this.success = false;
          this.processing = false;
          this.errorMessage = 'differentUsernamePassword';
          return;
        }

        if (this.password != this.confirmPassword) {
          this.error = true;
          this.success = false;
          this.processing = false;
          this.errorMessage =  $("#no_matching_passwords").val();
          this.loading = false;
          return;
        }
        
		if(Cookies.get('affiliateId') != '') {
		  formData.affiliateId = Cookies.get('affiliateId');
		}
		if(Cookies.get('affiliateOperator') != '') {
		  formData.affiliateOperator = Cookies.get('affiliateOperator');
		}
		if(Cookies.get('affiliateBanner') != '') {
		  formData.affiliateBanner = Cookies.get('affiliateBanner');
		}
		if(Cookies.get('affiliateCampaign') != '') {
		  formData.affiliateCampaign = Cookies.get('affiliateCampaign');
    }
       api.registerPlayer(formData)
          .done(res => {
            consoleLog(res);
            if (res.errors) {
              consoleLog('Register Player Error ', res.error);
              this.error = true;
              this.errorMessage = res.errors[0].message;
            } else {
              this.error = false;
                this.loading = true;
                api.login(this.userName, this.password)
                  .done(res => {
                    if (res.error) {
                      consoleLog('Login error ', res.error);
                      this.error = 'Could not automatically login';
                      return;
                    }
                    localStorage.setItem('jwtToken', res.jwt);
                    location.replace(`${location.origin}/${__APP__.langShort}/login/${res.language}?jwt=${res.jwt}&role=${res.role}`);
                  });
                this.success = true;
            }
          })
          .fail(({ responseJSON: res }) => {
              this.error = true;
              if (res.errors) {
                this.errorMessage = res.errors[0].message;
              } else {
                this.errorMessage = __APP__.default_error_message;
              }
          })
          .always(() => {
            this.loading = false;
            this.processing = false;
		  });
      },
      getCurrencies() {
        api.fetchCurrencies()
        .done(res => {
          this.currencies = res;
          if (res.length == []) {
            this.error = true;
            this.errorMessage =  $("#no-currency").val();
          }
          else if (res.length > 1) {
            this.currencies.unshift({"id": '', "currency_code": $("#select-currency").val(), "list": ''});
            this.currency = res[0].currency_code;
          }
          else {
            $('#currency-select').prop('disabled', true);
            this.currency = res[0].currency_code;
          }
        })
        .fail(({ responseJSON: res }) => {
          this.error = true;
          this.errorMessage = __APP__.default_error_message;
        })
      },
    },
    filters: {
      parseError(error) {
        return error.split('/').join(', ');
      }
    },
    created() {
      if (!document.getElementById('form-register-player')) {
        return;
      }
      popoverInfoMessage(this.validationMessage, 'format-message');
      popoverInfoMessage(this.repeatPasswordMessage, 'repeat-password-message');
      this.getCurrencies();
      
      api.fetchCountries().done(res => {
        this.countries = res;
        let country = this.countries.find(country => {
          return country.code2 === __APP__.country_2;
        });
        if (country !== undefined ) {
          this.myCountryCode = country.countryCode;
        }
      });
    },
  });

  /* -----------------------------------------
 	 Activate Player
 	 ----------------------------------------- */
  const ActivatePlayerForm = new Vue({
    el: '.form-activate-player',
    data: {
      error: '',
      loading: false,
      success: false,
    },
    methods: {
    },
    created() {
    },
    mounted() {
      if (!document.getElementById('form-activate-player')) {
        return;
      }

      const token = $('#activationCode').val();
      api.activatePlayer(token)
        .done(res => {
          if ( res.errors ) {
            consoleLog('done but with errors ', res.errors[0].message);
            this.error = res.errors[0].message;
          }
          else {
            this.success = true;
          }
        })
        .fail(({ responseJSON: res }) => {
          consoleLog('call failed');
          if (res.errors) {
            this.error = res.errors[0].message;
          } else {
            this.error = true;
          }
        });
    }
  });

  /* -----------------------------------------
 	 KYC Verification
 	 ----------------------------------------- */
  const KycVerificationForm = new Vue({
    el: '.form-kyc-verification',
    data: {
      notVerified: false,
      pending: false,
      verified: false,
    },
    methods: {
    },
    created() {
    },
    mounted() {
      if (!document.getElementById('form-kyc-verification')) {
        return;
      }

      api.getKYCStatus()
        .done(res => {
          if ( res.status === 'NOT VERIFIED' ) {
            this.notVerified = true;
          }
          else if ( res.errors ) {
            this.notVerified = true;
          }
          else if ( res.status === 'PENDING' ) {
            this.pending = true;
          }
          else if ( res.status === 'VERIFIED' ) {
            this.verified = true;
          }
        })
        .fail(({ responseJSON: res }) => {
          if (res.errors) {
            this.notVerified = true;
          }
        });
    }
  });

  /* -----------------------------------------
 	 Forgot Password - step 1
 	 ----------------------------------------- */
  const ForgotPasswordForm = new Vue({
    el: '.form-forgot-password',
    data: {
      birthDate: '',
      email: '',
      username: '',
      error: '',
      loading: false,
      success: false,
    },
    methods: {
      submit: function () {
        this.loading = true;
        this.error = '';

        const {
          email,
          username,
          birthDate,
        } = this;
        const activateUrl = location.origin + '/' + __APP__.langShort + '/reset-password/';
        api.forgotStep1(username, email, birthDate, activateUrl)
          .done(res => {
            //consoleLog(res);
            if (res.error) {
              consoleLog('Forgot Password error ', res.error);
              this.error = res.errors[0].message;
            } else {
              this.success = true;
            }
          })
          .fail(({ responseJSON: res }) => {
            if (res.errors) {
              consoleLog('failed ', res.error);
              this.error = res.errors[0].message;
            } else {
              this.error = true;
            }
          })
          .always(() => this.loading = false);
      }
    },
    created() {
      //consoleLog(this.$route.query);
    },
    mounted() {
      // Initialize datepicker
      const that = this;
      const $datepicker = $('.datepicker-birthday');
      $datepicker.datepicker({
        view: 'years',
        onSelect(formattedDate) {
          that.birthDate = formattedDate;
        }
      });
    }
  });

  /* -----------------------------------------
 	 Forgot Password - step 2 & 3 (reset)
 	 ----------------------------------------- */
  const ResetPasswordForm = new Vue({
    el: '.form-reset-password',
    data: {
      password: '',
      confirmPassword: '',
      error: '',
      loading: false,
      success: false,
      tokenCorrect: false,
      showRepeatPassword: true,
      passwordFieldType: 'password',
      repeatPasswordFieldType: 'password',
      showPassword: true,
      errorMessage: '',
      validationMessage: $("#pass_validation_text").val(),
      repeatPasswordMessage: $("#repeat_pass_validation_text").val(),
      defaultErrorMessage: __APP__.default_error_message,
      showInfos: true
    },
    methods: {
      togglePasswordVisibility() {
        switchVisibility(this, 'passwordFieldType', 'showPassword');
      },
      toggleRepeatPasswordVisibility() {
        repeatPasswordSwitchVisibility(this, 'repeatPasswordFieldType', 'showRepeatPassword');
      },
      ValidateInputPassword() {
        const cleanPassword = (password) => password.replace(/\s/g, "");
    
        this.password = cleanPassword(this.password);
        this.confirmPassword = cleanPassword(this.confirmPassword);
    
        const password = this.password;
        const conditions = [
            { regex: /^.{8,}$/ },
            { regex: /[A-Z]/ },
            { regex: /[a-z]/ },
            { regex: /[0-9]/ },
            { regex: /[!@#$%^&*()\-+=@'";:\|/?.`,~<>_\[\]{}]/ },
            { regex: /^[^\s]*$/ }
        ];
        return !conditions.every(condition => condition.regex.test(password));
      },
      submit: function () {
        const {
          password,
          confirmPassword,
        } = this;
        this.loading = true;
        this.success = false;
        this.error = '';

        if (this.ValidateInputPassword()) {
          this.loading = false;
          this.error = $("#pass_validation_text").val();
          return;
        }

        if (password !== confirmPassword) {
          // Artificial small delay here to blink the error
          // in case the user makes this error sequentially
          setTimeout(() => this.error = 'passwords_dont_match', 200);
          this.loading = false;
          setTimeout(() => {
            this.error = $("#pass_do_not_match").val();
            this.loading = false;
          }, 200);
          return;
        }

        api.forgotStep3(password, confirmPassword)
          .done(res => {
            //consoleLog(res);
            if (res.error) {
              consoleLog('Reset Password error ', res.error);
              this.error = res.errors[0].message;
            } else {
              this.success = true;
              location.replace(`${location.origin}/${__APP__.langShort}/login/${res.language || __APP__.langShort}?role=${res.role}`);
            }
          })
          .fail(({ responseJSON: res }) => {
            if (res.errors) {
              this.error = res.errors[0].message;
            } else {
              this.error = true;
            }
          })
          .always(() => this.loading = false);
      }
    },
    created() {
      if (!document.getElementById('form-reset-password')) {
        return;
      }
      if (this.showInfos) {
        popoverInfoMessage(this.validationMessage, 'format-message');
        popoverInfoMessage(this.repeatPasswordMessage, 'reset-repeat-password-message');
      }
    },
    mounted() {
      if (!document.getElementById('form-reset-password')) {
        return;
      }

      const token = $('#activationCode').val();
      //consoleLog(token);
      if (token){
        api.forgotStep2(token)
        .done(res => {
          if ( res.errors ) {
            consoleLog('done but with errors ', res.errors[0].message);
            this.error = res.errors[0].message;
          }
          else {
            this.tokenCorrect = true;
            localStorage.setItem('jwtToken', res.jwt);
          }
        })
        .fail(({ responseJSON: res }) => {
          consoleLog('call failed');
          if (res.errors) {
            this.error = res.errors[0].message;
          } else {
            this.error = true;
          }
        });
      }
    }
  });

  /* -----------------------------------------
  Deposit - Methods
  ----------------------------------------- */
  const DepositMethods = new Vue({
    el: '.form-deposit-methods',
    data: {
      allowDeposits: localStorage.userSource == 'online' && localStorage.role == ROLE_USER ? true : false,
      allowCoinspaid: false,
      service: "COINSPAID",
      allowPraxis: localStorage.userSource == 'online' && localStorage.role == ROLE_USER && PRAXIS_CURRENCIES.includes(localStorage.currency) ? true : false,
    },
    created() {
      if (!document.getElementById('form-deposit-methods')) {
        return;
      }
      api.coinspaidSupport(this.service)
      .done(res => {
          this.allowCoinspaid = res;
      })
    },
  });

  /* -----------------------------------------
 	 Account - Deposit - Coinspaid
 	 ----------------------------------------- */
  Vue.use(VueperSlides, VueperSlide);

  const DepositFormCoinspaid = new Vue({
    el: '#form-deposit-coinspaid',
    components: {
      'vueper-slide': VueperSlide,
      'vueper-slides': VueperSlides,
    },
    data: {
      allowDeposit: false,
      allowInvoiceRequest: false,
      amountInCrypto: '',
      amountInCryptoSpinner: false,
      cryptoCurrency: null,
      cryptoFilter: '',
      description: '',
      email: '',
      error: false,
      extra: {},
      fiatAmount: '',
      fiatAmountSpinner: false,
      fiatCurrency: '',
      maxFiatAmount: '',
      method: 'INIT',
      minFiatAmount: '',
      pageLoading: true,
      provider: 'COINSPAID',
      redirectMessage: false,
      submitSpinner: false,
      supportedCryptos: [],
      timeoutId: null,
      title: '',
      type: 'crypto',
      userId: ''
    },
    methods: {
      getSupportedCryptos(){
        api.getSupportedCryptoList(this.provider, this.userId, this.fiatCurrency, this.type).done(res => {
            if ( Object.keys(res).length > 0 ) {
            this.supportedCryptos = Object.entries(res).map(([id, crypto]) => {
              return {
                'image' : `/assets/images/crypto-${crypto}.svg`,
                'content': crypto,
              }
            })
          }
          else {
            this.error = true;
          }
      }).fail((error) => {
        this.error = true;
      }).always(() => {
          this.pageLoading = false;
      });
      },
      selectCrypto(selectedCrypto) {
        if ( this.cryptoCurrency === selectedCrypto ) {
          return;
        }
        this.fiatAmountSpinner = true;
        this.type = "DEPOSIT";
        this.cryptoCurrency = selectedCrypto;
        this.fiatAmount = '';
        this.amountInCrypto = '';
        api.getFiatCurrencyLimits(this.fiatCurrency, this.cryptoCurrency, this.provider, this.type).done(res => {
          if (res.status = true) {
            this.minFiatAmount = fromCents(res.limits.minAmount);
            this.maxFiatAmount = fromCents(res.limits.maxAmount);
          }
        }).fail((error) => {
          this.error = true;
        }).always(() => {
          this.fiatAmountSpinner = false;
        });
      },
      submit() {
        this.allowInvoiceRequest = false;
        this.redirectMessage = true;
        const submitData = {
          amount: toCents(this.fiatAmount),
          provider: this.provider,
          method: this.method,
          successUrl: `${location.origin}/${__APP__.langShort}/deposit-success`,
          failureUrl: `${location.origin}/${__APP__.langShort}/deposit-failed`,
          extra: {
            cryptoCurrency: this.cryptoCurrency,
            title: this.title,
            description: this.description,
            email : this.email
          }
        };
        api.depositInit(submitData.amount, submitData.provider, submitData.method, null, null, submitData.successUrl, submitData.failureUrl, submitData.extra).done(res => {
          if (res.method == 'REDIRECT') {
            location.replace(res.url);
          }
          else {
            this.error = true;
          }
        }).fail((error) => {
          this.error = true;
        });
      }
    },
    computed: {
      cryptosFiltered() {
        return this.cryptoFilter.length > 2 ?
              this.supportedCryptos.filter(crypto => crypto.content.includes(this.cryptoFilter.toUpperCase())) :
              this.supportedCryptos
      }
    },
    watch: {
      fiatAmount(newValue, oldValue) {
        this.fiatAmount = validateInteger(newValue) ? newValue : oldValue;
        this.allowInvoiceRequest = false;
        clearTimeout(this.timeoutId);
        if ( parseInt(this.fiatAmount) >= parseInt(this.minFiatAmount) && parseInt(this.fiatAmount) <= parseInt(this.maxFiatAmount) ) {
          this.amountInCryptoSpinner = true;
          this.timeoutId = setTimeout(() => {
            api.getCryptoExchangeAmount(toCents(this.fiatAmount), this.fiatCurrency, this.cryptoCurrency, this.provider).done(res => {
              if (res.status) {
                this.amountInCrypto = `${res.exchange.exchangedAmount} ${this.cryptoCurrency}`
                this.allowInvoiceRequest = true;
              }
            }).fail((error) => {
              this.allowInvoiceRequest = false;
            }).always(() => {
              this.amountInCryptoSpinner = false;
            });
          }, 500);
        }
        else {
          this.amountInCrypto = null;
        }
      }
    },
    created() {
    if (!document.getElementById('form-deposit-coinspaid')) {
      return;
    }
    this.allowDeposit = localStorage.userSource == 'online' && localStorage.role == ROLE_USER ? true : false;
    this.title = document.getElementById('title').value;
    this.description = document.getElementById('description').value;

    api.getPlayer().done(res => {
        this.email = res.email;
        this.userId = res.user_id;
        this.fiatCurrency = res.currency;
        this.getSupportedCryptos();
      });
    },
  });

  /* -----------------------------------------
 	 Account - Deposit
 	 ----------------------------------------- */
  const DepositForm = new Vue({
    el: '.form-deposit',
    data: {
      amount: '',
      kyc_status: '',
      isKYCVerified: false,
      provider: 'APCO',
      methods: [],
      error: '',
      loading: false,
      success: false,
      activeMethod: '',
      bonuses: '',
      bonusId: '',
      bonusCategory: 'BIA',
      allowDeposit: true,
      min: '',
      minAmounts: {
        'EUR': MINIMUM_DEPOSIT_AMOUNT,
        'USD' : MINIMUM_DEPOSIT_AMOUNT,
        'default': MINIMUM_DEFAULT_AMOUNT,
      },
    },
    methods: {
      submit: function () {
        const {
          amount,
          activeMethod,
          bonusId,
        } = this;
        this.loading = true;
        this.success = false;
        this.error = '';

        api.depositInit(
          toCents(amount),
          this.provider,
          this.activeMethod,
          (this.bonusId != 0 ? this.bonusId : null),
          (this.bonusId != 0 ? this.bonusCategory : null),
          `${location.origin}/${__APP__.langShort}/deposit-success`,
          `${location.origin}/${__APP__.langShort}/deposit-failed`
        )
          .done(res => {
            if (res.method == 'REDIRECT') {
              location.replace(res.url);
            }
            else if (res.method == 'POST') {
              /*$("<form action='"+res.url+"' method='POST'><input type='hidden' name='params' id='params' value='"+res.params.xml+"'></form>").appendTo('body').submit();*/
              $('<form action="'+res.url+'" method="POST"><input type="hidden" name="params" id="params" value="'+encodeURIComponent(res.params.xml)+'"></form>').appendTo('body').submit();
            }
            else {
              this.error = true;
              this.errorMessage = __APP__.default_error_message;
            }
            return;
          })
          .fail(({ responseJSON: res }) => {
            this.error = true;
            if (res) {
              this.errorMessage = res.errors[0].message;
            } else {
              this.errorMessage = __APP__.default_error_message;
            }
          })
          .always(() => this.loading = false);

      }
    },
    created() {
      if (!document.getElementById('form-deposit')) {
        return;
      }
      this.allowDeposit = localStorage.userSource == 'online' && localStorage.role == ROLE_USER ? true : false;
      api.getAvailableBonuses(this.bonusCategory)
        .done(res => {
          this.bonuses = res;
          if(res == '') { this.bonusId = 0; }
        });
      api.getDepositMethods(this.provider)
        .done(res => {
          this.methods = res;
          this.activeMethod = res[0];
        });
        api.getPlayer()
        .done(res => {
          this.min = (this.minAmounts[res.currency]) ? MINIMUM_DEPOSIT_AMOUNT : this.minAmounts['default'];
        })
    }
  });

     /* -----------------------------------------
 	 Account - Deposit Praxis
 	 ----------------------------------------- */
    const DepositPraxisForm = new Vue({
      el: '.form-deposit-praxis',
      data: {
        amount: '',
        provider: 'PRAXIS',
        error: '',
        loading: false,
        success: false,
        bonuses: '',
        bonusId: '',
        bonusCategory: null,
        min: '',
        max: '',
        allowDeposit: false,
        currency: '',
        extra: {},
        activeMethod: 'payment'
      },
      methods: {
        submit: function () {
          const {
            amount,
            bonusId,
          } = this;
          this.loading = true;
          this.success = false;
          this.error = '';
  
          api.depositInit(
        toCents(amount),
        this.provider,
        this.activeMethod,
        (this.bonusId != 0 ? this.bonusId : null),
        (this.bonusId != 0 ? this.bonusCategory : null),
        `${location.origin}/${__APP__.langShort}/deposit-success`,
        `${location.origin}/${__APP__.langShort}/deposit-failed`,
        this.extra
        )
          .done(res => {
             if (res.method == 'REDIRECT') {
                location.replace(res.url);
               }
                else if (res.method == 'POST') {
                 $('<form action="'+res.url+'" method="POST"><input type="hidden" name="params" id="params" value="'+encodeURIComponent(res.params.xml)+'"></form>').appendTo('body').submit();
              }
            else {
                this.error = true;
                this.errorMessage = __APP__.default_error_message;
              }
               return;
  
             })
            .fail(({ responseJSON: res }) => {
                this.error = true;
                if (res) {
                  this.errorMessage = res.errors[0].message;
                } else {
                  this.errorMessage = __APP__.default_error_message;
                }
            })
            .always(() => this.loading = false);
        }
      },
    created() {
          if (!document.getElementById('form-deposit-praxis')) {
            return;
          }

          api.getPlayer()
          .done(res => {
            this.currency = res.currency;
            switch(this.currency){
              case 'EUR':
              case 'USD':
              case 'TND':
                this.min = MINIMUM_DEPOSIT_AMOUNT;
                this.max = MAXIMUM_DEPOSIT_AMOUNT;
                break;
             
              default:
                this.min = MINIMUM_DEFAULT_AMOUNT;
                this.max = MAXIMUM_DEPOSIT_AMOUNT;
            }
            this.allowDeposit = localStorage.userSource == 'online' && localStorage.role == ROLE_USER && PRAXIS_CURRENCIES.includes(res.currency) ? true : false;

          });
        api.getAvailableBonuses(this.bonusCategory)
          .done(res => {
            this.bonuses = res;
            if(res == '') { this.bonusId = 0; }
          });
          /*
          * Set minimum deposit amount depending on currency;
          * */
      }
    });

  /* -----------------------------------------
 	 Account - GTBANK
 	 ----------------------------------------- */
  const GtBankDeposit = new Vue({
    el: '.gtbank-deposit',
    data: {
      customerId: '',
      allowDeposit: true,
    },
    methods: {
    },
    created() {
      if (!document.getElementById('gtbank-deposit')) {
        return;
      }
      this.allowDeposit = localStorage.userSource == 'online' && localStorage.role == ROLE_USER ? true : false;
      api.getPlayer().
      done(res => {
        //consoleLog(res);
        this.customerId = res.user_id;
      })
        .fail(({ responseJSON: error }) => {
          consoleLog(error);
        });
    },
  });

  /* -----------------------------------------
 	 Account - Deposit Interswitch Result
 	 ----------------------------------------- */
  const InterswitchDepositResult = new Vue({
    el: '.interswitch-result',
    data: {
      txnref: '',
      provider: 'INTERSWITCH',
      activeMethod: '',
      methods: '',
      error: '',
      errorCode: 0,
      errorMessage: '',
      loading: false,
      success: false,
    },
    methods: {
    },
    created() {
      if (!document.getElementById('interswitch-result')) {
        return;
      }

      this.txnref = $('#txnref').val();
    },
    mounted() {
      if (!document.getElementById('interswitch-result')) {
        return;
      }

      if (this.txnref === '') {
        this.error = true;
        this.errorCode = 333;
      } else {
        this.loading = true;
        api.getDepositMethods(this.provider)
          .done(res => {
            this.methods = res;
            this.activeMethod = res[0];

            api.depositNotify(this.provider, this.activeMethod, {"txn_ref": this.txnref})
              .done(res => {
                consoleLog('res: ' + JSON.stringify(res));
                if (res.success) {
                  this.error = false;
                  this.success = true;
                } else {
                  this.error = true;
                  this.success = false;
                  this.errorCode = res.errorCode;
                  this.errorMessage = res.message;
                }
              })
              .fail(({responseJSON: error}) => {
                this.error = true;
                if (error.errors) {
                  this.errorMessage = error.errors[0].message;
                  this.errorCode = error.errors[0].errorCode;
                  consoleLog(error.errors[0].message);
                } else {
                  this.errorMessage = __APP__.default_error_message;
                  consoleLog(JSON.stringify(error));
                }
                consoleLog(this.errorMessage);
              })
              .always(() => this.loading = false);
          });
      }
    }
  });

  /* -----------------------------------------
 	 Account - Deposit Interswitch
 	 ----------------------------------------- */
  const InterswitchDepositForm = new Vue({
    el: '.form-interswitch-deposit',
    data: {
      amount: '',
      provider: 'INTERSWITCH',
      methods: '',
      error: '',
      loading: false,
      success: false,
      activeMethod: '',
      bonuses: '',
      bonusId: '',
      bonusCategory: 'BIA',
      allowDeposit: true,
    },
    methods: {
      submit: function () {
        const {
          amount,
          bonusId,
        } = this;
        this.loading = true;
        this.success = false;
        this.error = '';
        refreshToken();

        api.depositInit(
          toCents(amount),
          this.provider,
          this.activeMethod,
          (this.bonusId != 0 ? this.bonusId : null),
          (this.bonusId != 0 ? this.bonusCategory : null),
          `${location.origin}/${__APP__.langShort}/deposit-result-interswitch`,
          `${location.origin}/${__APP__.langShort}/deposit-result-interswitch`
          )
          .done(res => {
            consoleLog(res);
            document.open();
            document.write(res.post);
            document.close();
            return;
            /*
                        if (res.method == 'REDIRECT') {
                          location.replace(res.url);
                        }
                        else if (res.method == 'POST') {
                          /!*$("<form action='"+res.url+"' method='POST'><input type='hidden' name='params' id='params' value='"+res.params.xml+"'></form>").appendTo('body').submit();*!/
                          $('<form action="'+res.url+'" method="POST"><input type="hidden" name="params" id="params" value="'+encodeURIComponent(res.params.xml)+'"></form>').appendTo('body').submit();
                        }
                        else {
                          this.error = true;
                          this.errorMessage = __APP__.default_error_message;
                        }
                        return;
            */
          })
          .fail(({ responseJSON: res }) => {
            this.error = true;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            } else {
              this.errorMessage = __APP__.default_error_message;
            }
          })
          .always(() => this.loading = false);

      }
    },
    created() {
      if (!document.getElementById('form-interswitch-deposit')) {
        return;
      }
      this.allowDeposit = localStorage.userSource == 'online' && localStorage.role == ROLE_USER ? true : false;
      api.getAvailableBonuses(this.bonusCategory)
        .done(res => {
          this.bonuses = res;
          this.bonusId = (res == '' ? 0 : res[0].id);
        });
      api.getDepositMethods(this.provider)
        .done(res => {
          this.methods = res;
          this.activeMethod = res[0];
        });
    }
  });

  /* -----------------------------------------
    Withdraw - Methods
  ----------------------------------------- */
  const WithdrawMethods = new Vue({
    el: '.form-withdraw-methods',
    data: {
      allowWithdrawals: localStorage.userSource == 'online' && localStorage.role == ROLE_USER ? true : false,
      allowCoinspaid: false,
      service: "COINSPAID",
      allowPraxis: localStorage.userSource == 'online' && localStorage.role == ROLE_USER && PRAXIS_CURRENCIES.includes(localStorage.currency) ? true : false,
    },
    created() {
      if (!document.getElementById('form-withdraw-methods')) {
        return;
      }
      api.coinspaidSupport(this.service).done(res => {
        this.allowCoinspaid = res;
    });
    },
  });

  /* -----------------------------------------
    Account - Withdraw - Coinspaid
    ----------------------------------------- */
  Vue.use(VueperSlides, VueperSlide);

  const WithdrawFormCoinspaid = new Vue({
    el: '#form-withdraw-coinspaid',
    components: {
      'vueper-slide': VueperSlide,
      'vueper-slides': VueperSlides,
    },
    data: {
      allowWithdraw: false,
      amountInCrypto: '',
      amountInCryptoSpinner: false,
      cryptoAddress: '',
      cryptoCurrency: null,
      cryptoTag: '',
      cryptoFilter: '',
      description: '',
      disabledInputs: true,
      email: '',
      error: false,
      extra: {},
      fiatAmount: '',
      fiatAmountSpinner: false,
      fiatCurrency: '',
      insufficientFunds: false,
      maxFiatAmount: '',
      method: 'INIT',
      minFiatAmount: '',
      pageLoading: true,
      provider: 'COINSPAID',
      successMessage: false,
      submitSpinner: false,
      supportedCryptos: [],
      timeoutId: null,
      title: '',
      type: 'crypto',
      userId: '',
      calculatedCryptoAmount: '',
      activeBonus: 0,
      bonusCategory: SERVICE_BIA_TEXT,
      maxCryptoTag: false
    },
    methods: {
      setActiveBonusStatus() {
        api.getActiveBonus()
          .done(res => {
            if (res.bonusCategory !== null) {
              this.activeBonus = 1;
            }
          })
          .fail(({ responseJSON: res }) => {
            if (res.errors) {
              consoleLog(res.errors);
            }
          });
      },
      getSupportedCryptos(){
        api.getSupportedCryptoList(this.provider, this.userId, this.fiatCurrency, this.type).done(res => {
            if ( Object.keys(res).length > 0 ) {
            this.supportedCryptos = Object.entries(res).map(([id, crypto]) => {
              return {
                'image' : `/assets/images/crypto-${crypto}.svg`,
                'content': crypto,
              }
            })
          }
          else {
            this.error = true;
          }
      }).fail((error) => {
        this.error = true;
      }).always(() => {
          this.pageLoading = false;
      });
      },
      selectCrypto(selectedCrypto) {
        if ( this.cryptoCurrency === selectedCrypto ) {
          return;
        }
        this.fiatAmountSpinner = true;
        this.type = "PAYOUT";
        this.cryptoCurrency = selectedCrypto;
        this.fiatAmount = '';
        this.amountInCrypto = '';
        this.disabledInputs = true;
        this.cryptoAddress = '';
        this.cryptoTag = '';
        this.successMessage = false;
        api.getFiatCurrencyLimits(this.fiatCurrency, this.cryptoCurrency, this.provider, this.type).done(res => {
          if (res.status = true) {
            this.minFiatAmount = fromCents(res.limits.minAmount);
            this.maxFiatAmount = fromCents(res.limits.maxAmount);
          }
        }).fail((error) => {
          this.error = true;
        }).always(() => {
          this.fiatAmountSpinner = false;
        });
      },
      submit() {
        const submitData = {
          amount: toCents(this.fiatAmount),
          accountNumber: this.cryptoAddress,
          provider: this.provider,
          activeBonus: this.activeBonus,
          extra: {
            convertTo: this.cryptoCurrency,
            calculatedCryptoAmount: this.amountInCrypto
          }
        };
        if (this.cryptoCurrency === 'XRP' || this.cryptoCurrency === 'BNB') {
          submitData.extra.tag = this.cryptoTag;
        }
        api.withdrawalInit(submitData.amount, null, submitData.accountNumber, null, null, submitData.activeBonus, submitData.extra, submitData.provider)
          .done(res => {
            this.successMessage = true;
            this.cryptoCurrency = null;
            this.fiatAmount = null;
            this.minFiatAmount = '';
            this.maxFiatAmount = '';
            this.amountInCrypto = null;
            this.cryptoAddress = null;
            this.cryptoTag = null;
          })
        .fail((error) => {
            this.error = true;
        });
      }
    },
    computed: {
      cryptosFiltered() {
        return this.cryptoFilter.length > 2 ?
              this.supportedCryptos.filter(crypto => crypto.content.includes(this.cryptoFilter.toUpperCase())) :
              this.supportedCryptos
      },
      allowSubmit() {
        if (this.cryptoCurrency === 'XRP' || this.cryptoCurrency === 'BNB') {
          if ( this.cryptoAddress.length < 20 || this.cryptoTag.length < 1 || this.cryptoTag > MAX_COINSPAID_TAG_VALUE || (toCents(this.fiatAmount) > localStorage.getItem('balance'))) {
            return false;
          }
          else {
            return true;
          }
        }
        else {
          if ( this.cryptoAddress.length < 20 || (toCents(this.fiatAmount) > localStorage.getItem('balance'))) {
            return false;
          }
          else {
            return true;
          }
        } 
      }
    },
    watch: {
      cryptoTag(newValue, oldValue) {
      this.cryptoTag = validateInteger(newValue) ? newValue : oldValue;   
      this.maxCryptoTag = this.cryptoTag > MAX_COINSPAID_TAG_VALUE ? true : false;
    },
      fiatAmount(newValue, oldValue) {
        this.fiatAmount = validateInteger(newValue) ? newValue : oldValue;
        this.disabledInputs = true;
        if ( toCents(this.fiatAmount) > localStorage.getItem('balance') ) {
          this.insufficientFunds = true;
          this.amountInCrypto = null;
          return;
        }
        else {
          this.insufficientFunds = false;
        }
        clearTimeout(this.timeoutId);
        if ( parseInt(this.fiatAmount) >= parseInt(this.minFiatAmount) && parseInt(this.fiatAmount) <= parseInt(this.maxFiatAmount) ) {
            this.amountInCryptoSpinner = true;
            this.timeoutId = setTimeout(() => {
            api.getCryptoExchangeAmount(toCents(this.fiatAmount), this.fiatCurrency, this.cryptoCurrency, this.provider).done(res => {
              if (res.status) {
                this.amountInCrypto = `${res.exchange.exchangedAmount} ${this.cryptoCurrency}`
                this.disabledInputs = false;
              }
            }).fail((error) => {
              this.error = true;
            }).always(() => {
              this.amountInCryptoSpinner = false;
            });
          }, 500);
        }
        else {
          this.amountInCrypto = null;
          this.amountInCryptoSpinner = false;
        }
      }
    },
    created() {
    if (!document.getElementById('form-withdraw-coinspaid')) {
      return;
    }
    this.allowWithdraw = localStorage.userSource == 'online' && localStorage.role == ROLE_USER ? true : false;
    this.title = document.getElementById('title').value;
    this.description = document.getElementById('description').value;

    api.getPlayer().done(res => {
        this.email = res.email;
        this.userId = res.user_id;
        this.fiatCurrency = res.currency;
        this.getSupportedCryptos();
      });
    this.setActiveBonusStatus();
    },
  });

  /* -----------------------------------------
     Account - Bank Withdraw
     ----------------------------------------- */
  const BankWithdrawalForm = new Vue({
    el: '.form-withdraw-bank',
    data: {
      banks: '',
      amount: '',
      accountNumber: '',
      activeBonus: 0,
      accountType: '',
      bonusCategory: SERVICE_BIA_TEXT,
      accountName: '',
      iban: '',
      bankName: '',
      bankCode: null,
      activeMethod: 'BankTransfer',
      error: '',
      loading: false,
      success: false,
      notVerified: false,
      pending: false,
      verified: false,
      extra: [],
      allowWithdrawal: true,
      min: '',
      minAmounts: {
        'EUR' : MINIMUM_WITHDRAW_AMOUNT,
        'USD' : MINIMUM_WITHDRAW_AMOUNT,
        'default' : MINIMUM_DEFAULT_AMOUNT,
      }
    },
    computed: {
      disabledButton() {
        return parseInt(this.amount) >= parseInt(this.min);
      },
    },
    methods: {
      setActiveBonusStatus() {
        api.getActiveBonus()
          .done(res => {
            if (res.bonusCategory === this.bonusCategory) {
              this.activeBonus = 1;
            }
          })
          .fail(({ responseJSON: res }) => {
            if (res.errors) {
              consoleLog(res.errors);
            }
          });
        },
      submit: function () {
        const {
          amount,
          activeMethod,
          accountNumber,
          bankCode,
          activeBonus
        } = this;
        this.extra={
          "accountName":this.accountName,
          "iban":this.iban,
          "bankName":this.bankName
        };
        this.loading = true;
        this.success = false;
        this.error = '';
        let accountType = null;

        api.withdrawalInit(toCents(amount), this.activeMethod, this.accountNumber, this.bankCode, this.accountType, this.activeBonus, this.extra)
          .done(res => {
            consoleLog(res);
            if (res.status == 'OK') {
              this.error = false;
              this.success = true;
            }
            else if (res.hasOwnProperty('withdrawalId')) {
              this.error = false;
              this.success = true;
            }
            else if (res.status == 'NOTOK') {
              this.success = false;
              this.error = true;
              this.errorMessage = __APP__.default_error_message;
            }
            else {
              this.success = false;
              this.error = true;
              this.errorMessage = res.message;
            }
            return;
          })
          .fail(({ responseJSON: res }) => {
            this.success = false;
            this.error = true;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            } else {
              this.errorMessage = __APP__.default_error_message;
            }
          })
          .always(() => this.loading = false);

      }
    },
    created() {
      if (!document.getElementById('form-withdraw-bank')) {
        return;
      }
      this.allowWithdrawal = localStorage.userSource == 'online' && localStorage.role == ROLE_USER ? true : false;
      api.getKYCStatus()
        .done(res => {
          if ( res.status === 'NOT VERIFIED' ) {
            this.notVerified = true;
          }
          else if ( res.errors ) {
            this.notVerified = true;
          }
          else if ( res.status === 'PENDING' ) {
            this.pending = true;
          }
          else if ( res.status === 'VERIFIED' ) {
            this.verified = true;

            api.getAvailableBanks()
              .done(res => {
                this.banks = res.banks;
              });
            api.getPlayer()
              .done(res => {
                this.firstname = res.firstname;
                this.lastname = res.lastname;
                this.min = (this.minAmounts[res.currency]) ? MINIMUM_WITHDRAW_AMOUNT : this.minAmounts['default'];
              })
            .fail(err => {
              consoleLog('could not fetch user details');
            });

          }
        })
        .fail(({ responseJSON: res }) => {
          if (res.errors) {
            this.notVerified = true;
          }
        });
        this.setActiveBonusStatus();
    }
  });

  /* -----------------------------------------
 	 Account - Withdraw
 	 ----------------------------------------- */
  const WithdrawalForm = new Vue({
    el: '.form-withdraw',
    data: {
      amount: '',
      provider: 'APCO',
      activeBonus: 0,
      bonusCategory: SERVICE_BIA_TEXT,
      accountNumber: '',
      bankCode: '',
      accountType: '',
      methods: [],
      error: '',
      loading: false,
      success: false,
      activeMethod: '',
      allowWithdrawal: true,
      min: '',
      minAmounts: {
        'EUR' : MINIMUM_WITHDRAW_AMOUNT,
        'USD' : MINIMUM_WITHDRAW_AMOUNT,
        'default' : MINIMUM_DEFAULT_AMOUNT,
      }
    },
    computed: {
      disabledButton() {
        return parseInt(this.amount) >= parseInt(this.min) && this.activeMethod !== '';
      }
    },
    methods: {
      setActiveBonusStatus() {
        api.getActiveBonus()
          .done(res => {
            if (res.bonusCategory === this.bonusCategory) {
              this.activeBonus = 1;
            }
          })
          .fail(({ responseJSON: res }) => {
            if (res.errors) {
              consoleLog(res.errors);
            }
          });
        },
      submit: function () {
        const {
          amount,
          activeMethod,
          accountNumber,
          bankCode,
          accountType,
          activeBonus
        } = this;
        this.loading = true;
        this.success = false;
        this.error = '';

        //api.withdrawalInit(toCents(amount), this.provider, this.activeMethod, `${location.origin}/${__APP__.langShort}/withdrawal-success`, `${location.origin}/${__APP__.langShort}/withdrawal-failed`)
        api.withdrawalInit(toCents(amount), this.activeMethod, accountNumber, bankCode, accountType, activeBonus)
          .done(res => {
            if (res.method == 'REDIRECT') {
              location.replace(res.url);
            }
            else if (res.method == 'POST') {
              $('<form action="'+res.url+'" method="POST"><input type="hidden" name="params" id="params" value="'+encodeURIComponent(res.params.xml)+'"></form>').appendTo('body').submit();
            }
            else if (res.status == 'OK') {
              this.success = true;
            }
            else if (res.hasOwnProperty('withdrawalId')) {
              this.success = true;
            }
            else if (res.status == 'NOTOK') {
              this.error = true;
              this.errorMessage = __APP__.default_error_message;
            }
            else {
              this.error = true;
              this.errorMessage = res.error[0].message;
            }
            return;
          })

          .fail(({ responseJSON: res }) => {
            this.error = true;
            if (res) {
              this.errorMessage = res.errors[0].message;
            } else {
              this.errorMessage = __APP__.default_error_message;
            }
          })
          .always(() => this.loading = false);
      }
    },
    created() {
      if (!document.getElementById('form-withdraw')) {
        return;
      }
      this.allowWithdrawal = localStorage.userSource == 'online' && localStorage.role == ROLE_USER ? true : false;
      api.getWithdrawalMethods(this.provider)
        .done(res => {
          this.methods = res;
          this.activeMethod = res[0];
        });
      api.getPlayer()
        .done(res => {
          this.min = (this.minAmounts[res.currency]) ? MINIMUM_WITHDRAW_AMOUNT : this.minAmounts['default'];
        })
        this.setActiveBonusStatus();
    }
  });

   /* -----------------------------------------
 	 Account - Withdraw Praxis
 	 ----------------------------------------- */
    const WithdrawalPraxisForm = new Vue({
      el: '.form-withdraw-praxis',
      data: {
        amount: '',
        provider: 'PRAXIS',
        error: '',
        loading: false,
        success: false,
        activeMethod: 'PRAXIS',
        min: '',
        max: '',
        activeBonus: 0,
        bonusCategory: SERVICE_BIA_TEXT,
        accountNumber: '',
        bankCode: '',
        accountType: '',
        allowWithdrawal: true,
        currency: '',
        extra: {},
      },
      computed: {
        disabledButton() {
          return parseInt(this.amount) > 0 ;
        }
      },
      methods: {
        setActiveBonusStatus() {
          api.getActiveBonus()
            .done(res => {
              if (res.bonusCategory !== null) {
                this.activeBonus = 1;
              }
            })
            .fail(({ responseJSON: res }) => {
              if (res.errors) {
                consoleLog(res.errors);
              }
            });
        },
        submit: function () {
          const {
            amount,
            accountNumber,
            bankCode,
            accountType,
            activeBonus,
            provider
          } = this;
          this.loading = true;
          this.success = false;
          this.error = '';
          this.extra = {
            "returnUrl": `${location.origin}/${__APP__.langShort}/withdraw-praxis`,
          };
          api.withdrawalInit(toCents(amount), '', accountNumber, bankCode, accountType, activeBonus, this.extra, provider)
            .done(res => {
              if (res.method == 'REDIRECT') {
                location.replace(res.url);
             }
                else if (res.method == 'POST') {
                   $('<form action="'+res.url+'" method="POST"><input type="hidden" name="params" id="params" value="'+encodeURIComponent(res.params.xml)+'"></form>').appendTo('body').submit();
                }
                else if (res.status == 'OK') {
                  this.success = true;
                }
                 else if (res.hasOwnProperty('url')) {
                  location.replace(res.url);
                }
                 else if (res.status == 'NOTOK') {
                   this.error = true;
                   this.errorMessage = __APP__.default_error_message;
            }
            else {
                this.error = true;
                this.errorMessage = res.message;
          }
            return;
             })
  
            .fail(({ responseJSON: res }) => {
                this.error = true;
                if (res) {
                  this.errorMessage = res.errors[0].message;
                } else {
                  this.errorMessage = __APP__.default_error_message;
                }
            })
            .always(() => this.loading = false);
        }
      },
      created() {
          if (!document.getElementById('form-withdraw-praxis')) {
            return;
          }
          api.getPlayer()
          .done(res => {
            /*
            * Set minimum withdraw amount depending on currency;
            * */
           this.currency = res.currency;
            switch(this.currency){
              case 'EUR':
              case 'USD':
              case 'TND':
                this.min = MINIMUM_WITHDRAW_AMOUNT;
                this.max = MAXIMUM_WITHDRAW_AMOUNT;
                break;
              default:
                this.min = MINIMUM_DEFAULT_AMOUNT;
                this.max = MAXIMUM_WITHDRAW_AMOUNT;
            }
            this.allowWithdrawal = localStorage.userSource == 'online' && localStorage.role == ROLE_USER && PRAXIS_CURRENCIES.includes(res.currency) ? true : false;
          })
          this.setActiveBonusStatus();
      }
    });

  /* -----------------------------------------
   Betting Transactions
   ----------------------------------------- */
  new Vue({
    el: '#transactions-betting',
    data: {
      isFetching: false,
      currentPage: 1,
      maxPages: 0,
      gameNames: [],
      loading: true,
      startDate: '',
      endDate: '',
      columns: ['dateTime', 'referenceId', 'gameId', 'gameName', 'status'],
      tableData: [],
      options: {
        headings: {
          'dateTime' : $("#history_betting_datetime").val(),
          'referenceId' : $("#history_betting_referenceid").val(),
          'gameId' : $("#history_betting_gameid").val(),
          'gameName' : $("#history_betting_gamename").val(),
          'status' : $("#history_betting_status").val(),

      },
      texts: {
        filter : $("#history_financial_filter_results").val(),
        filterPlaceholder : $("#history_financial_search_query").val(),
        noResults: " ",
      },
        orderBy: {
          column: 'dateTime',
          ascending: false,
        },
        customSorting: {
          dateTime: function (ascending) {
            return function (a, b) {
              return ascending
                ? a.dateTime - b.dateTime
                : b.dateTime - a.dateTime;
            }
          }
        },
        perPage: 9999,
        perPageValues: [],
        sortIcon: {
          base: '',
          up: 'fa fa-angle-up',
          down: 'fa fa-angle-down'
        },
      },
    },
    methods: {
      getGameName(row) {
        if(typeof this.gameNames[parseInt(row.gameId)] !== 'undefined'){
          return this.gameNames[parseInt(row.gameId)];
        }
        return row.gameName;
      },
      transformResponse(rows) {
        return rows.map(row => ({
          ...row,
          gameName: this.getGameName(row),
          status: row.betAmount === 0
            ? `Won (${formatMoney(row.returnAmount)})`
            : `Bet (${formatMoney(row.betAmount)})`
        })).filter(row => {
          return (row.betAmount !== 0 || row.returnAmount !== 0);
        });
      },
      fetchTransactions(page = 1, startDate, endDate) {
        this.isFetching = true;

        api.getGameTransactions(page, startDate || undefined, endDate || undefined).done((res, textStatus, xhr) => {
          if (res.length > 0) {
            if (page === 1) {
              this.tableData = this.transformResponse(res);
            } else {
              this.tableData = this.tableData.concat(this.transformResponse(res));
            }
          }  
          else {
            this.options.texts.noResults = $("#history_no_matching_records").val();
          }
          this.loading = false;  
          this.currentPage = page;
          this.maxPages = xhr.getResponseHeader('X-Pagination-Page-Count');
          this.isFetching = false;
        });
      },
      loadMoreTransactions() {
        this.fetchTransactions(this.currentPage + 1, this.startDate, this.endDate);
      },
      resetDateFilters() {
        this.startDate = '';
        this.endDate = '';
        this.fetchTransactions();
      }
    },
    created() {
      if (!document.getElementById('transactions-betting')) {
         return;
       }

       api.fetchGames(__APP__.country_2, CATEGORY_ALL_GAMES).done(res => {
        res.find(game => {
          this.gameNames[parseInt(game.provider.game_id)] = game.provider.game_name;
        });
        this.fetchTransactions();
      });
    },
    mounted() {
      // Initialize datepickers
      const that = this;
      const $startDate = $(this.$refs.startDate);
      const $endDate = $(this.$refs.endDate);

      $startDate.datepicker({
        language: __APP__.langShort,
        dateFormat: 'yyyy-mm-dd',
        maxDate: new Date(),
        onSelect(formattedDate, date) {
          that.startDate = formattedDate;
          $endDate.datepicker().data('datepicker').update('minDate', date);
          that.fetchTransactions(1, that.startDate, that.endDate);
        }
      });

      $endDate.datepicker({
        language: __APP__.langShort,
        dateFormat: 'yyyy-mm-dd',
        maxDate: new Date(),
        onSelect(formattedDate) {
          that.endDate = formattedDate;
          that.fetchTransactions(1, that.startDate, that.endDate);
        }
      });
    }
  });

  /* -----------------------------------------
   Financial Transactions
   ----------------------------------------- */
  new Vue({
    el: '#transactions-financial',
    data: {
      isFetching: false,
      errorMessage: '',
      startDate: '',
      endDate: '',
      error: false,
      success: false,
      firstPage: 1,
      maxPages: 0,
      currentPage: 1,
      loading: true,
      transactionType: 'deposit',
      columns: ['paymentTime', 'paymentId', 'paymentMethod', 'status', 'paymentAmount'],
      translatedStatusString: {
        '-1': 'Failed / Cancelled',
        '0': 'Pending',
        '1': 'Paid',
        '5': 'Approved',
        '10': 'Paid',
      },
      providerStrings: {
        '0': $("#history_financial_provider_unknown").val(),
        '102': $("#history_financial_provider_agent_tool").val(),
        '106': $("#history_financial_provider_bank_transfer").val(),
        '110': 'Apco',
        '112': 'Skrill',
        '113': 'Neteller',
        '114': 'Ecopayz',
        '117': 'Paystack',
        '118': 'Paydirect',
        '128': 'Payland',
        '129': 'Neosurf',
        '132': 'Flutterwave',
        '141': 'Praxis'
      },
      tableData: [],
      options: {
        headings: {
          'paymentTime' : $("#history_financial_paymenttime").val(),
          'paymentId' : $("#history_financial_paymentid").val(),
          'paymentMethod' : $("#history_financial_paymentmethod").val(),
          'status' : $("#history_financial_status").val(),
          'paymentAmount' : $("#history_financial_paymentamount").val(),
          'paymentAction' : $("#history_financial_payment_action").val(),
      },
      texts: {
        filter : $("#history_financial_filter_results").val(),
        filterPlaceholder : $("#history_financial_search_query").val(),
        noResults: $("#history_no_matching_records").val(),
      },
        orderBy: {
          column: 'paymentId',
          ascending: false,
        },
        customSorting: {
          paymentId: function (ascending) {
            return function (a, b) {
              return ascending
                ? a.paymentId - b.paymentId
                : b.paymentId - a.paymentId;
            }
          }
        },
        perPage: 9999,
        perPageValues: [],
        sortIcon: {
          base: '',
          up: 'fa fa-angle-up',
          down: 'fa fa-angle-down'
        },
      },
    },
    methods: {
      transformResponse(rows) {
        var self = this;
        return rows.map(row => ({
          ...row,
          paymentTime: (new Date(row.paymentTime+ 'Z')).toLocaleString().slice(0, -3),
          status: self.getStatusString(row.status),
          paymentAmount: formatMoney(row.paymentAmount),
          paymentMethod: (typeof this.providerStrings[row.paymentMethod] === 'string') ? this.providerStrings[row.paymentMethod] : row.paymentMethod,
          paymentAction: self.showActionButton(row.status),
        }), self);
      },
      getStatusString(code) {
        if (typeof this.translatedStatusString[code] === 'string') {
          return this.translatedStatusString[code];
        }
        return code;
      },
      showActionButton(status) {
        let self = this;
        const statusPending = '0';
        if ( status == statusPending && this.transactionType == 'withdraw') {
          return self.paymentAction = true;
        }
        else {
          return self.paymentAction = false;
        }
      },
      loadMoreTransactions() {
        this.fetchTransactions(this.transactionType, this.currentPage + 1, this.startDate, this.endDate).done(() => {
          this.currentPage++;
        });
      },
      changeTransactionType(type) {
        this.transactionType = type;
        if ( type == 'deposit') {
          this.resetDateFilters();
          this.columns = [
            'paymentTime',
            'paymentId',
            'paymentMethod',
            'status',
            'paymentAmount'
          ];
        }
        else if ( type == 'withdraw') {
          this.resetDateFilters();
          this.columns = [
            'paymentTime',
            'paymentId',
            'paymentMethod',
            'status',
            'paymentAmount',
            'paymentAction'
          ];
        }
        this.currentPage = 1;
        this.fetchTransactions(type);
      },
      fetchTransactions(type, page = 1, startDate, endDate) {
        let transactionRequest;
        type = type || this.transactionType;
        startDate = startDate || undefined;
        endDate = endDate || undefined;
        this.isFetching = true;

        switch(type) {
          case 'deposit':
          default:
            transactionRequest = api.getDepositTransactions;
            break;
          case 'withdraw':
            transactionRequest = api.getWithdrawTransactions;
            break;
        }

        return transactionRequest(page, startDate, endDate).done((res, textStatus, xhr) => {
          if (res) {
            if (page === 1) {
              this.tableData = this.transformResponse(res);
            }
            else {
              this.tableData = this.tableData.concat(this.transformResponse(res));
            }
          }
          else {
            this.options.texts.noResults;
          }
          this.loading = false;  
          this.maxPages = xhr.getResponseHeader('X-Pagination-Page-Count');
          this.isFetching = false;
        });
      },
      resetDateFilters() {
        this.startDate = '';
        this.endDate = '';
        this.fetchTransactions();
      },
      fetchTranslatedStatusStrings() {
        let translationsArray = [];
        $("#translated_status_string span").each(function(){
          translationsArray[$(this).attr('data-id')] = $(this).html();
        });
        this.translatedStatusString = translationsArray;
    },
    userCancelWithdraw(withdrawalId) {
      this.paymentId = withdrawalId;
      api.userCancelWithdrawal(this.paymentId)
        .done(res => {
          if (res.errors) {
            consoleLog('Withdrawal Cancel Error ', res.error);
            this.error = true;
            this.success = false;
          }
          else {
            this.error = false;
            this.success = true;
            setTimeout(() => this.success = false, 4000);
            this.fetchTransactions(this.transactionType, this.firstPage);
            this.fetchTranslatedStatusStrings();
          }
        })
        .fail(({ responseJSON: res}) => {
          this.error = true;
        });
    },
  },
    created() {
      if (!document.getElementById('transactions-financial')) {
        return;
      }

      this.fetchTransactions(this.transactionType, 1);
      this.fetchTranslatedStatusStrings();
    },
    watch: {
      startDate(newValue, oldValue) {
        this.fetchTransactions(this.transactionType, 1, this.startDate, this.endDate);
      },
      endDate(newValue, oldValue) {
        this.fetchTransactions(this.transactionType, 1, this.startDate, this.endDate);
      },
    },
    mounted() {
      // Initialize datepickers
      const that = this;
      const $startDate = $(this.$refs.startDate);
      const $endDate = $(this.$refs.endDate);

      $startDate.datepicker({
        language: __APP__.langShort,
        dateFormat: 'yyyy-mm-dd',
        maxDate: new Date(),
        onSelect(formattedDate, date) {
          that.startDate = formattedDate;
          $endDate.datepicker().data('datepicker').update('minDate', date);
          that.fetchTransactions(this.transactionType, 1, that.startDate, that.endDate);
        }
      });

      $endDate.datepicker({
        language: __APP__.langShort,
        dateFormat: 'yyyy-mm-dd',
        maxDate: new Date(),
        onSelect(formattedDate) {
          that.endDate = formattedDate;
          that.fetchTransactions(this.transactionType, 1, that.startDate, that.endDate);
        }
      });
    }
  });

/* -----------------------------------------
     Account - Shop Withdraw
     ----------------------------------------- */
     const ShopWithdrawalForm = new Vue({
      el: '.form-withdraw-shop',
      data: {
        provider: 'AGENT_TOOL',
        amount: '',
        errors: [],
        errorMessage: '',
        error: '',
        accountNumber: '',
        bankCode: '',
        accountType: '',
        withdrawalId: '',
        shopName: '',
        shopName1: '',
        shops: [],
        extra: '',
        activeBonus: 0,
        bonusCategory: SERVICE_BIA_TEXT,
        loading: false,
        success: false,
        disabled: false,
        min: '',
        minAmounts: { 
            'EUR' : MINIMUM_WITHDRAW_AMOUNT,
            'USD' : MINIMUM_WITHDRAW_AMOUNT,
            'default' : MINIMUM_DEFAULT_AMOUNT,
          }
      },
      methods: {
        setActiveBonusStatus() {
          api.getActiveBonus()
            .done(res => {
              if (res.bonusCategory === this.bonusCategory) {
                this.activeBonus = 1;
              }
            })
            .fail(({ responseJSON: res }) => {
              if (res.errors) {
                consoleLog(res.errors);
              }
            });
        },
        submit: function () {
          this.loading = true;
          this.success = false;
          this.error = '';

          api.withdrawalInit( toCents(this.amount), this.provider, this.accountNumber, this.bankCode, this.accountType, this.activeBonus)
              .done( res => {
                this.success = true;
                this.error = false;
                this.loading = false;
                this.withdrawalId = res.withdrawalId;
                this.shops.forEach(shop => {
                  if (shop.id == this.accountType) {
                     this.shopName = shop.name;
                  }
                })
              }).fail(({ responseJSON: res }) => {
            this.error = true;
            this.loading = false;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            }
            else {
              this.errorField = res[0].field;
            }
          })
        },
      },
      computed: {
        resultAmount() {
          return formatMoney(toCents(this.amount));
        },
      },
      created() {
        if (!document.getElementById('form-withdraw-shop')) {
          return;
        }
        api.getPlayer()
        .done(res => {
          this.min = this.minAmounts[res.currency] ? MINIMUM_WITHDRAW_AMOUNT : this.minAmounts['default'];
        })
        api.getAvailableShops()
        .done( res => {
            this.shops = res;
        });
        this.setActiveBonusStatus();
      }
    });

/*
  * Agent Tool content
  * */

  /* -----------------------------------------
 	 Sidebar agent menu
 	 ----------------------------------------- */

    $('#plansHasMenu').on('shown.bs.collapse', function () {
      $('.plansDrop').addClass('fa-chevron-down').removeClass('fa-chevron-right');
    }).on('hidden.bs.collapse', function () {
      $('.plansDrop').addClass('fa-chevron-right').removeClass('fa-chevron-down');
    });

    $('#paymentHasMenu').on('shown.bs.collapse', function () {
      $('.paymentDrop').
        addClass('fa-chevron-down').
        removeClass('fa-chevron-right');
    }).on('hidden.bs.collapse', function () {
      $('.paymentDrop').
        addClass('fa-chevron-right').
        removeClass('fa-chevron-down');
    });

    $('#reportHasMenu').on('shown.bs.collapse', function () {
      $('.reportDrop').
        addClass('fa-chevron-down').
        removeClass('fa-chevron-right');
    }).on('hidden.bs.collapse', function () {
      $('.reportDrop').
        addClass('fa-chevron-right').
        removeClass('fa-chevron-down');
    });

    $('#userHasMenu').on('shown.bs.collapse', function () {
      $('.userDrop').addClass('fa-chevron-down').removeClass('fa-chevron-right');
    }).on('hidden.bs.collapse', function () {
      $('.userDrop').addClass('fa-chevron-right').removeClass('fa-chevron-down');
    });

    $('#commissionHasMenu').on('shown.bs.collapse', function () {
      $('.commissionDrop').addClass('fa-chevron-down').removeClass('fa-chevron-right');
    }).on('hidden.bs.collapse', function () {
      $('.commissionDrop').addClass('fa-chevron-right').removeClass('fa-chevron-down');
    });

    /* -----------------------------------------
       Register Agent User
       ----------------------------------------- */
    const AgentRegisterUserForm = new Vue({
      el: '.form-agent-register-user',
      data: {
        userData: [],
        username: '',
        password: '',
        confirmPassword: '',
        dayBirthDate: '',
        monthBirthDate: '',
        yearBirthDate: '',
        role: '',
        email: '',
        agentId: '',
        currency: '',
        country: '',
        countries: [],
        disableButton: false,
        firstname: '',
        lastname: '',
        error: '',
        errorField: '',
        errorMessages: [],
        errorMessage: '',
        loading: false,
        success: false,
        disabled: false,
        showRepeatPassword: true,
        passwordFieldType: 'password',
        repeatPasswordFieldType: 'password',
        showPassword: true,
        validationMessage: $("#pass_validation_text").val(),
        repeatPasswordMessage: $("#enter_repeat_pass_validation_text").val(),
      },
      methods: {
        togglePasswordVisibility() {
          switchVisibility(this, 'passwordFieldType', 'showPassword');
        },
        toggleRepeatPasswordVisibility() {
          repeatPasswordSwitchVisibility(this, 'repeatPasswordFieldType', 'showRepeatPassword');
        },
        ValidateInputPassword() {
          const cleanPassword = (password) => password.replace(/\s/g, "");
      
          this.password = cleanPassword(this.password);
          this.confirmPassword = cleanPassword(this.confirmPassword);
      
          // Validate the cleaned password
          const password = this.password;
          const conditions = [
              { regex: /^.{8,}$/ },
              { regex: /[A-Z]/ },
              { regex: /[a-z]/ },
              { regex: /[0-9]/ },
              { regex: /[!@#$%^&*()\-+=@'";:\|/?.`,~<>_\[\]{}]/ },
              { regex: /^[^\s]*$/ }
          ];
  
          return !conditions.every(condition => condition.regex.test(password));
       },  
        submit () {
          this.disableButton = false;
          this.loading = true;
          this.error = false;
          this.success = false;

          if (this.ValidateInputPassword()) {
            this.error = true;
            this.loading = false;
            this.errorMessage = 'Validation message';
            return;
          }

          if (this.password != this.confirmPassword) {
            this.error = true;
            this.success = false;
            this.errorMessage = '';
            this.errorField = 'Passwords do not match';
            this.loading = false;
            this.disabled = false;
            return;
          }

          let birthdate = `${this.yearBirthDate}-${this.monthBirthDate}-${this.dayBirthDate}`;

          if (this.role == 10) {
            api.registerUser(this.username, this.password, this.email,
              this.country, this.currency, this.firstname, this.lastname, birthdate).done(res => {
              if (res.errors) {
                console.log('Register User Error ', res.error);
                this.error = true;
                this.errorMessage = res.errors[0].message;
              }
              else {
                this.error = false;
                this.success = true;
                this.username = '';
                this.password = '';
                this.confirmPassword = '';
                this.firstname = '';
                this.lastname = '';
                this.email = '';
              }
            }).fail(({ responseJSON: res }) => {
              this.error = true;
              if (res.errors) {
                this.errorMessage = res.errors[0].message;
              }
              else {
                this.errorMessage = res[0].message;
                this.errorField = res[0].field;
              }
            }).always(() => {
              this.disableButton = false;
              if (this.success) {
                setTimeout(() => this.success = false, 4000);
              }
              this.loading = false;
            });
          }
          else if (this.role == 15) {
            api.registerCashier(this.username, this.password, this.email,
              this.country, this.currency, this.firstname, this.lastname, birthdate).done(res => {
              if (res.errors) {
                console.log('Register User Error ', res.error);
                this.error = true;
                this.errorMessage = res.errors[0].message;
              }
              else {
                this.error = false;
                this.loading = true;
                this.success = true;
                this.username = '';
                this.password = '';
                this.confirmPassword = '';
                this.firstname = '';
                this.lastname = '';
                this.email = '';
              }
            }).fail(({ responseJSON: res }) => {
              this.error = true;
              if (res.errors) {
                this.errorMessage = res.errors[0].message;
              }
              else {
                this.errorMessage = res[0].message;
                this.errorField = res[0].field;
              }
            }).always(() => {
              this.disableButton = false;
              if (this.success) {
                setTimeout(() => this.success = false, 4000);
              }
              this.loading = false;
            });
          }
          else if (this.role == 20) {
            api.registerAgent(this.username, this.password, this.email,
              this.country, this.currency, this.firstname, this.lastname, birthdate).done(res => {
              if (res.errors) {
                console.log('Register User Error ', res.error);
                this.error = true;
                this.errorMessage = res.errors[0].message;
              }
              else {
                this.error = false;
                this.loading = true;
                this.success = true;
                this.username = '';
                this.password = '';
                this.confirmPassword = '';
                this.firstname = '';
                this.lastname = '';
                this.email = '';
              }
            }).fail(({ responseJSON: res }) => {
              this.error = true;
              if (res.errors) {
                this.errorMessage = res.errors[0].message;
              }
              else {
                this.errorMessage = res[0].message;
                this.errorField = res[0].field;
              }
            }).always(() => {
              this.disableButton = false;
              if (this.success) {
                setTimeout(() => this.success = false, 4000);
              }
              this.loading = false;
            });
          }
          else if (this.role == 30) {
            api.registerSuperAgent(this.username, this.password, this.email,
              this.country, this.currency, this.firstname, this.lastname, birthdate).done(res => {
              if (res.errors) {
                console.log('Register User Error ', res.error);
                this.error = true;
                this.errorMessage = res.errors[0].message;
              }
              else {
                this.error = false;
                this.loading = true;
                this.success = true;
                this.username = '';
                this.password = '';
                this.confirmPassword = '';
                this.firstname = '';
                this.lastname = '';
                this.email = '';
              }
            }).fail(({ responseJSON: res }) => {
              this.error = true;
              if (res.errors) {
                this.errorMessage = res.errors[0].message;
              }
              else {
                this.errorMessage = res[0].message;
                this.errorField = res[0].field;
              }
            }).always(() => {
              this.disableButton = false;
              if (this.success) {
                setTimeout(() => this.success = false, 4000);
              }
              this.loading = false;
            });
          }
          else {
            this.disableButton = false;
            this.error = true;
            this.errorField = 'Role cannot be blank';
            this.loading = false;
          }
        },
        filters: {
          parseError (error) {
            return error.split('/').join(', ');
          },
        },
      },
      created () {
        if (!document.getElementById('form-agent-register-user')) {
          return;
        }
        popoverInfoMessage(this.validationMessage, 'format-message');
        popoverInfoMessage(this.repeatPasswordMessage, 'repeat-password-message');

        api.getPlayer().done(res => {
          this.agentId = res.user_id;
          this.country = res.country;
        });

        api.getBalance().done(res => {
          this.currency = res.currency;
        });

        api.getAvailableRegistrationCountries().done(res => {
          this.countries = res;
        });

      },
    });


  /* -----------------------------------------
  Module for Agent Search
  ----------------------------------------- */
  Vue.component('agent-tree', {
    template: '#agent-tree',
    props: ['username', 'userid', 'depth', 'translations', 'errorstranslations', 'role', 'usertype'],
    data() {
      return {
        showChildren: false,
        hasChildren: true,
        balanceLoaded: false,
        loading: false,
        plan: '',
        planId: '',
        balance: '',
        cashbalance: '',
        children: []
      }
    },
    computed: {
      indent() {
        return { transform: `translate(${this.depth * __APP__.indentation}px)` }
      },
      balanceClass() {
        return (this.balanceLoaded) ? ' balance-loaded ' : '';
      }
    },
    watch: {
      balance(newValue, oldValue) {
        this.showChildren = false;
        this.balanceLoaded = true;
      },
      plan(newValue, oldValue) {
        this.showChildren = false;
      }
    },
    methods: {
      iconClasses(role) {
        return {
          'fa-plus-square-o': this.canHaveChildren(role) && !this.showChildren,
          'fa-minus-square-o': this.canHaveChildren(role) && this.showChildren,
          '' : !this.canHaveChildren(role)
        }
      },
      getBalance () {
        this.loading = true;
        api.getBalanceAgent(this.userid).done(res => {
          if ((typeof res.errors !== 'undefined') || (typeof res.code !== 'undefined')) {
            consoleLog('Get Balance Error', res.error);
            this.error = true;
            this.errorMessage = errorstranslations[res.errors[0].code];
          }
          else {
            this.balance = null;
            this.cashbalance = null;
            this.showChildren = false;
            this.balanceLoaded = true;
            this.balance = formatMoney(res.balance,
              res.currency);
            this.cashbalance = formatMoney(res.cashBalance,
              res.currency);
          }
        }).fail(({ responseJSON: res }) => {
          this.error = true;
          if ((typeof res.errors !== 'undefined') || (typeof res.code !== 'undefined')) {
            this.errorMessage = errorstranslations[res.errors[0].code];
          }
          else {
            this.errorMessage = __APP__.default_error_message;
          }
        }).always(() => {
          this.loading = false;
        });
      },
      getCommissionPlan () {
        this.loading = true;
        api.agentGetUserCommmissionPlan(this.userid).done(res => {
          if (res) {
            this.plan = res.name;
            this.planId = res.id;
          }
          else {
            this.plan = false;
            this.error = true;
          }
        }).fail(({ responseJSON: res }) => {
          this.error = true;
          if ((typeof res.errors !== 'undefined') || (typeof res.code !== 'undefined')) {
            this.errorMessage = this.errorstranslations[res.errors[0].code];
          }
          else {
            this.errorMessage = __APP__.default_error_message;
          }
          this.plan = '';
          this.planid = '';
        }).always(() => {
          this.loading = false;
        });
      },
      canHaveChildren(role) {
        return !((parseInt(role) === parseInt(ROLE_USER)) || (parseInt(role) === parseInt(ROLE_CASHIER))) ;
      },
      canHavePlan(role) {
        return parseInt(role) === parseInt(ROLE_AGENT);
      },
      setNoChildren() {
        this.showChildren = false;
        this.hasChildren = false;
      },
      toggleChildren() {
        if(!this.canHaveChildren(this.role)) {
          this.setNoChildren();
          return;
        }
        this.showChildren = !this.showChildren;
        api.getAgentDirectChildren(this.userid).done(res => {
          if(res.length == 0) {
            this.setNoChildren();
            return;
          }
          this.children = res.map(user => {
            return {
              'usertype': (typeof this.translations[user.role] === 'undefined') ? user.role : this.translations[user.role],
              'username': user.username,
              'children' : null,
              'balance': null,
              'cashBalance': null,
              'userid': parseInt(user.userId),
              'position': user.position,
              'role': user.role,
              'plan': null,
              'planid': null
            };
          }).sort((a, b) => {
            return (b.role - a.role) || a.username.localeCompare(b.username);
          });
        });
      }
    },
  });

    /* -----------------------------------------
    Agent Search Users
    ----------------------------------------- */
    const AgentSearchUserForm = new Vue({
      el: '.form-agent-search-user',
      data: {
        error: '',
        errorMessage: '',
        loading: false,
        loadingCsvBtn: false,
        success: false,
        users: [],
        currentUser: [],
        errorstranslations: [],
        tableHeadings: [],
        translations: [],
        totalBalances: [],
        totalBalancesPerRole: [],
        totals: '',
        userCurrency: '',
        parent: null,
        flatUserTree: [],
        userId: '',
        result: [],
        search: '',
        showMessage: false,
        columns: [
          'usertype',
          'username',
          'father',
          'balances',
          localStorage.getItem('role') === ROLE_SUPER_AGENT ? 'plan' : ''
        ],
        options: {
          perPage: 50,
          headings: {
            'usertype': function (h) {
              return this.tableHeadings.usertype;
            },
            'username': function (h) {
              return this.tableHeadings.username;
            },
            'father': function (h) {
              return this.tableHeadings.father;
            },
            'balances': function (h) {
              return this.tableHeadings.balances;
            },
            'plan': localStorage.getItem('role') === '30' ? 'Assigned Plan' : ''
          },
        },
      },
      computed: {
        /*usersMapped() {
          let that = this;
          return this.users.map(user => {
            return {

            };
          }, that);
        },*/
        usersFiltered () {
          let that = this;
          return this.flatUserTree.filter(user => {
          return (user.username !== this.currentUser.username) && (user.username.toLowerCase().search(this.search.toLowerCase()) != -1);
          }, that);
        },
        usersSorted () {
          return this.users.sort((a, b) => {
          return (b.role - a.role) || a.username.localeCompare(b.username);
          });
        },
      },
      methods: {
        submit () {
          this.loading = true;
          this.error = false;
          this.success = false;
        },
        saveAgentSearchAsCsv() {
          this.loadingCsvBtn = true;
          api.saveAgentSearchAsCsv()
            .done(res => {
              this.success = true;
              this.error = false;
              this.message = $("#csvSuccess").val();
              this.localClass = 'alert-success';
              this.showMessage = true;
            })
            .fail(({ responseJSON: res }) => {
              this.message = $("#csvError").val();
              this.localClass = 'alert-danger';
              this.showMessage = true;
            })
            .always(() => {
              this.loadingCsvBtn = false;
              this.disableButton = false;
              setTimeout(() => {
                this.showMessage = false;
                }, 3000);
            })
        },
        getTranslations () {
          let translationsArrayTotalBalance = [];
          $('#roles_total_balance_translations span').each(function () {
          translationsArrayTotalBalance[$(this).attr('data-id')] = $(this).html();
          });
          this.translationsTotalBalance = translationsArrayTotalBalance;

          let translationsArray = [];
          $('#roles_translations span').each(function () {
            translationsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.translations = translationsArray;
          let errorsArray = [];
          $('#errors_translations span').each(function () {
            errorsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.errorstranslations = errorsArray;
          let stringsArray = [];
          let typesObj = {};
          $('#strings_translations span').each(function () {
            stringsArray[$(this).attr('data-id')] = $(this).html();
            if ($(this).attr('data-name')) {
              typesObj[$(this).attr('data-name')] = $(this).html();
            }
          });
          this.strings = stringsArray;
          this.typeTranslations = typesObj;
          let tableHeadingsObj = {};
          $('#table_headings_translations span').each(function () {
            tableHeadingsObj[$(this).attr('data-name')] = $(this).html();
          });
          tableHeadingsObj['plan'] = localStorage.getItem('role') === ROLE_SUPER_AGENT ? 'Assigned Plan' : '';
          this.tableHeadings = tableHeadingsObj;
        },
        canHavePlan(role) {
          return parseInt(role) === parseInt(ROLE_AGENT);
        },
        getBalance (id) {
          this.userId = id;
          let arrKeyForId = this.flatUserTree.map(user => {
            return (typeof user === 'object')
              ? parseInt(user.userid)
              : -1;
          }).indexOf(id);
          this.flatUserTree[arrKeyForId].loading = true;

          api.getBalanceAgent(id).done(res => {
            if (res.errors) {
              consoleLog('Get Balance Error', res.error);
              this.error = true;
              this.errorMessage = errorstranslations[res.errors[0].code];
            } else {
              this.flatUserTree[arrKeyForId].balance = formatMoney(res.balance,
              res.currency);
              this.flatUserTree[arrKeyForId].cashbalance = formatMoney(res.cashBalance,
              res.currency);
            }
          }).fail(({ responseJSON: res }) => {
            this.error = true;
            if (res) {
              this.errorMessage = res[0].message;
            }
            else {
              this.errorMessage = __APP__.default_error_message;
            }
          }).always(() => {
            this.flatUserTree[arrKeyForId].loading = false;
          });
        },
        getCommissionPlan (id) {
          this.userId = id;
          let arrKeyForId = this.flatUserTree.map(user => {
            return (typeof user === 'object')
              ? parseInt(user.userid)
              : -1;
          }).indexOf(id);
          this.flatUserTree[arrKeyForId].loading = true;
          api.agentGetUserCommmissionPlan(id).done(res => {
            if (res !== null && res.errors) {
              consoleLog('Get Balance Error', res.error);
              this.error = true;
              this.errorMessage = errorstranslations[res.errors[0].code];
            }
            else {
              if(res !== null) {
                this.flatUserTree[arrKeyForId].plan = res.plan;
                this.flatUserTree[arrKeyForId].planid = res.plan_id;
              } else {
                this.flatUserTree[arrKeyForId].plan = false;
                this.flatUserTree[arrKeyForId].planid = false;
              }
            }
          }).fail(({ responseJSON: res }) => {
            this.error = true;
            if ((typeof res.errors !== 'undefined') || (typeof res.code !== 'undefined')) {
              this.errorMessage = errorstranslations[res.errors[0].code];
            }
            else {
              this.errorMessage = __APP__.default_error_message;
            }
          }).always(() => {
            this.flatUserTree[arrKeyForId].loading = false;
          });
        },
        getAgentDirectChildren() {
          api.getAgentDirectChildren(this.currentUser.id).done(res => {
            this.users = res.map(user => {
              return {
                'usertype': (typeof this.translations[user.role] === 'undefined') ? user.role : this.translations[user.role],
                'username': user.username,
                'balance': null,
                'cashBalance': null,
                'userId': parseInt(user.userId),
                'position': user.position,
                'role': user.role,
              };
            });
           });
        },
        getAgentHierarchyFull() {
          api.getAgentHierarchyFull().done(res => {
            if (res[0] !== false) {
              this.parent = {
                'usertype': this.translations[this.currentUser.role],
                'userId': this.currentUser.id,
                'username': this.currentUser.username,
              };
            }
            if (res[0] === false) { //TODO: Temporary fix because platform returns false if there is no parent
              if (this.currentUser.role == ROLE_PARTNER) {
                res.shift();  
              } 
              this.parent = {
                'usertype': this.translations[this.currentUser.role],
                'userId': this.currentUser.id,
                'username': this.currentUser.username,
              };
            }
          this.flatUserTree = res.map(user => {
            return {
              'usertype': (typeof this.translations[user.role] === 'undefined') ? user.role : this.translations[user.role],
              'username': user.username,
              'balance': null,
              'cashBalance': null,
              'userid': parseInt(user.userId),
              'position': user.position,
              'role': user.role,
              'plan': user.plan_name,
              'planid': user.plan_id,
              'loading': false,
            };
          });
          });
        },
      },
      created () {
        if (!document.getElementById('form-agent-search-user')) {
          return;
        }
        this.currentUser.role = localStorage.getItem('role');
        this.userCurrency = localStorage.getItem('currency');
        this.totals = this.currentUser.role == ROLE_OWNER && this.userCurrency != CURRENCY_TND ? false : true;

          api.getAgentHierarchyFullTotalBalance()
          .done(res => {
            if (res) {
              this.totalBalances = res.total.map(item => {
                return {
                  'balance' : formatMoney(item.balance),
                  'currency' : item.currency,
                }
              });
            }
          })

          api.getAgentTotalBalancePerRole()
          .done(res => {
            if (res) {
              this.totalBalancesPerRole = res.total.map(item => {
                return {
                  'balance' : formatMoney(item.balance),
                  'currency' : item.currency,
                  'role': this.translationsTotalBalance[item.role]
                }
              });
            }
          }); 

          if (!localStorage.user_id) {
            api.getPlayer().done(res => {
              this.currentUser.agentId = res.user_id;
              this.currentUser.id = this.currentUser.agentId;
              this.currentUser.username = res.username;
              this.getAgentDirectChildren();
              this.getAgentHierarchyFull();
            });
          } 
          else {
            this.currentUser.agentId = localStorage.user_id;
            this.currentUser.id = this.currentUser.agentId;
            this.currentUser.username = localStorage.username;
            this.getAgentDirectChildren();
            this.getAgentHierarchyFull();
          }

        this.getTranslations();
      },
      mounted() {
        if (localStorage.getItem('role') !== '30') {
          this.columns.pop();
        }
      }
    });

    /* -----------------------------------------
    Transfer Agent Cash - v1
    ----------------------------------------- */
    const AgenTransferCashForm = new Vue({
      el: '.form-agent-transfer-user',
      data: {
        users: [],
        usernames: [],
        roles: [],
        amount: '',
        error: '',
        sourceUser: '',
        targetUser: '',
        errorMessage: '',
        currentUser: {},
        translations: [],
        errorsTranslations: [],
        transferNote: '',
        transferNoteMax: 250,
        disabled: false,
        loading: false,
        success: false,
        parent: 0,
        self: 1,
      },
      computed: {
        uniqueRoles () {
          let sortedUsers = this.usersSorted;
          /* Find the first and last occurences of role */
          let roles = sortedUsers.map(user => {
            return parseInt(user.role);
          });
          return roles.filter(function (value, index, self) {
            return self.indexOf(value) === index;
          });
        },
        userTree () {
          let that = this;
          let users = [];
          this.users.forEach(user => {
            if (typeof user === 'object') {
              if (typeof (users[user.role]) !== 'object') {
                users[user.role] = [];
              }
              if (user.position == 'parent') {
                this.translations[parseInt(
                  user.role)] = this.translations[this.parent];
              }
              if (user.position == 'self') {
                this.translations[parseInt(
                  user.role)] = this.translations[this.self];
              }
              users[parseInt(user.role)].push({
                'username': user.username,
                'id': parseInt(user.userId),
                'position': user.position,
              });
            }
          }, that);
          return users;
        },
        usersSorted () {
          return this.users.sort((a, b) => {
            return (b.role - a.role) || a.username.localeCompare(b.username);
          });
        },
      },
      mounted () {
        if (!document.getElementById('form-agent-transfer-user')) {
            return;
          }

        this.$nextTick(function () {
          let that = this;
          $('#transfer_from').select2().on('change', function () {
              that.sourceUser = this.value;
            });
          $('#transfer_to').select2().on('change', function () {
            that.targetUser = this.value;
          });
          });
      },
      methods: {
        setAmount (amount) {
          this.amount = amount;
        },
        getTranslations () {
          let translationsArray = [];
          $('#roles_translations span').each(function () {
            translationsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.translations = translationsArray;
          let errorsArray = [];
          $('#errors_translations span').each(function () {
            errorsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.errorsTranslations = errorsArray;

        },
        submit () {
          // When the platform responses with correct errNos and messages then
          // the below lines must be removed TODO: These have to be translated
          // via cms
          if (this.sourceUser === '') {
            this.errorMessage = $("#agent_error_select_a_source_user").val();
            this.error = true;
            this.success = false;
            return;
          }
          if (this.targetUser === '') {
            this.errorMessage = $("#agent_error_select_a_target_user").val();
            this.error = true;
            this.success = false;
            return;
          }
          if (this.targetUser === this.sourceUser ) {
            this.errorMessage = $("#agent_error_different_target_user_and_source_user").val();
            this.error = true;
            this.success = false;
            return;
          }
          if (this.amount === '') {
            this.errorMessage = $("#agent_error_fill_the_amount").val();
            this.error = true;
            this.success = false;
            return;
          }
          if (this.amount < '0') {
            this.errorMessage = $("#agent_error_amount_less_than_0").val();
            this.error = true;
            this.success = false;
            return;
          }
          this.disabled = true;
          this.loading = true;
          this.error = false;
          this.success = false;

          const {
            agentId,
            sourceUser,
            targetUser,
          } = this;

          api.transferBalance(this.sourceUser, this.targetUser,
            toCents(this.amount), this.transferNote).done(res => {
            if (res.errors) {
              console.log('Transfer Error ', res.error);
              this.error = true;
              this.errorMessage = res.errors[0].message;
            }
            else {
              this.sourceUser = '';
              this.targetUser = '';
              this.amount = '';
              this.transferNote = '';
              this.error = false;
              this.loading = true;
              this.success = true;
            }
          }).fail(({ responseJSON: res }) => {
            this.error = true;
            if (res) {
              this.errorMessage = res[0].message;
            }
            else {
              this.errorMessage = __APP__.default_error_message;
            }
          }).always(() => {
            setTimeout(() => this.disabled = false, 1000);
            if (this.success) {
              setTimeout(() => this.success = false, 4000);
            }
            this.loading = false;
          });
        },
      },
      created () {
        if (!document.getElementById('form-agent-transfer-user')) {
          return;
        }

        api.getAgentHierarchyFull().done(res => {
          if (res[0] === false) { //TODO: Temporary fix because platform returns false if there is no parent
            res.shift();
          }
          this.users = res;
        });

        api.getPlayer().done(res => {
          this.currentUser.role = localStorage.getItem('role');
          this.currentUser.agentId = res.user_id;
          this.currentUser.id = res.user_id;
          this.currentUser.username = res.username;
        });

        this.getTranslations();
      },
    });

  /* -----------------------------------------
  Transfer Agent Cash - v2
  ----------------------------------------- */
  const AgentTransferV2 = new Vue({
    el: '.form-agent-transfer-v2',
    components: {
      'v-select': vSelect
    },
    data: {
      sourceUser: '',
      targetUser: '',
      sourceUserInputText: '',
      targetUserInputText: '',
      sourceUserOptions: [],
      targetUserOptions: [],
      amount: '',
      error: '',
      errorMessage: '',
      translations: [],
      errorsTranslations: [],
      transferNote: '',
      transferNoteMax: 250,
      disabled: false,
      loading: false,
      success: false,
      displayMessage: false,
      ctf: __APP__.ctf,
      ctt: __APP__.ctt,
    },
    computed: {
      sourceUserOptions() {
        return this.sourceUserOptions;
      },
      targetUserOptions() {
        return this.targetUserOptions;
      }
    },
    methods: {
      sourceUserInput(value) {
        if( value.length > 2 ) {
          setTimeout(() => {
            this.fetchSearchResults(value, "sourceUserInput");
          }, AGENT_TRANSFER_V2_TYPING_TIMEOUTS);
        }
      },
      targetUserInput(value) {
        if( value.length > 2 ) {
          setTimeout(() => {
            this.fetchSearchResults(value, "targetUserInput");
          }, AGENT_TRANSFER_V2_TYPING_TIMEOUTS);
        }
      },
      fetchSearchResults(value, inputElement) {
          api.searchUserByUsername(value).done(res => {
            if( inputElement === "sourceUserInput" ){
              this.sourceUserOptions = res.users;
              this.sourceUserInputText = value;
            }
            else {
              this.targetUserOptions = res.users;
              this.targetUserInputText = value;
            }
          });
      },
      setAmount (amount) {
        this.amount = amount;
      },
      getTranslations () {
        let translationsArray = [];
        $('#roles_translations span').each(function () {
          translationsArray[$(this).attr('data-id')] = $(this).html();
        });
        this.translations = translationsArray;
        let errorsArray = [];
        $('#errors_translations span').each(function () {
          errorsArray[$(this).attr('data-id')] = $(this).html();
        });
        this.errorsTranslations = errorsArray;

      },
      submit () {
        // When the platform responses with correct errNos and messages then
        // the below lines must be removed TODO: These have to be translated
        // via cms
        if (this.sourceUser === '') {
          this.displayMessage = true;
          this.errorMessage = $("#agent_error_select_a_source_user").val();
          this.error = true;
          this.success = false;
          return;
        }
        if (this.targetUser === '') {
          this.displayMessage = true;
          this.errorMessage = $("#agent_error_select_a_target_user").val();
          this.error = true;
          this.success = false;
          return;
        }
        if (this.targetUser === this.sourceUser ) {
          this.displayMessage = true;
          this.errorMessage = $("#agent_error_different_target_user_and_source_user").val();
          this.error = true;
          this.success = false;
          return;
        }
        if (this.amount === '') {
          this.displayMessage = true;
          this.errorMessage = $("#agent_error_fill_the_amount").val();
          this.error = true;
          this.success = false;
          return;
        }
        if (this.amount < '0') {
          this.displayMessage = true;
          this.errorMessage = $("#agent_error_amount_less_than_0").val();
          this.error = true;
          this.success = false;
          return;
        }
        if (this.amount === '0') {
          this.displayMessage = true;
          this.errorMessage = $("#agent_error_amount_equal_0").val();
          this.error = true;
          this.success = false;
          return;
        }
        this.disabled = true;
        this.loading = false;
        this.error = false;
        this.success = false;
        this.displayMessage = false;

        const {
          agentId,
          sourceUser,
          targetUser,
        } = this;

        api.transferBalance(this.sourceUser, this.targetUser, toCents(this.amount), this.transferNote).done(res => {
          if (res.errors) {
            consoleLog('Transfer Error ', res.error);
            this.displayMessage = true;
            this.error = true;
            this.errorMessage = res.errors[0].message;
          }
          else {
            this.sourceUser = '';
            this.targetUser = '';
            this.amount = '';
            this.transferNote = '';
            this.error = false;
            this.loading = true;
            this.success = true;
          }
        }).fail(({ responseJSON: res }) => {
          this.error = true;
          if (res) {
            this.displayMessage = true;
            this.errorMessage = res[0].message;
          }
          else {
            this.displayMessage = true;
            this.errorMessage = __APP__.default_error_message;
          }
        }).always(() => {
          setTimeout(() => this.disabled = false, SUBMIT_BUTTON_DEACTIVATION_TIMEOUT);
          if (this.success) {
            setTimeout(() => this.success = false, SUCCESS_MESSAGE_TIMEOUT);
          }
          this.loading = false;
        });
      },
    },
    created () {
      if (!document.getElementById('form-agent-transfer-v2')) {
        return;
      }
      this.getTranslations();
    },
  });

    /* -----------------------------------------
    Transfer Agent Cash-In-Hand
    ----------------------------------------- */
    const AgenTransferCashInHandForm = new Vue({
      el: '.form-agent-transfer-user-cash-in-hand',
      data: {
        users: [],
        usernames: [],
        roles: [],
        amount: '',
        error: '',
        errorCode: '',
        sourceUser: '',
        targetUser: '',
        errorMessage: '',
        currentUser: {},
        translations: [],
        errorsTranslations: [],
        disabled: false,
        transferNote: '',
        transferNoteMax: 250,
        loading: false,
        success: false,
        parent: 0,
        self: 1,
      },
      computed: {
        uniqueRoles () {
          let sortedUsers = this.usersSorted;
          /* Find the first and last occurences of role */
          let roles = sortedUsers.map(user => {
            return parseInt(user.role);
          });
          return roles.filter(function (value, index, self) {
            return self.indexOf(value) === index;
          });
        },
        userTree () {
          let that = this;
          let users = [];
          this.users.forEach(user => {
            if (typeof user === 'object') {
              if (typeof (users[user.role]) !== 'object') {
                users[user.role] = [];
              }
              if (user.position == 'parent') {
                this.translations[parseInt(
                  user.role)] = this.translations[this.parent];
              }
              if (user.position == 'self') {
                this.translations[parseInt(
                  user.role)] = this.translations[this.self];
              }
              users[parseInt(user.role)].push({
                'username': user.username,
                'id': parseInt(user.userId),
                'position': user.position,
              });
            }
          }, that);
          return users;
        },
        usersSorted () {
          return this.users.sort((a, b) => {
            return (b.role - a.role) || a.username.localeCompare(b.username);
          });
        },
      },
      mounted () {
      if (!document.getElementById('form-agent-transfer-user-cash-in-hand')) {
          return;
        }

        this.$nextTick(function () {
            let that = this;
            $('#transfer_from').select2().on('change', function () {
              that.sourceUser = this.value;
            });
            $('#transfer_to').select2().on('change', function () {
              that.targetUser = this.value;
            });
          });
      },
      methods: {
        setAmount (amount) {
          this.amount = amount;
        },
        getTranslations () {
          let translationsArray = [];
          $('#roles_translations span').each(function () {
            translationsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.translations = translationsArray;
          let errorsArray = [];
          $('#errors_translations span').each(function () {
            errorsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.errorsTranslations = errorsArray;

        },
        submit () {
          // When the platform responses with correct errNos and messages then
          // the below lines must be removed TODO: These have to be translated
          // via cms
          if (this.sourceUser === '') {
            this.errorMessage = $("#agent_error_select_a_source_user").val();
            this.error = true;
            this.success = false;
            return;
          }
          if (this.targetUser === '') {
            this.errorMessage = $("#agent_error_select_a_target_user").val();
            this.error = true;
            this.success = false;
            return;
          }
          if (this.targetUser === this.sourceUser ) {
            this.errorMessage = $("#agent_error_different_target_user_and_source_user").val();
            this.error = true;
            this.success = false;
            return;
          }
          if (this.amount === '') {
            this.errorMessage = $("#agent_error_fill_the_amount").val();
            this.error = true;
            this.success = false;
            return;
          }
          if (this.amount < '0') {
            this.errorMessage = $("#agent_error_amount_less_than_0").val();
            this.error = true;
            this.success = false;
            return;
          }
          this.disabled = true;
          this.loading = true;
          this.error = false;
          this.success = false;

          const {
            agentId,
            sourceUser,
            targetUser,
          } = this;

          api.agentCashTransfer(this.sourceUser, this.targetUser,
            toCents(this.amount), this.transferNote).done(res => {
            if (res.errors) {
              console.log('Transfer Error ', res.error);
              this.error = true;
              this.errorMessage = this.errorsTranslations[res.errors[0].code];
            }
            else {
              this.sourceUser = '';
              this.targetUser = '';
              this.amount = '';
              this.transferNote = '';
              this.error = false;
              this.loading = true;
              this.success = true;
            }
          }).fail(({ responseJSON: res }) => {
            this.error = true;
            if (res) {
              this.errorCode = res.code;
            }
            else {
              this.errorMessage = __APP__.default_error_message;
            }
          }).always(() => {
            setTimeout(() => this.disabled = false, 1000);
            if (this.success) {
              setTimeout(() => this.success = false, 4000);
            }
            this.loading = false;
          });
        },
      },
      created () {
        if (!document.getElementById('form-agent-transfer-user-cash-in-hand')) {
          return;
        }

        api.getAgentHierarchyFull().done(res => {
          if (res[0] === false) { //TODO: Temporary fix because platform returns false if there is no parent
            res.shift();
          }
          this.users = res;
        });

        api.getPlayer().done(res => {
          this.currentUser.role = localStorage.getItem('role');
          this.currentUser.agentId = res.user_id;
          this.currentUser.id = res.user_id;
          this.currentUser.username = res.username;
        });

        this.getTranslations();
      },
    });

    /* -----------------------------------------
    Agent User Withdraw
    ----------------------------------------- */
    const AgentWithdrawalForm = new Vue({
      el: '.form-agent-withdraw',
      data: {
        amount: '',
        provider: 'APCO',
        methods: '',
        error: '',
        loading: false,
        success: false,
        activeMethod: '',
      },
      methods: {
        submit: function () {
          const {
            amount,
            activeMethod,
          } = this;
          this.loading = true;
          this.success = false;
          this.error = '';
        },
      },
      created () {
        if (!document.getElementById('form-agent-withdraw')) {
          return;
        }
        api.getWithdrawalMethods(this.provider).done(res => this.methods = res);
      },
    });

    /* -----------------------------------------
    Agent Sportsbook Search
    ----------------------------------------- */
    const AgentSearchBet = new Vue({
      el: '.agent-sportsbook-search',
      data: {
        betId: '',
        result: [],
        SportsbookSearchResult: [],
        currency: '',
        columns: [
          'betId',
          'userId',
          'agentId',
          'amount',
          'agentPaid',
          'placedAt',
          'settledAt',
          'settledAmount',
          'canceledAmount',
          'canceledAt',
          'paidOutAt',
          'paidOutAmount',
        ],
        options: {
          headings: {
            'betId': 'Bet Id',
            'userId': 'User Id',
            'agentId': 'Agent Id',
            'amount': 'Amount',
            'agentPaid': 'Agent Paid',
            'placedAt': 'Placed At',
            'settledAt': 'Settled At',
            'settledAmount': 'Settled Amount',
            'canceledAmount': 'Cancelled Amount',
            'canceledAt': 'Cancelled At',
            'paidOutAt': 'Paid Out At',
            'paidOutAmount': 'Paid Out Amount',
          },
        },
      },
      methods: {
        submit () {
          api.getBetDetail(this.betId).done(res => {
            this.result.length = 0;
            this.SportsbookSearchResult = res;
            this.SportsbookSearchResult.amount = formatMoney(res.amount,
              this.currency);
            this.SportsbookSearchResult.settledAmount = formatMoney(
              res.settledAmount, this.currency);
            this.SportsbookSearchResult.canceledAmount = formatMoney(
              res.canceledAmount, this.currency);
            this.SportsbookSearchResult.paidOutAmount = formatMoney(
              res.paidOutAmount, this.currency);

            this.result.push(this.SportsbookSearchResult);
          });
        },
      },
      created () {
        if (!document.getElementById('agent-sportsbook-search')) {
          return;
        }
        api.getPlayer().done(res => {
          this.currency = res.currency;
        });

      },
    });

    /* -----------------------------------------
    Agent Online Deposit
    ----------------------------------------- */
    const AgentOnlineDepositForm = new Vue({
      el: '.agent-deposit-money',
      data: {
        searchUserText: '',
        username: '',
        userId: '',
        userTextEmpty: '',
        amount: '',
        amountEmpty: '',
        amountEmptyError: '',
        amountIntegerError: '',
        currencyMismatch: '',
        currencyMismatchText: 'Currency mismatch',
        insufficientFundsError: '',
        invalidRolePartner: '',
        invalidRoleSuperAgent: '',
        invalidRoleAgent: '',
        invalidRoleCashier: '',
        depositSuccess: '',
        depositError: '',
        notes: '',
        notesMax: 250,
        error: '',
        errorMessage: '',
        errorCode: '',
        loading: false,
        success: false,
        disabled: false,
        userFound: false,
        userNotFound: false,
        active: 'none',
      },
      methods: {
        submit () {
          this.amountEmptyError = false;
          this.amountIntegerError = false;
          this.currencyMismatch = false;
          this.insufficientFundsError = false;
          this.userTextEmpty = false;
          this.invalidRolePartner = false;
          this.invalidRoleSuperAgent = false;
          this.invalidRoleAgent = false;
          this.invalidRoleCashier = false;
          this.error = false;
          this.success = false;
          this.loading = false;
          this.disabled = false;
          this.userNotFound = false;
          this.userFound = false;
          this.active = 'none';

          if (this.searchUserText === '') {
            this.userTextEmpty = true;
            this.active = 'none';
            return;
          }
          else {
              api.searchUser(this.searchUserText).done(res => {
                  this.userId = res.userId;
                  this.username = res.username;
                  this.userFound = true;
                  this.searchUserText = '';
                  this.active = 'block';
                  }).fail(({ responseJSON: res }) => {
                    this.error = true;
                  });
          }
        },
          deposit() {
            this.amountEmptyError = false;
            this.amountIntegerError = false;
            this.insufficientFundsError = false;
            if (this.amount === '') {
              this.amountEmptyError = true;
              return;
            }
            else {
              api.agentDepositMoney(this.userId, toCents(this.amount), this.notes).done(res => {
                if (res.errors) {
                  consoleLog('Deposit Error ', res.error);
                  this.depositError = true;
                  this.errorMessage = res.errors.message;
                }
                else {
                  this.depositSuccess = true;
                  this.depositError = false;
                  this.active = 'none';
                  this.error = false;
                  this.loading = true;
                  this.success = true;
                  this.amount = '';
                  this.notes = '';
                }
              }).fail(({ responseJSON: res }) => {
                this.error = true;
                this.errorMessage = res.errors[0].message;
                if ( this.errorMessage = 'Amount must be an integer.') {
                  this.amountIntegerError = true;
                  this.amountEmptyError = false;
                  this.currencyMismatch = false;
                  this.insufficientFundsError = false;
                  this.error = false;
                  return;
                }
                else if ( this.errorMessage.includes( this.currencyMismatchText ) ) {
                  this.currencyMismatch = true;
                  this.amountIntegerError = false;
                  this.amountEmptyError = false;
                  this.insufficientFundsError = false;
                  this.error = false;
                 return;
               }
                else if ( this.errorMessage == 'Insufficient funds' ) {
                  this.insufficientFundsError = true;
                  this.currencyMismatch = false;
                  this.amountIntegerError = false;
                  this.amountEmptyError = false;
                  this.error = false;
                  return;
                }
                else if ( this.errorMessage == 'Invalid role: 50' ) {
                  this.invalidRolePartner = true;
                  this.error = false;
                  return;
                }
                else if ( this.errorMessage == 'Invalid role: 30' ) {
                  this.invalidRoleSuperAgent = true;
                  this.error = false;
                  return;
                }
                else if ( this.errorMessage == 'Invalid role: 20' ) {
                  this.invalidRoleAgent = true;
                  this.error = false;
                  return;
                }
                else if ( this.errorMessage == 'Invalid role: 15' ) {
                  this.invalidRoleCashier = true;
                  this.error = false;
                  return;
                }
                else {
                  this.errorMessage = __APP__.default_error_message;
                }

            }).always(() => {
              setTimeout(() => this.disabled = false, 1000);
              if (this.success) {
                setTimeout(() => this.success = false, 4000);
                setTimeout(() => this.depositSuccess = false, 4000);
              }
              this.loading = false;
            });

          }
        },
      },
      created () {
        if (!document.getElementById('agent-deposit-money')) {
          return;
        }
      },
    });


      /* -----------------------------------------
  Agent Sportsbook Bets
  ----------------------------------------- */
  const AgentSportsbookBet = new Vue({
    el: '.agent-sportsbook-bets',
    data: {
      betId: $(".urlBetId").val() ? $(".urlBetId").val() : '',
      betIdCoupon: '',
      errorName: '',
      errorMessage: '',
      amount: '',
      alreadyPaidOutMsg: '',
      errorCustomMessage: '',
      error: '',
      payoutError: '',
      payoutSuccess: '',
      disabled: false,
      loading: false,
      result: [],
      eventCount: '',
      settledAmount: '',
      canceledAmount: '',
      display: false,
      betType: '',
      betStatus: '',
      betDetail: [],
      events: '',
      markets: '',
      eventValue: [],
      eventDate: [],
      eventTime: [],
      market: [],
      outcome: [],
      odds: [],
      betStake: '',
      winnings: '',
      paidOutAt: '',
      canceledAt: '',
      settledAt: '',
      isPayable: '',
      stringsTranslations: {},
      color: '',
      disableButton: false,
      currency: '',
      placedAt: '',
    },
    computed: {},
    methods: {
      betDetailDone (res) {
        this.betDetail = [];
        this.eventValue = [];
        this.events = [];
        this.markets = [];
        this.error = false;
        this.payoutError = false;
        this.result = res;
        this.betIdCoupon = res.betId;
        this.settledAmount = res.settledAmount;
        this.canceledAmount = res.canceledAmount;
        this.amount = formatMoney(res.amount, this.currency);
        this.paidOutAt = res.paidOutAt;
        this.canceledAt = res.canceledAt;
        this.settledAt = res.settledAt;
        this.isPayable = res.isPayable;
        this.placedAt = res.placedAt;

        this.eventCount = this.result.details.EventCount['@attributes'].Value;

        this.betDetail.push(this.result);
        this.betDetail = this.betDetail.forEach(item => {
          if (typeof item.details.EventList.Event === 'object' &&
            this.eventCount == '1') {
            this.events.push(item.details.EventList.Event);
          }
          else if (this.eventCount > '1') {
            this.events = item.details.EventList.Event;
          }
          this.events.forEach(function (item) {
            item.eventValue = item['@attributes'].Value;
            item.eventDate = item.EventDate['@attributes'].Value.split(' ');
            item.eventTime = item.eventDate[1];
            item.eventDate = new Date(item.eventDate[0]);
            item.month = item.eventDate.getMonth() + 1;
            item.day = item.eventDate.getDate();
            item.year = item.eventDate.getFullYear();
            item.markets = [];
            if (!Array.isArray(item.Market)) {
              item.markets.push(item.Market);
            }
            else if (Array.isArray(item.Market)) {
              item.markets = item.Market;
            }
            item.markets.forEach(function (market) {
              market.market = market['@attributes'].Value;
              market.outcome = market.Outcome['@attributes'].Value;
              market.odds = formatAmount(market.Odds['@attributes'].Value);
              market.eventValue = item.eventValue;
              market.eventDate = item.EventDate['@attributes'].Value.split(' ');
              market.eventTime = market.eventDate[1];
              market.eventDate = new Date(market.eventDate[0]);
              market.month = market.eventDate.getMonth() + 1;
              market.day = market.eventDate.getDate();
              market.year = market.eventDate.getFullYear();
            });
          });
        });

        if (this.isPayable) {
          this.display = true;
          this.payoutSuccess = false;
        }
        else if (!this.isPayable) {
          this.display = false;
        }

        if (this.result.details.EventCount['@attributes'].Value == '1' &&
          this.result.details.IsSystem['@attributes'].Value == 'false') {
          this.betType = this.stringsTranslations.betType.single;
        }
        else if (this.result.details.EventCount['@attributes'].Value == '1' &&
          this.result.details.IsSystem['@attributes'].Value == 'true') {
          this.betType = this.stringsTranslations.betType.system;
        }
        else if (this.result.details.EventCount['@attributes'].Value > '1' &&
          this.result.details.IsSystem['@attributes'].Value == 'false') {
          this.betType = this.stringsTranslations.betType.multiple;
        }
        let isOpen = false;
        let isVoid = false;
        if (this.paidOutAt != null) {
          this.betStatus = this.stringsTranslations.betStatus.paidOut;
          this.color = 'dimgray';
        }
        else if (this.canceledAt != null) {
          this.betStatus = this.stringsTranslations.betStatus.void;
          isVoid = true;
          this.color = 'dimgray';
        }
        else if (this.settledAt === null && this.canceledAt === null) {
          this.betStatus = this.stringsTranslations.betStatus.open;
          isOpen = true;
          this.color = 'dimgray';
        }
        else if (this.settledAt != null && parseInt(this.settledAmount) == 0) {
          this.betStatus = this.stringsTranslations.betStatus.lost;
          this.color = 'bet-title-red';
        }
        else if (this.settledAt != null && parseInt(this.settledAmount) > 0) {
          this.betStatus = this.stringsTranslations.betStatus.won;
          this.color = 'bet-title-green';
        }

        this.betStake = formatMoney(
          this.result.details.BetStake['@attributes'].Value, this.currency);
        if (isOpen === true) {
          this.winnings = formatMoney(
            this.result.details.BetStake.Winnings['@attributes'].Value,
            this.currency);
        }
        else if (isVoid == true) {
          this.winnings = formatMoney(this.result.canceledAmount,
            this.currency);
        }
        else {
          this.winnings = formatMoney(this.result.settledAmount, this.currency);
        }
      },
      getTranslations () {
        let strings = {};
        $('#strings_translations span').each(function () {
          if (typeof strings[$(this).attr('data-cat')] !== 'object') {
            strings[$(this).attr('data-cat')] = {};
          }
          strings[$(this).attr('data-cat')][$(this).attr('data-id')] = $(this).
            html();
        });
        this.stringsTranslations = strings;
      },
      submit () {
        this.disableButton = true;
        this.error = false;
        this.payoutError = false;
        this.payoutSuccess = false;

        api.getBetDetail(this.betId).done(res => {
          this.betDetailDone(res);
        }).fail(({ responseJSON: res }) => {
          this.error = true;
          this.payoutError = false;
          if (res.errors) {
            this.errorMessage = res.errors[0].message;
          }
          else {
            this.result.length = 0;
            this.errorName = res.name;
          }
        })
        .always(() => this.disableButton = false);
      },
      payout () {
        this.disabled = true;
        this.loading = true;

        api.betPayout(this.betId).done(res => {
          this.payoutSuccess = true;
          this.display = false;
          api.getBetDetail(this.betId).done(res => {
            let self = this;
            this.betDetailDone(res);
            setTimeout(function () {
              self.payoutSuccess = false;
            }, 3000);
          }).fail(({ responseJSON: res }) => {
            this.error = true;
            this.payoutError = false;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            }
            else {
              this.result.length = 0;
              this.errorName = res.name;
            }
          });
        }).fail(({ responseJSON: res }) => {
          this.error = false;
          this.payoutError = true;
          this.payoutSuccess = false;
          if (res.errors) {
            this.errorMessage = res.errors[0].message;
          }
          else {
            this.alreadyPaidOutMsg = this.errorMessage.indexOf(
              'is already paid out');
            if (this.alreadyPaidOutMsg > 0) {
              this.payoutSuccess = false;
              this.errorMessage = 'Bet already paid out';
            }
            else {
              this.errorMessage = res.message;
            }
          }
        }).always(() => {   
          setTimeout(() => this.loading = false, 1000);
          setTimeout(() => this.disabled = false, 1000);
        });
      },
    },

    created () {
      if (!document.getElementById('agent-sportsbook-bets')) {
        return;
      }
      this.currency = localStorage.getItem('currency');

      this.getTranslations();

      if (this.betId) {
        this.submit();
      }

    },
  });

    /* -----------------------------------------
   Agent Online Withdrawal
   ----------------------------------------- */
    const AgentOnlineWithdrawalForm = new Vue({
      el: '.form-agent-payment-withdrawal',
      data: {
        withdrawalsList: [],
        withdrawalCode: [],
        tableHeadings: [],
        result: [],
        error: '',
        errorMessage: '',
        success: '',
        payoutSuccess: '',
        cancelSuccess: '',
        columns: [
          'withdrawalId',
          'username',
          'amount',
          'currency',
          'withdrawalCode',
          'action',
          'created',
        ],
        options: {
          perPage: 50,
          headings: {
            'withdrawalId': function (h) {
                return this.tableHeadings.withdrawalId;
              },
              'username': function (h) {
                return this.tableHeadings.username;
              },
              'amount': function (h) {
                return this.tableHeadings.amount;
              },
              'currency': function (h) {
                return this.tableHeadings.currency;
              },
              'withdrawalCode': function (h) {
                return this.tableHeadings.withdrawalCode;
              },
              'action': function (h) {
                return this.tableHeadings.action;
              },
              'created': function (h) {
                return this.tableHeadings.created;
              },
          },
        },
      },
      methods: {
        submit () {
          this.error = false;
          this.success = false;
          this.payoutSuccess = false;
          this.cancelSuccess = false;
        },
        getList: function() {
          api.getAgentWithdrawalList().done(res => {
            if (res[0] === false) { //TODO: Temporary fix because platform returns false if there is no parent
              res.shift();
            }
            this.withdrawalsList = res.map(withdrawalList => {
              return {
                'withdrawalId': withdrawalList.withdrawalId,
                'username': withdrawalList.username,
                'amount': formatMoney(withdrawalList.amount, this.currency),
                'currency': withdrawalList.currency,
                'created': withdrawalList.created,
              };
            });
          });
        },
        payout (withdrawalId) {
          this.withdrawalId = withdrawalId;
          api.agentPayoutWithdrawal(withdrawalId, this.withdrawalCode[withdrawalId]).done(res => {
            if (res.errors) {
              consoleLog('Withdrawal Payout Error ', res.error);
              this.error = true;
              this.success = false;
              this.errorMessage = res.errors[0].message;
            }
            else {
              this.error = false;
              this.success = true;
              this.payoutSuccess = true;
              this.getList();
            }
          }).fail(({ responseJSON: res }) => {
            this.error = true;
            this.errorMessage = res[0].message;
          });
        },
        cancel (withdrawalId) {
          this.withdrawalId = withdrawalId;
          api.agentCancelWithdrawal(withdrawalId, this.withdrawalCode[withdrawalId]).done(res => {
            this.error = true;
            if (res.errors) {
              consoleLog('Withdrawal Cancel Error ', res.error);
              this.error = true;
              this.success = false;
              this.errorMessage = res.errors[0].message;
            }
            else {
              this.error = false;
              this.success = true;
              this.cancelSuccess = true;
              this.getList();
            }
          }).fail(({ responseJSON: res }) => {
            this.error = true;
            this.errorMessage = res[0].message;
          });
        },
        getTranslations () {
          let tableHeadingsObj = {};
          $('#table_headings_translations span').each(function () {
            tableHeadingsObj[$(this).attr('data-name')] = $(this).html();
          });
          this.tableHeadings = tableHeadingsObj;
        },
      },
      created() {
        if (!document.getElementById('form-agent-payment-withdrawal')) {
          return;
        }
        this.getTranslations();
        this.getList();
      }
    });

  /* -----------------------------------------
      Agent User Deposit
      ----------------------------------------- */
      const AgentDepositForm = new Vue({
        el: '.form-agent-deposit',
        data: {
          amount: '',
          provider: 'APCO',
          methods: '',
          error: '',
          loading: false,
          success: false,
          activeMethod: '',
          bonuses: '',
          bonusId: '',
          bonusCategory: 'BIA',
        },
        methods: {
          submit: function () {
            const {
              amount,
              activeMethod,
              bonusId,
            } = this;
            this.loading = true;
            this.success = false;
            this.error = '';

          },
        },
        created () {
          if (!document.getElementById('form-agent-deposit')) {
            return;
          }

          api.getDepositMethods(this.provider).done(res => {
            this.methods = res;
            this.activeMethod = res[0];
          });
        },
      });

  /* -----------------------------------------
    Agent Sportsbook Report
    ----------------------------------------- */
    const AgentSportsbookReport = new Vue({
      el: '.agent-sportsbook-report',
      data: {
        users: [],
        statuses: [],
        paidStatuses: [],
        types: [],
        selections: [],
      },
      methods: {},
      created () {
        if (!document.getElementById('agent-sportsbook-report')) {
          return;
        }
        //Populate the arrays. These are not correct API calls.
        //The values either have to be hardcoded or fetched through new API calls
        // but this is the general idea.

        //Get Users
        // api.getAgentUsers()
        //   .done(res => {
        //     this.users = res;
        //   });
        //
        // //Get Status
        // api.getAgentStatuses()
        //   .done(res => {
        //     this.statuses = res;
        //   });
        //
        // //Get Paid Statuses
        // api.getPaidStatusesTypes()
        //   .done(res => {
        //     this.paidStatuses = res;
        //   });
        //
        // //Get Bet Types
        // api.getAgentTypes()
        //   .done(res => {
        //     this.types = res;
        //   });
        //
        // //Get Selections (?)
        // api.getAgentSelections()
        //   .done(res => {
        //     this.selections = res;
        //   });
      },
    });

  /* -----------------------------------------
  Agent Sportsbook Report New
  ----------------------------------------- */
  const AgentCasinoReportNew = new Vue({
    el: '.agent-sportsbook-report-new',
    data: {
      activeBtn: 'week',
      searchBetsColumns: [
        'username',
        'parentName',
        'betId',
        'createdAt',
        'settledAt',
        'amount',
        'settledAmount',
        'status',
        'action',
      ],
      generateReportColumns: [
        'date',
        'count',
        'amount',
        'settledAmount',
        'revenue',
        'margin',
      ],
      displaySearch: false,
      displayReport: false,
      reports: {},
      error: '',
      disableButton: false,
      errorMessage: '',
      fromDate: '',
      toDate: '',
      createdFrom: '',
      createdTo: '',
      settledFrom: '',
      settledTo: '',
      currentPage: 1,
      currentReportPage: 1,
      totalPages: '',
      totalReports: '',
      page: '',
      activePage: 1,
      reportPage: '',
      searchSize: 20,
      reportSize: 20,
      subagents: '',
      clients: '',
      status: '',
      action: '',
      paidout: '',
      betmode: '',
      selections: '',
      fn: '',
      picked: 'date_created',
      totalAmountPerPage: 0,
      totalSettledAmountPerPage: 0,
      totalAmountOverall: 0,
      totalSettledAmountOverall: 0,
      totalCountOverall: 0,
      totalRevenueOverall: 0,
      totalMarginOverall: 0,
      translateStatusNumber: {
        '0': $("#agent_status_open").val(),
        '1': $("#agent_status_won").val(),
        '2': $("#agent_status_lost").val(),
        '3': $("#agent_status_cancelled").val(),
      },
      searchBetsTableOptions: {
        headings: {
          'username': function (h) {
            return this.tableHeadings.username;
          },
          'parentName': function (h) {
            return this.tableHeadings.parentName;
          },
          'betId': function (h) {
            return this.tableHeadings.betId;
          },
          'createdAt': function (h) {
            return this.tableHeadings.createdAt;
          },
          'settledAt': function (h) {
            return this.tableHeadings.settledAt;
          },
          'amount': function (h) {
            return this.tableHeadings.amount;
          },
          'settledAmount': function (h) {
            return this.tableHeadings.settledAmount;
          },
          'status': function (h) {
            return this.tableHeadings.status;
          },
          'action': function (h) {
            return this.tableHeadings.action;
          },
        },
      },
        generateReportOptions: {
          filterable: false,
          headings: {
            'date': function (h) {
              return this.tableHeadingsReport.date;
            },
            'count': function (h) {
              return this.tableHeadingsReport.count;
            },
            'amount': function (h) {
              return this.tableHeadingsReport.amount;
            },
            'settledAmount': function (h) {
              return this.tableHeadingsReport.settledAmount;
            },
            'revenue': function (h) {
              return this.tableHeadingsReport.revenue;
            },
            'margin': function (h) {
              return this.tableHeadingsReport.margin;
            },
          },
     },
     searchResults: [],
     perPage: [],
     overall: [],
     generateReportResults: [],
     stringsTranslations: [],
     stringstranslationsReport: [],
     statusTranslations: [],
      unfilteredResult: [],
    },
    methods: {
      showReports(selectedPage='') {
        this.currentPage = selectedPage > 1 ? selectedPage : 1;
        this.reports = 0;
        this.displaySearch = true;
        this.displayReport = false;
        this.error = '';
        this.getParams();
        const {
          pageSize=this.searchSize,
          } = this;
          this.disableButton = true;
          api.searchBettingReport(reverseDateFormat(this.createdFrom), reverseDateFormat(this.createdTo), reverseDateFormat(this.settledFrom), reverseDateFormat(this.settledTo), this.status, this.currentPage, pageSize)
        .done((res) => {
          let that = this;
          this.showReport = true;
          res.list.length > 0 ? this.reports = res : this.reports=0;
          this.currentPage = res.pagination.currentPage;
          this.totalPages = res.pagination.pageCount;
          this.totalAmountPerPage = formatMoney(res.summary.page.amount, this.currency);
          this.totalSettledAmountPerPage = formatMoney(res.summary.page.settledAmount, this.currency);
          this.totalAmountOverall = formatMoney(res.summary.overall.amount, this.currency);
          this.totalSettledAmountOverall = formatMoney(res.summary.overall.settledAmount, this.currency);
          this.totalCountOverall = res.pagination.totalCount;

          this.searchResults = res.list.map(item => {
            return {
              'username': item.username,
              'parentName': item.parentName,
              'betId': item.betId,
              'createdAt': item.createdAt,
              'settledAt': item.settledAt,
              'amount': formatMoney(item.amount, this.currency),
              'settledAmount': formatMoney(item.settledAmount, this.currency),
              'status': this.getTranslationFromStatus(this.getStatus(item.status)),
            };
          }, that);
        })
        .fail((error) => {
          consoleLog(error);
          this.error = true;
          this.success = false;
        })
        .always(() => {
          this.disableButton = false;
          addSticky('th');
        })
    },

    goToPage(selectedPage) {
      this.showReports(selectedPage);
    },

    goToReportPage(selectedPage) {
      this.generate(selectedPage);
    },

    sortResults() {
      this.showReports();
    },

    sortReportResults() {
      this.generate();
    },

    getStatus( status ) {
      if ( status == 'open') {
      return 0;
      } else if ( status == 'won') {
      return 1;
      } else if ( status == 'lost') {
      return 2;
      } else if ( status == 'canceled') {
      return 3;
      }
   },

   getTranslationFromStatus(status) {
     if (typeof this.translateStatusNumber[status] === 'string') {
       return this.translateStatusNumber[status];
     }
     return status;
   },

      getParams() {
        if (this.picked == 'date_created') {
          this.createdFrom = this.fromDate;
          this.createdTo = this.toDate;
          this.settledFrom = '';
          this.settledTo = '';
        }
        else if (this.picked == 'date_settled') {
          this.createdFrom = '';
          this.createdTo = '';
          this.settledFrom = this.fromDate;
          this.settledTo = this.toDate;
        }
      },
      getTranslations () {
        let statusTranslations = {};
        $('#status_translations span').each(function () {
          statusTranslations[$(this).attr('data-id')] = $(this).html();
        });
        this.tableStatusHeadings = statusTranslations;

        let tableHeadingsObj = {};
        $('#table_headings_translations span').each(function () {
          tableHeadingsObj[$(this).attr('data-name')] = $(this).html();
        });
        this.tableHeadings = tableHeadingsObj;

        let stringsArrayReport = [];
        $('#strings_translations_report span').each(function () {
          stringsArrayReport[$(this).attr('data-id')] = $(this).html();
        });
        this.stringstranslationsReport = stringsArrayReport;

        let tableHeadingsObjReport = {};
        $('#table_headings_translations_report span').each(function () {
          tableHeadingsObjReport[$(this).attr('data-name')] = $(this).html();
        });
        this.tableHeadingsReport = tableHeadingsObjReport;
      },

      generate (selectedPage='') {
        this.currentReportPage = selectedPage > 1 ? selectedPage : 1;
        this.reports = 0;
        this.displaySearch = false;
        this.displayReport = true;
        this.error = '';
        this.getParams();
        const {
          page_size=this.reportSize,
          } = this;
          this.disableButton = true;
          api.generateBettingReport(reverseDateFormat(this.createdFrom), reverseDateFormat(this.createdTo), reverseDateFormat(this.settledFrom), reverseDateFormat(this.settledTo), this.status, this.currentReportPage, page_size).
        done(res => {
          let that = this;
          this.error = false;
          this.currentReportPage = res.pagination.currentPage;
          this.totalReports = res.pagination.pageCount;
          this.totalCountOverall = res.summary.overall.count;
          this.totalAmountOverall = formatMoney(res.summary.overall.amount, this.currency);
          this.totalSettledAmountOverall = formatMoney(res.summary.overall.settledAmount, this.currency);
          this.totalRevenueOverall = formatMoney(res.summary.overall.revenue, this.currency);
          this.totalMarginOverall = res.summary.overall.margin;

          this.generateReportResults = res.list.map(item => {
            return {
              'date': item.date,
              'count': item.count,
              'amount': formatMoney(item.amount, this.currency),
              'settledAmount': formatMoney(item.settledAmount, this.currency),
              'revenue': formatMoney(item.revenue, this.currency),
              'margin': item.margin
            };
          }, that);
        }).
        fail(({ responseJSON: res }) => {
          this.error = true;
          if (res.errors) {
            this.errorMessage = res.errors[0].message;
          }
        })
        .always(() => {this.disableButton = false});
      },

    },

    created () {
      if (!document.getElementById('agent-sportsbook-report-new')) {
        return;
      }

      setDate('week', this);

      this.getTranslations();
      this.fn = formatMoney;
    },
    mounted () {
      if (!document.getElementById('agent-sportsbook-report-new')) {
        return;
      }

      // Initialize datepickers
      const that = this;
      const $startDate = $(this.$refs.fromDate);
      const $endDate = $(this.$refs.toDate);

      $startDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate, date) {
          that.fromDate = formattedDate;
          $endDate.datepicker().data('datepicker').update('minDate', date);
        },
      });

      $endDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate) {
          that.toDate = formattedDate;
        },
      });
    },
  });

  /* -----------------------------------------
    Agent Casino Report
    ----------------------------------------- */
    const AgentCasinoReport = new Vue({
      el: '.agent-casino-report',
      data: {
        activeBtn: 'week',
        agentId: '',
        columns: [
          'username',
          'role',
          'rounds',
          'totalStakes',
          'totalWinnings',
          'totalResultAmount'
        ],
        currency: '',
        currentUser: '',
        error: '',
        errorMessage: '',
        fn: '',
        disableButton: false,
        loading: false,
        fromDate: '',
        options: {
          customSorting: {
            totalStakes: function (ascending) {
              return function (a, b) {
                var amountA = parseFloat(a.totalStakes.split(' ')[1]);
                var amountB = parseFloat(b.totalStakes.split(' ')[1]);

                if (ascending) {
                  return amountA >= amountB ? 1 : -1;
                }

                return amountA <= amountB ? 1 : -1;
              };
            },
            totalWinnings: function (ascending) {
              return function (a, b) {
                var amountA = parseFloat(a.totalWinnings.split(' ')[1]);
                var amountB = parseFloat(b.totalWinnings.split(' ')[1]);

                if (ascending) {
                  return amountA >= amountB ? 1 : -1;
                }

                return amountA <= amountB ? 1 : -1;
              };
            },
            totalResultAmount: function (ascending) {
              return function (a, b) {
                var amountA = parseFloat(a.totalResultAmount.split(' ')[1]);
                var amountB = parseFloat(b.totalResultAmount.split(' ')[1]);

                if (ascending) {
                  return amountA >= amountB ? 1 : -1;
                }

                return amountA <= amountB ? 1 : -1;
              };
            },
          },
          headings: {
            'username': function (h) {
              return this.tableHeadings.username;
            },
            'role': function (h) {
              return this.tableHeadings.role;
            },
            'rounds': function (h) {
              return this.tableHeadings.rounds;
            },
            'totalStakes': function (h) {
              return this.tableHeadings.totalStakes;
            },
            'totalWinnings': function (h) {
              return this.tableHeadings.totalWinnings;
            },
            'totalResultAmount': function (h) {
              return this.tableHeadings.totalResultAmount;
            },
          },
          texts: {
            noResults: " ",
          }
        },
        parent: 0,
        result: [],
        self: 1,
        stringsTranslations: [],
        toDate: '',
        totals: {
          'rounds': 0,
          'stakes': 0,
          'winnings': 0,
          'results': 0,
        },
        translations: [],
        unfilteredResult: [],
        users: [],
      },
      computed: {
        uniqueRoles () {
          let sortedUsers = this.usersSorted;
          /* Find the first and last occurences of role */
          let roles = sortedUsers.map(user => {
            return parseInt(user.role);
          });
          return roles.filter(function (value, index, self) {
            return self.indexOf(value) === index;
          });
        },
        userTree () {
          let that = this;
          let users = [];
          this.users.forEach(user => {
            if (typeof user === 'object') {
              if (typeof (users[user.role]) !== 'object') {
                users[user.role] = [];
              }
              if (user.position == 'parent') {
                this.translations[parseInt(
                  user.role)] = this.translations[this.parent];
              }
              if (user.position == 'self') {
                this.translations[parseInt(
                  user.role)] = this.translations[this.self];
              }
              users[parseInt(user.role)].push({
                'username': user.username,
                'id': parseInt(user.userId),
                'position': user.position,
              });
            }
          }, that);
          const {
            translations,
          } = this;
          return users;
        },
        usersSorted () {
          return this.users.sort((a, b) => {
            return (b.role - a.role) || a.username.localeCompare(b.username);
          });
        },
      },
      methods: {
        setSelfDate (from) {
          this.activeBtn = from;
          setDate(from, this);
        },
        submit () {
          this.disableButton = true;
          this.error = '';
          this.loading = true;
          this.options.texts.noResults = '';
          api.casinoReport(this.currentUser, reverseDateFormat(this.fromDate), reverseDateFormat(this.toDate)).done(res => {
            if (res.length > 0) {
              this.disableButton = false;
              this.totals.rounds = 0;
              this.totals.stakes = 0;
              this.totals.winnings = 0;
              this.error = false;
              let that = this;
              this.result = res.map(item => {
                this.totals.rounds = this.totals.rounds +
                  parseInt(item.numberOfRounds);
                this.totals.stakes = this.totals.stakes +
                  parseInt(item.totalStakes);
                this.totals.winnings = this.totals.winnings +
                  parseInt(item.totalWinnings);
                this.totals.results = this.totals.stakes - this.totals.winnings;
                return {
                  'username': item.username + ' (id: ' + item.userId + ')',
                  'role': this.getUserRole(item.userId),
                  'rounds': item.numberOfRounds,
                  'totalStakes': formatMoney(item.totalStakes, this.currency),
                  'totalWinnings': formatMoney(item.totalWinnings, this.currency),
                  'totalResultAmount': formatMoney(item.totalStakes - item.totalWinnings,this.currency),
                };
              }, that);
            }
            else {
              this.options.texts.noResults = $("#no_matching_records").val();
            }  
          }).fail(({responseJSON: res}) => {
            this.disableButton = false;
            this.error = true;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            }
          })
          .always(() => {
            this.disableButton = false;
            this.loading = false;
            addSticky('th');
          });
        },
        getUserRole (id) {
          let returnVal = '';
          for (let user of this.users) {
            if (parseInt(user.userId) == parseInt(id)) {
              returnVal = this.translations[parseInt(user.role)];
              break;
            }
          }
          return returnVal;
        },
        getTranslations () {
          let translationsArray = [];
          $('#roles_translations span').each(function () {
            translationsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.translations = translationsArray;
          let stringsArray = [];
          $('#strings_translations span').each(function () {
            stringsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.stringsTranslations = stringsArray;
          let tableHeadingsObj = {};
          $('#table_headings_translations span').each(function () {
            tableHeadingsObj[$(this).attr('data-name')] = $(this).html();
          });
          this.tableHeadings = tableHeadingsObj;
        },
      },
      created () {
        if (!document.getElementById('agent-casino-report')) {
          return;
        }

        setDate('week', this);

        api.getPlayer().done(res => {
          this.currency = res.currency;
          this.currentUser = res.user_id;
        });

        api.getAgentHierarchyFull().done(res => {
          if (res[0] === false) { //TODO: Temporary fix because platform returns false if there is no parent
            res.shift();
          }
          this.users = res;
        });

        this.getTranslations();
        this.fn = formatMoney;
      },
      mounted () {
        if (!document.getElementById('agent-casino-report')) {
          return;
        }

        // Initialize datepickers
        const that = this;
        const $startDate = $(this.$refs.fromDate);
        const $endDate = $(this.$refs.toDate);

        $startDate.datepicker({
          language: setDefaultLanguage(__APP__.langShort),
          dateFormat: 'dd-mm-yyyy',
          maxDate: new Date(),
          onSelect (formattedDate, date) {
            that.fromDate = formattedDate;
            $endDate.datepicker().data('datepicker').update('minDate', date);
          },
        });

        $endDate.datepicker({
          language: setDefaultLanguage(__APP__.langShort),
          dateFormat: 'dd-mm-yyyy',
          maxDate: new Date(),
          onSelect (formattedDate) {
            that.toDate = formattedDate;
          },
        });

        this.$nextTick(function () {
            let that = this;
            $('#financial_transactions_select').select2().on('change', function () {
              that.currentUser = this.value;
          });
          });
      },
    });

  /* -----------------------------------------
     Agent Financial Report
     ----------------------------------------- */
     const AgentFinancialReport = new Vue({
      el: '.agent-financial-report',
      data: {
        agentId: '',
        users: [],
        currentUser: '',
        currency: '',
        totalAmount: 0,
        error: '',
        errorMessage: '',
        activeBtn: 'week',
        fromDate: '',
        toDate: '',
        fn: '',
        loading: false,
        disableButton: false,
        roleTranslations: [],
        stringsTranslations: [],
        tableHeadings: {},
        totalsResults: 0,
        totals: {
          'deposit': 0,
          'withdraw': 0,
          'result': 0,
        },
        result: [],
        columns: [
          'username',
          'role',
          'totalDepositAmount',
          'totalWithdrawalAmount',
          'totalResultAmount',
        ],
        options: {
          customSorting: {
            totalDepositAmount: function (ascending) {
              return function (a, b) {
                var amountA = parseFloat(a.totalDepositAmount.split(' ')[1]);
                var amountB = parseFloat(b.totalDepositAmount.split(' ')[1]);

                if (ascending) {
                  return amountA >= amountB ? 1 : -1;
                }

                return amountA <= amountB ? 1 : -1;
              };
            },
            totalWithdrawalAmount: function (ascending) {
              return function (a, b) {
                var amountA = parseFloat(a.totalWithdrawalAmount.split(' ')[1]);
                var amountB = parseFloat(b.totalWithdrawalAmount.split(' ')[1]);

                if (ascending) {
                  return amountA >= amountB ? 1 : -1;
                }

                return amountA <= amountB ? 1 : -1;
              };
            },
            totalResultAmount: function (ascending) {
              return function (a, b) {
                var amountA = parseFloat(a.totalResultAmount.split(' ')[1]);
                var amountB = parseFloat(b.totalResultAmount.split(' ')[1]);

                if (ascending) {
                  return amountA >= amountB ? 1 : -1;
                }

                return amountA <= amountB ? 1 : -1;
              };
            },
          },
          headings: {
            'username': function (h) {
              return this.tableHeadings.username;
            },
            'role': function (h) {
              return this.tableHeadings.role;
            },
            'totalDepositAmount': function (h) {
              return this.tableHeadings.totalDepositAmount;
            },
            'totalWithdrawalAmount': function (h) {
              return this.tableHeadings.totalWithdrawalAmount;
            },
            'totalResultAmount': function (h) {
              return this.tableHeadings.totalResultAmount;
            },
          },
          texts: {
            noResults: " ",
          }
        },
      },
      methods: {
        setSelfDate (from) {
          this.activeBtn = from;
          setDate(from, this);
        },
        getTranslations () {
          let translationsArray = [];
          $('#roles_translations span').each(function () {
            translationsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.translations = translationsArray;
          let stringsArray = [];
          $('#strings_translations span').each(function () {
            stringsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.stringsTranslations = stringsArray;
          let tableHeadingsObj = {};
          $('#table_headings_translations span').each(function () {
            tableHeadingsObj[$(this).attr('data-name')] = $(this).html();
          });
          this.tableHeadings = tableHeadingsObj;
        },
        getUserRole (id) {
          let returnVal = '';
          for (let user of this.users) {
            if (parseInt(user.userId) == parseInt(id)) {
              returnVal = this.translations[parseInt(user.role)];
              break;
            }
          }
          return returnVal;
        },
        submit () {
          this.disableButton = true;
          this.loading = true;
          this.options.texts.noResults = '';
          api.financialReport(this.agentId, reverseDateFormat(this.fromDate), reverseDateFormat(this.toDate)).
          done(res=> {
            if (res.length > 0) {
              this.totals.deposit = 0;
              this.totals.withdraw = 0;
              let that = this;
              this.error = false;
              this.result = res.map(item => {
                this.totals.deposit = this.totals.deposit +
                    parseInt(item.totalDepositAmount);
                this.totals.withdraw = this.totals.withdraw +
                    parseInt(item.totalWithdrawalAmount);
                this.totals.results = this.totals.deposit - this.totals.withdraw ;
                return {
                  'username': item.username + ' (id: ' + item.userId + ')',
                  'role': this.getUserRole(item.userId),
                  'totalDepositAmount': formatMoney(item.totalDepositAmount,
                      this.currency),
                  'totalWithdrawalAmount': formatMoney(item.totalWithdrawalAmount,
                      this.currency),
                  'totalResultAmount': formatMoney(item.totalDepositAmount - item.totalWithdrawalAmount,
                      this.currency),
                };
              }, that);
            }
            else {
              this.options.texts.noResults = $("#no_matching_records").val();
            }  
          }).
          fail(({ responseJSON: res }) => {
            this.disableButton = false;
            this.error = true;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            }
          })
            .always(() => {
              this.disableButton = false;
              this.loading = false;
              addSticky('th');
            });
        },
      },
      created () {
        if (!document.getElementById('agent-financial-report')) {
          return;
        }

        setDate('week', this);

        api.getPlayer().done(res => {
          this.agentId = res.user_id;
          this.currentUser = res.user_id;
          this.currency = res.currency;
        });

        api.getAgentHierarchyFull().done(res => {
          if (res[0] === false) { //TODO: Temporary fix because platform returns false if there is no parent
            res.shift();
          }
          this.users = res;
        });

        this.getTranslations();
        //Pass formatMoney to View for use in data tables vue slots
        this.fn = formatMoney;
      },
      mounted () {
        if (!document.getElementById('agent-financial-report')) {
          return;
        }

        // Initialize datepickers
        const that = this;
        const $startDate = $(this.$refs.fromDate);
        const $endDate = $(this.$refs.toDate);

        $startDate.datepicker({
          language: setDefaultLanguage(__APP__.langShort),
          dateFormat: 'dd-mm-yyyy',
          maxDate: new Date(),
          onSelect (formattedDate, date) {
            that.fromDate = formattedDate;
            $endDate.datepicker().data('datepicker').update('minDate', date);
          },
        });

        $endDate.datepicker({
          language: setDefaultLanguage(__APP__.langShort),
          dateFormat: 'dd-mm-yyyy',
          maxDate: new Date(),
          onSelect (formattedDate) {
            that.toDate = formattedDate;
          },
        });
      },
    });

  /* -----------------------------------------
  Agent New Financial Report
  ----------------------------------------- */
  const AgentNewFinancialReport = new Vue({
    el: '.agent-new-financial-report',
    data: {
      activeBtn: 'week',
      currency: '',
      filters: [],
      fn: '',
      displaySearch: false,
      error: '',
      errorMessage: '',
      fromDate: '',
      toDate: '',
      createdFrom: '',
      createdTo: '',
      loggedInRole: __APP__.agentRole,
      username: '',
      userId: '',
      constantLoggedInId: 0,
      constantPartnerId: 0,
      constantSuperAgentId: 0,
      constantAgentId: 0,
      status: '',
      loading: false,
      totalPages: 0,
      activePage: 0,
      pageSize: 20,
      page: '',
      headingRole: '',
      headingUserName: '',
      headingDeposit: '',
      headingWithdrawal: '',
      headingTotalResultAmount: '',
      searchResults: [],
      tempSearchResults: [],
      userHierarchy: [],
      subrows: [],
      subrows2: [],
      subrows3: [],
      subUserId: 0,
      showFooterTotals: false,
      totalPageResults: [],
      totalOverallResults: [],
      tempLvl1Idx: '',
      tempLvl2Idx: '',
      tempLvl3Idx: '',
      filteredPartners: [],
      filteredSuperagents: [],
      filteredAgents: [],
      disableButton: false,
      localClass: '',
      showMessage: false,
      saveAsDownloadUserId: '',
      loadMessage: false,
      disabled: false
    },
    methods: {
      showLvl1Children(lvl1AgentId, lvl1Idx) {
        if ($("#lvl1-bordered-collapse-" + lvl1Idx).hasClass("lvl1Closed")) {
          this.loadMessage = false;
          this.tempLvl1Idx = lvl1Idx;
          this.getFinancialReportResults(lvl1AgentId, 'lvl1', "#lvl1-bordered-collapse-" + lvl1Idx);
          $("#lvl1-subrow-" + lvl1Idx).removeClass("d-none");
          $("#lvl1-bordered-collapse-" + lvl1Idx).removeClass("lvl1Closed").addClass("lvl1Opened").html('-');
        }
        else if ($("#lvl1-bordered-collapse-" + lvl1Idx).hasClass("lvl1Opened")) {
          this.subrows[lvl1Idx] = '';
          $("#lvl1-subrow-" + lvl1Idx).addClass("d-none");
          $("#lvl1-bordered-collapse-" + lvl1Idx).removeClass("lvl1Opened").addClass("lvl1Closed").html('+');
        }

      },
      showLvl2Children(lvl2AgentId, lvl2Idx, lvl1Idx='') {
        this.loadMessage = false;
        this.tempLvl3Idx = '';
        let subSuffix = lvl1Idx + "-" + lvl2Idx;
        if ($("#lvl2-sub-bordered-collapse-" + subSuffix).hasClass("lvl2Closed")) {
          this.tempLvl1Idx = lvl1Idx;
          this.tempLvl2Idx = lvl2Idx;
          this.subUserId = lvl2AgentId;
          this.getFinancialReportResults(lvl2AgentId, 'lvl2', "#lvl2-sub-bordered-collapse-" + subSuffix);
          $("#lvl2-subrow-" + subSuffix).removeClass("d-none");
          $("#lvl2-sub-bordered-collapse-" + subSuffix).removeClass("lvl2Closed").addClass("lvl2Opened").html('-');
        }
        else if ($("#lvl2-sub-bordered-collapse-" + subSuffix).hasClass("lvl2Opened")) {
          this.subrows2[lvl1Idx + '-' + lvl2Idx] = '';
          $("#lvl2-subrow-" + subSuffix).addClass("d-none");
          $("#lvl2-sub-bordered-collapse-" + subSuffix).removeClass("lvl2Opened").addClass("lvl2Closed").html('+');
        }
      },
      showLvl3Children(lvl3AgentId, lvl3Idx, lvl1Idx='', lvl2Idx='') {
        this.loadMessage = false;
        this.tempLvl3Idx = '';
        let subSuffix = lvl1Idx + "-" + lvl2Idx + "-" + lvl3Idx;
        if ($("#lvl3-sub-bordered-collapse-" + subSuffix).hasClass("lvl3Closed")) {
          this.tempLvl1Idx = lvl1Idx;
          this.tempLvl2Idx = lvl2Idx;
          this.tempLvl3Idx = lvl3Idx;
          this.subUserId = lvl3AgentId;
          this.getFinancialReportResults(lvl3AgentId, 'lvl3', "#lvl3-sub-bordered-collapse-" + subSuffix);
          $("#lvl3-subrow-" + subSuffix).removeClass("d-none");
          $("#lvl3-sub-bordered-collapse-" + subSuffix).removeClass("lvl3Closed").addClass("lvl3Opened").html('-');
        }
        else if ($("#lvl3-sub-bordered-collapse-" + subSuffix).hasClass("lvl3Opened")) {
          this.subrows3[lvl1Idx + '-' + lvl2Idx + '-' + lvl3Idx] = '';
          $("#lvl3-subrow-" + subSuffix).addClass("d-none");
          $("#lvl3-sub-bordered-collapse-" + subSuffix).removeClass("lvl3Opened").addClass("lvl3Closed").html('+');
        }
      },

      getUserHierarchy(selectedRole='') {
        api.getAgentDirectChildren(this.userId)
        .done(res => {
          this.disabled = false;
          this.userHierarchy = sortAlphabeticalArrayByValue(res);
          if (selectedRole === 'partner') {
            $("#select2-chosen-2").text('All');
            $("#select2-chosen-3").text('All');
            this.filteredSuperagents = this.userHierarchy.filter(agent =>
              agent.role === ROLE_SUPER_AGENT
            );
            this.filteredAgents = this.userHierarchy.filter(agent =>
              agent.role === ROLE_AGENT
            );
          }
          else if (selectedRole === 'superagent') {
            $("#select2-chosen-3").text('All');
            this.filteredAgents = this.userHierarchy.filter(agent =>
              agent.role === ROLE_AGENT
            );
          }
          else if (selectedRole === 'agent') {
            return;
          }
          else {
            this.filteredPartners = this.userHierarchy.filter(agent =>
              agent.role === ROLE_PARTNER
            );
            this.filteredSuperagents = this.userHierarchy.filter(agent =>
              agent.role === ROLE_SUPER_AGENT
            );
            this.filteredAgents = this.userHierarchy.filter(agent =>
              agent.role === ROLE_AGENT
            );
          }
        })
          .fail((error) => {
            consoleLog(error);
          })
          .always(() => {
            this.loading = false;
          });
      },

      getfinancialReportForUser() {
        api.financialReportForUser(reverseDateFormat(this.createdFrom), reverseDateFormat(this.createdTo))
          .done(res => {
            this.headingUserName = res.username;
            this.headingRole =  res.role == ROLE_OWNER ? $("#agent_role_owner").val() : res.role == ROLE_REPORTER ? $("#agent_role_reporter").val() : res.role == ROLE_PARTNER ? $("#agent_role_partner").val() : res.role == ROLE_SUPER_AGENT ? $("#agent_role_superagent").val() : res.role == ROLE_AGENT ? $("#agent_role_agent").val() : res.role == ROLE_CASHIER ? $("#agent_role_cashier").val() : '',
            this.headingDeposit = swapCurrency(formatMoney(res.totalDepositAmount, this.currency));
            this.headingWithdrawal = swapCurrency(formatMoney(res.totalWithdrawalAmount, this.currency));
            this.headingTotalResultAmount =  swapCurrency(formatMoney(res.totalDepositAmount - res.totalWithdrawalAmount, this.currency))
          })
      },

      goToPage(selectedPage) {
        this.activePage = selectedPage;
        this.getFinancialReportResults();
      },

      getResultsNo() {
        this.getFinancialReportResults();
      },

      removeFilter(selectedFilter) {
        switch(selectedFilter) {

          case 'selectedDate':
            setDate('week', this);
            this.createdFrom='';
            this.createdTo='';
            break;

          case 'selectedUser':
            this.userId= this.constantLoggedInId;
            this.filters['user'] = this.username;
            $("#select2-chosen-1").text('All');
            $("#select2-chosen-2").text('All');
            $("#select2-chosen-3").text('All');
            break;
        }
        this.getUserHierarchy();
        this.getFinancialReportResults();
      },

      setSelfDate (from) {
        this.activeBtn = from;
        setDate(from, this);
      },

      modifyDates(wantedDate) {
        let today = new Date();
        switch(wantedDate) {
          case 'today':
            let dd = today.getDate() > 9 ? today.getDate() : '0' + today.getDate();
            let mm = today.getMonth() + 1 > 9 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1);
            let yyyy = today.getFullYear();
            return dd + '-' + mm + '-' + yyyy;
            break;

          case 'week':
            let day = today.getDay();
            let diff = today.getDate() - day + (day == 0 ? -6 : 1);
            return reverseDateFormat(this.formatDate(new Date(today.setDate(diff))));
            break;
        }
      },

      getParams(page=0) {
        let that = this;

        this.createdFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
        this.createdTo = (this.toDate) ? this.toDate : this.modifyDates('today');
        that.filters['createdFrom'] = (this.createdFrom) ? this.createdFrom : '';
        that.filters['createdTo'] = (this.createdTo) ? this.createdTo : '';

        if (page > 0) {
          this.activePage = page;
        }

        if (this.subUserId > 0) {
          that.userId = this.subUserId;
        }
        else if (that.constantAgentId > 0) {
          that.userId = that.constantAgentId;
          that.saveAsDownloadUserId = that.constantAgentId;
        }
        else if (that.constantSuperAgentId > 0) {
          that.userId = that.constantSuperAgentId;
          that.saveAsDownloadUserId = that.constantSuperAgentId;
        }
        else if (that.constantPartnerId > 0) {
          that.userId = that.constantPartnerId;
          that.saveAsDownloadUserId = that.constantPartnerId;
        }
        else {
          that.userId = '';
          that.saveAsDownloadUserId = '';
        }
      },

      reset() {
        let that = this;
        this.createdFrom = "";
        this.createdTo = "";
        setDate('week', this);
        this.displaySearch = false;
        this.filters = [];
        this.totalPages = 0;
        this.activePage = 0;
        this.pageSize = 20;
        that.constantPartnerId = 0;
        that.constantSuperAgentId = 0;
        that.constantAgentId = 0;
        this.subUserId = 0;
        this.disabled = false;
        $("#select2-chosen-1").text('All');
        $("#select2-chosen-2").text('All');
        $("#select2-chosen-3").text('All');
        let agetnRoleString = that.loggedInRole === ROLE_OWNER ? 'partner' : 
        ( that.loggedInRole === ROLE_PARTNER ? 'superagent' : 'agent' );
        $('#agent-new-financial-report-' + agetnRoleString).select2('val', 0);
      },

      formatDate(date) {
        let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      },

      saveReport() {
        this.showMessage = false;
        this.disableButton = true;
        this.loading = true;
        this.loadMessage = true;

        api.generateNewFinancialReport(reverseDateFormat(this.createdFrom), reverseDateFormat(this.createdTo), this.saveAsDownloadUserId, this.pageSize, this.activePage)
          .done(() => {
            this.loadMessage = false;
            this.success = true;
            this.error = false;
            this.message = $("#csvSuccess").val();
            this.localClass = 'alert-success';
            this.showMessage = true;
          })
          .fail(() => {
            this.loadMessage = false;
            this.message = $("#csvError").val();
            this.localClass = 'alert-danger';
            this.showMessage = true;
          })
          .always(() => {
            const SUCCESS_MESSAGE_TIMEOUT = 3000;
            this.loading = false;
            this.disableButton = false;
            setTimeout(() => {
              this.showMessage = false;
            }, SUCCESS_MESSAGE_TIMEOUT);
          })
      },

      getFinancialReportResults(currentValue='', subRowsType='lvl1', hideSymbol='', asCsv=0) {
        let that = this;
        this.loading = true;
        this.disableButton = true;

        if (currentValue === '') {
          this.displaySearch = false;
          this.subUserId = 0;
        }

        this.filters['user'] = ($("#select2-chosen-2").length > 0 && $("#select2-chosen-2").text() !== 'All') ? $("#select2-chosen-2").text()
          : ($("#select2-chosen-1").length > 0 && $("#select2-chosen-1").text() !== 'All') ? $("#select2-chosen-1").text()
            : this.username;

        this.subUserId = currentValue;

        this.getParams(this.activePage);
        api.generateNewFinancialReport(reverseDateFormat(this.createdFrom), reverseDateFormat(this.createdTo), that.userId, this.pageSize, this.activePage, asCsv)
          .done(res => {
            this.totalPages = 0;
            if(res.list.length > 0) {
              this.displaySearch = true;
              this.error = false;
              this.totalPages = parseInt(res.pagination.pageCount);

              this.tempSearchResults = res.list.map(item => {
                return {
                  'userId': item.userId,
                  'username': item.username,
                  'intUserRole': parseInt(item.role),
                  'userrole': item.role === ROLE_PARTNER ? $("#agent_role_partner").val() : item.role === ROLE_SUPER_AGENT ? $("#agent_role_superagent").val() : item.role === ROLE_AGENT ? $("#agent_role_agent").val(): item.role === ROLE_CASHIER ? $("#agent_role_cashier").val() : $("#agent_role_user").val(),
                  'totalDepositAmount': swapCurrency(formatMoney(item.totalDepositAmount, this.currency)),
                  'totalWithdrawalAmount': swapCurrency(formatMoney(item.totalWithdrawalAmount, this.currency)),
                  'totalResultsAmount': swapCurrency(formatMoney(item.totalDepositAmount - item.totalWithdrawalAmount, this.currency))
                };
              }, that);

              if (!currentValue) {
                this.searchResults = this.tempSearchResults;

                if (
                  (that.constantPartnerId > 0 && that.constantSuperAgentId > 0 && that.constantAgentId > 0) ||
                  (that.constantSuperAgentId > 0 && that.constantAgentId > 0) ||
                  (that.constantAgentId > 0) ||
                  (that.loggedInRole === ROLE_AGENT)
                ) {
                  this.showFooterTotals = true;
                  this.totalOverallResults['depositAmount'] = swapCurrency(formatMoney(res.summary.overall.totalDepositAmount, this.currency));
                  this.totalOverallResults['withdrawalAmount'] = swapCurrency(formatMoney(res.summary.overall.totalWithdrawalAmount, this.currency));
                  this.totalOverallResults['resultsAmount'] = swapCurrency(formatMoney(res.summary.overall.totalDepositAmount - res.summary.overall.totalWithdrawalAmount, this.currency));
                  this.totalPageResults['depositAmount'] = swapCurrency(formatMoney(res.summary.page.totalDepositAmount, this.currency));
                  this.totalPageResults['withdrawalAmount'] = swapCurrency(formatMoney(res.summary.page.totalWithdrawalAmount, this.currency));
                  this.totalPageResults['resultsAmount'] = swapCurrency(formatMoney(res.summary.page.totalDepositAmount - res.summary.page.totalWithdrawalAmount, this.currency));
                }
                else {
                  this.showFooterTotals = false;
                }
              }
              else {
                if (subRowsType === 'lvl1') {
                  this.subrows[this.tempLvl1Idx] = this.tempSearchResults;
                }
                else if (subRowsType === 'lvl2') {
                  this.subrows2[this.tempLvl1Idx + '-' + this.tempLvl2Idx] = this.tempSearchResults;
                }
                else {
                  this.subrows3[this.tempLvl1Idx + '-' + this.tempLvl2Idx + '-' + this.tempLvl3Idx] = this.tempSearchResults;
                }
              }
            }
            if (currentValue === '' && res.list.length === 0) {
              this.displaySearch = false;
              this.totalPages = 0;
            }
            if (hideSymbol !== '' && res.list.length === 0) {
              $(hideSymbol).addClass("invisible");
            }
            this.getfinancialReportForUser();
          })
          .fail(({ responseJSON: res }) => {
            this.displaySearch = false;
            this.error = true;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            }
          })
          .always(() => {
            this.loading = false;
            this.disableButton = false;
            addSticky('th');
          });
      },

    },

    created () {
      if (!document.getElementById('agent-new-financial-report')) {
        return;
      }
      setDate('week', this);

      api.getBalance()
        .done(res => {
          this.currency = res.currency;
        });

      this.error = false;
      api.getPlayer().done(res => {
        this.username = res.username;
        this.userId = res.user_id;
        this.constantLoggedInId = res.user_id;
        this.getUserHierarchy();
      });

    },

    mounted () {
      if (!document.getElementById('agent-new-financial-report')) {
        return;
      }

      // Initialize datepickers
      const that = this;
      const $startDate = $(this.$refs.fromDate);
      const $endDate = $(this.$refs.toDate);

      $startDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate, date) {
          that.fromDate = formattedDate;
          $endDate.datepicker().data('datepicker').update('minDate', date);
        },
      });

      $endDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate) {
          that.toDate = formattedDate;
        },
      });

      $('#agent-new-financial-report-partner').select2()
      .on('change', function () {
        $('#agent-new-financial-report-superagent').select2('val', 0);
        that.disabled = true;
        that.constantAgentId = 0;
        that.constantSuperAgentId = 0;
        that.constantPartnerId = this.value;
        that.userId = this.value > 0 ? this.value : that.constantLoggedInId;
        that.getUserHierarchy('partner');
      });

      $('#agent-new-financial-report-superagent').select2()
        .on('change', function () {
          $('#agent-new-financial-report-agent').select2('val', 0);
          that.disabled = true;
          that.constantAgentId = 0;
          that.constantSuperAgentId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantLoggedInId;
          that.getUserHierarchy('superagent');
        });

      $('#agent-new-financial-report-agent').select2()
        .on('change', function () {
          $('#agent-new-financial-report-user').select2('val', 0);
          that.disabled = true;
          that.constantAgentId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantSuperAgentId;
          that.getUserHierarchy('agent');
        });
    },

  });

  /* -----------------------------------------
  Agent Reports Csv List
  ----------------------------------------- */
  const AgentReportsCsvList = new Vue({
    el: '.agent-reports-csv-list',
    data: {
      currency: '',
      displaySearch: false,
      error: '',
      errorMessage: '',
      loading: false,
      activePage: 0,
      totalPages: 0,
      pageSize: 20,
      searchResults: [],
      reports: [
        {
          'id': 170,
          'name': $("#newCasinoReport").val()
        },
        {
          'id': 120,
          'name': $("#sbAccountingReport").val()
        },
        {
          'id': 130,
          'name': $("#sbDailyAccountingReport").val()
        },
        {
          'id': 140,
          'name': $("#searchUsers").val()
        },
        {
          'id': 150,
          'name': $("#newFinancialReport").val()
        },
        {
          'id': 160,
          'name': $("#financialTransactions").val()
        },
        {
          'id': 240,
          'name': $("#overallActivityReport").val()
        },
      ]
    },
    methods: {
      goToPage(selectedPage) {
        this.activePage = selectedPage
        this.getCsvsList();
      },

      fixDateFormat(dRange) {
        let formattedDates = dRange.split(':');
        return reverseDateFormat(formattedDates[0]) + ':' + reverseDateFormat(formattedDates[1]);
      },

      returnFilters(selectedFilters, categoryId) {
        let filters = '';
        let array_filters = [];
        array_filters.push(selectedFilters);

        array_filters.map(item => {
          if (categoryId === 110) {
            filters += item.paid === PAIDOUT_NO ? $("#filtersPaidout").val() + ": " + $("#filtersValueNo").val() + ", " :
              item.paid === PAIDOUT_YES ? $("#filtersPaidout").val() + ": " + $("#filtersValueYes").val() + ", " :
                $("#filtersPaidout").val() + ": " + $("#filtersValueAny").val() + ", ";
          }

          if (categoryId === 120) {
            filters += item.paid === PAIDOUT_NO ? $("#filtersPaidout").val() + ": " + $("#filtersValueNo").val() + ", " :
              item.paid === PAIDOUT_YES ? $("#filtersPaidout").val() + ": " + $("#filtersValueYes").val() + ", " :
                $("#filtersPaidout").val() + ": " + $("#filtersValueAny").val() + ", ";

            filters += item.status === STATUS_OPEN ? $("#filtersStatus").val() + ": " + $("#filtersValueOpen").val() + ", " :
              item.status === STATUS_WON ? $("#filtersStatus").val() + ": " + $("#filtersValueWon").val() + ", " :
                item.status === STATUS_LOST ? $("#filtersStatus").val() + ": " + $("#filtersValueLost").val() + ", " :
                  item.status === STATUS_CANCELED ? $("#filtersStatus").val() + ": " + $("#filtersValueCanceled").val() + ", " :
                    $("#filtersStatus").val() + ": " + $("#filtersValueAll").val() + ", ";

            filters += item.betSearch ==='created' ? $("#filtersBetSearch").val() + ": " + $("#filtersValueCreated").val() + ", " :
              item.betSearch ==='settled' ? $("#filtersBetSearch").val() + ": " + $("#filtersValueSettled").val() + ", " :
                $("#filtersBetSearch").val() + ": " + $("#filtersValuePaid").val() + ", ";

            filters += item.userRole == ROLE_USER ? $("#filtersUserRole").val() + ": " + $("#filtersValueUsers").val() + ", " :
              item.userRole == ROLE_CASHIER ? $("#filtersUserRole").val() + ": " + $("#filtersValueCashiers").val() + ", " :
                $("#filtersUserRole").val() + ": " + $("#filtersValueAll").val() + ", ";
          }

          if (categoryId === 130) {
            filters += item.paid === PAIDOUT_NO ? $("#filtersPaidout").val() + ": " + $("#filtersValueNo").val() + ", " :
              item.paid === PAIDOUT_YES ? $("#filtersPaidout").val() + ": " + $("#filtersValueYes").val() + ", " :
                $("#filtersPaidout").val() + ": " + $("#filtersValueAny").val() + ", ";

            filters += item.status === STATUS_OPEN ? $("#filtersStatus").val() + ": " + $("#filtersValueOpen").val() + ", " :
              item.status === STATUS_WON ? $("#filtersStatus").val() + ": " + $("#filtersValueWon").val() + ", " :
                item.status === STATUS_LOST ? $("#filtersStatus").val() + ": " + $("#filtersValueLost").val() + ", " :
                  item.status === STATUS_CANCELED ? $("#filtersStatus").val() + ": " + $("#filtersValueCanceled").val() + ", " :
                    $("#filtersStatus").val() + ": " + $("#filtersValueAll").val() + ", ";

            filters += item.betSearch ==='created' ? $("#filtersBetSearch").val() + ": " + $("#filtersValueCreated").val() + ", " :
              item.betSearch ==='settled' ? $("#filtersBetSearch").val() + ": " + $("#filtersValueSettled").val() + ", " :
                $("#filtersBetSearch").val() + ": " + $("#filtersValuePaid").val() + ", ";
          }

          if (categoryId === 180 || categoryId === 190 || categoryId === 200 || categoryId === 210) {
            filters += item.status === STATUS_OPEN ? $("#filtersStatus").val() + ": " + $("#filtersValueOpen").val() + ", " :
              item.status === STATUS_WON ? $("#filtersStatus").val() + ": " + $("#filtersValueWon").val() + ", " :
                item.status === STATUS_LOST ? $("#filtersStatus").val() + ": " + $("#filtersValueLost").val() + ", " :
                  item.status === STATUS_CANCELED ? $("#filtersStatus").val() + ": " + $("#filtersValueCanceled").val() + ", " :
                    $("#filtersStatus").val() + ": " + $("#filtersValueAll").val() + ", ";

            filters += item.betSearch ==='created' ? $("#filtersBetSearch").val() + ": " + $("#filtersValueCreated").val() + ", " :
              item.betSearch ==='settled' ? $("#filtersBetSearch").val() + ": " + $("#filtersValueSettled").val() + ", " :
                $("#filtersBetSearch").val() + ": " + $("#filtersValuePaid").val() + ", ";
          }

          if (categoryId === 240) {
            filters += item.betSearch ==='date' ? $("#filtersBetSearch").val() + ": " + $("#filtersValueCreated").val() + ", " :
              item.betSearch ==='settled' ? $("#filtersBetSearch").val() + ": " + $("#filtersValueSettled").val() + ", " :
                $("#filtersBetSearch").val() + ": " + $("#filtersValuePaid").val() + ", ";
          }

        });

        filters = filters.slice(0, -2);

        return filters;

      },

      getReportName(categoryId) {
        let filtered_report = this.reports.filter(report => {
          return report.id === categoryId
        })
        if (filtered_report.length > 0) {
          return filtered_report[0].name;
        };
        return '-';
      },
      
      reverseDate(date){
        if (date) {
          let tempTime = [];
          let tempDate = [];
          let reverseDate = date.split(' ');
          let transformDate = reverseDate[0].split('-');
          tempDate[0] = transformDate[2];
          tempDate[1] = transformDate[1];
          tempDate[2] = transformDate[0];
          tempTime[0] = reverseDate[1];

          reverseDate = tempDate[0] + "-" + tempDate[1] + "-" + tempDate[2] + " " + tempTime[0];
          return reverseDate;
        }
        else {
          return '';
        }
      },
      getCsvStatus(isReady, link, error) {
        if (isReady && link !== null && error === null) {
          this.disableButton = false;
          return 'success';
        }
        if (isReady == true && link == null && error != null) {
          this.disableButton = false;
          return 'empty';
        }
        if (!isReady && link == null && error != null) {
          this.disableButton = true;
          return 'error';
        }
        if (!isReady && link == null && error == null) {
          this.disableButton = true;
          return 'in-progress';
        }
      },

      getCsvsList() {
        let that = this;
        this.disableButton = true;
        this.displaySearch = false;
        this.loading = true;

        api.generateCsvsListFromReports(this.pageSize, this.activePage)
          .done(res => {
            if (res.list.length > 0) {
              this.displaySearch = true;

              this.totalPages = parseInt(res.pagination.pageCount);
              this.error = false;
              let that = this;
              this.searchResults = res.list.map(item => {
                return {
                  'id': item.id,
                  'status': this.getCsvStatus(item.isReady, item.link, item.error),
                  'report': this.getReportName(item.categoryId),
                  'link': item.link,
                  'periodDate': item.params.periodDate ? this.fixDateFormat(item.params.periodDate) : '',
                  'username': item.params.username ? item.params.username : '',
                  'availableTill': this.reverseDate(item.availableTill),
                  'filters': this.returnFilters(item.params, item.categoryId),
                  'userId': item.params.userId,
                };
              }, that);
            }
          })
          .fail(({ responseJSON: res }) => {
            this.error = true;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            }
          })
          .always(() => {
            this.loading = false;
            this.disableButton = false;
          });
      }
    },
    created () {
      if (!document.getElementById('agent-reports-csv-list')) {
        return;
      }
      this.getCsvsList();
    }
  });  

  /* -----------------------------------------
     Agent Financial Transactions
  ----------------------------------------- */
     const AgentFinancialTransactions = new Vue({
      el: '.agent-financial-transactions',
      components: {
        'v-select': vSelect
      },
      data: {
        sourceUser: '',
        sourceUserInputText: '',
        sourceUserOptionsResults: [],
        agentId: '',
        currency: '',
        error: false,
        success: false,
        errorMessage: '',
        currentUser: '',
        fromDate: '',
        toDate: '',
        notificationMessage: false,
        showMessage: false,
        displaySearch: false,
        localClass: '',
        activeBtn: 'week',
        unfilteredResult: [],
        translations: [],
        errorsTranslations: [],
        typeTranslations: {},
        tableHeadings: {},
        strings: [],
        loggedInRole: __APP__.agentRole,
        parent: 0,
        self: 1,
        totalAmount: 0,
        fn: '',
        showTotalResults: '',
        disableButton: false,
        loading: false,
        columns: [
          'type',
          'fromUser',
          'toUser',
          'amount',
          'dateTime',
          'note',
          'referenceId',
        ],
        options: {
          customSorting: {
            amount: function (ascending) {
              return function (a, b) {
                var amountA = parseFloat(a.amount.split(' ')[1]);
                var amountB = parseFloat(b.amount.split(' ')[1]);

                if (ascending) {
                  return amountA >= amountB ? 1 : -1;
                }

                return amountA <= amountB ? 1 : -1;
              };
            },
          },
          headings: {
            'type': function (h) {
              return this.tableHeadings.type;
            },
            'fromUser': function (h) {
              return this.tableHeadings.fromUser;
            },
            'toUser': function (h) {
              return this.tableHeadings.toUser;
            },
            'amount': function (h) {
              return this.tableHeadings.amount;
            },
            'dateTime': function (h) {
              return this.tableHeadings.dateTime;
            },
            'note': function (h) {
              return this.tableHeadings.note;
            },
            'referenceId': function (h) {
              return this.tableHeadings.referenceId;
            },
          },
          texts: {
            noResults: $("#no_matching_records").val(),
          }
        },
      },
        methods: {
          sourceUserInput(value) {
            if( value.length > 2 ) {
              setTimeout(() => {
                this.fetchSearchResults(value, "sourceUserInput");
              }, AGENT_TRANSFER_V2_TYPING_TIMEOUTS);
            }
          },
          fetchSearchResults(value, inputElement) {
              api.searchUserByUsername(value).done(res => {
                if( inputElement === "sourceUserInput" ){
                  this.sourceUserOptionsResults = res.users;
                  this.sourceUserInputText = value;
                }
                else {
                  this.sourceUserOptionsResults = '';
                  this.sourceUserInputText = '';
                }
              });
          },
        setSelfDate (from) {
          this.activeBtn = from;
          setDate(from, this);
        },
        noteShowHide (status, id) {
          if (status === 'collapse') {
            $('.noteCollapsed[data-id=' + id + ']').removeClass('hidden');
            $('.noteExpanded[data-id=' + id + ']').addClass('hidden');
          }
          if (status === 'expand') {
            $('.noteCollapsed[data-id=' + id + ']').addClass('hidden');
            $('.noteExpanded[data-id=' + id + ']').removeClass('hidden');
          }
        },
        saveReport() {
          this.showMessage = false;
          this.disableButton = true;
          this.loading = true;
          this.notificationMessage = true;
  
          api.saveFinancialTransactionsAsCsv(this.sourceUser, reverseDateFormat(this.fromDate), reverseDateFormat(this.toDate))
            .done(() => {
              this.notificationMessage = false;
              this.success = true;
              this.error = false;
              this.message = $("#csvSuccess").val();
              this.localClass = 'alert-success';
              this.showMessage = true;
            })
            .fail(() => {
              this.message = $("#csvError").val();
              this.localClass = 'alert-danger';
              this.showMessage = true;
              this.notificationMessage = false;
            })
            .always(() => {
              this.loading = false;
              this.disableButton = false;
              setTimeout(() => {
                this.showMessage = false;
                }, 3000);
            })
        },
        submit () {
          this.disableButton = true;
          this.loading = true;
          this.options.texts.noResults = '';
          api.financialTransactions(this.sourceUser, reverseDateFormat(this.fromDate), reverseDateFormat(this.toDate)).
            done(res => {
              if (res.length > 0) {
                this.showTotalResults = true;
                this.displaySearch = true;
                this.users = res;
                this.unfilteredResult = res;
                this.error = false;
              }
              else if (res.list = []) {
                this.error = false;
                this.showTotalResults = false;
                this.options.texts.noResults = $("#no_matching_records").val();
              }
              else {
                this.error = false;
                this.showTotalResults = false;
                this.options.texts.noResults = $("#no_matching_records").val();
              }  
            }).
            fail(({ responseJSON: res }) => {
              this.error = true;
              this.options.texts.noResults = $("#no_matching_records").val();
              this.showTotalResults = false;
              if (res.errors) {
                this.errorMessage = res.errors[0].message;
                this.showTotalResults = false;
                this.options.texts.noResults = $("#no_matching_records").val();
              }
            })
            .always(() => {
              this.disableButton = false;
              this.loading = false;
              addSticky('th');
            });
        },
        cancel() {
          this.fromDate='';
          this.toDate='';
          this.error = false;
          this.unfilteredResult = [];
          this.setSelfDate ("week");
          this.sourceUser = '';
          this.sourceUserInputText = '';
          this.sourceUserOptions = [];
          this.sourceUserOptionsResults = [];
          this.showTotalResults = false;
          this.options.texts.noResults = $("#no_matching_records").val();
        },
        getTranslations () {
          let translationsArray = [];
          $('#roles_translations span').each(function () {
            translationsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.translations = translationsArray;
          let errorsArray = [];
          $('#errors_translations span').each(function () {
            errorsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.errorsTranslations = errorsArray;
          let stringsArray = [];
          let typesObj = {};
          $('#strings_translations span').each(function () {
            stringsArray[$(this).attr('data-id')] = $(this).html();
            if ($(this).attr('data-name')) {
              typesObj[$(this).attr('data-name')] = $(this).html();
            }
          });
          this.strings = stringsArray;
          this.typeTranslations = typesObj;
          let tableHeadingsObj = {};
          $('#table_headings_translations span').each(function () {
            tableHeadingsObj[$(this).attr('data-name')] = $(this).html();
          });
          this.tableHeadings = tableHeadingsObj;
        },
      },
      computed: {
        sourceUserOptions() {
          return this.sourceUserOptionsResults;
        },
        uniqueRoles () {
          let sortedUsers = this.usersSorted;
          /* Find the first and last occurences of role */
          let roles = sortedUsers.map(user => {
            return parseInt(user.role);
          });
          return roles.filter(function (value, index, self) {
            return self.indexOf(value) === index;
          });
        },
        userTree () {
          let that = this;
          let users = [];
          this.users.forEach(user => {
            if (typeof user === 'object') {
              if (typeof (users[user.role]) !== 'object') {
                users[user.role] = [];
              }
              if (user.position == 'parent') {
                this.translations[parseInt(
                  user.role)] = this.translations[this.parent];
              }
              if (user.position == 'self') {
                this.translations[parseInt(
                  user.role)] = this.translations[this.self];
              }
              users[parseInt(user.role)].push({
                'username': user.username,
                'id': parseInt(user.userId),
                'position': user.position,
              });
            }
          }, that);
          const {
            translations,
          } = this;
          return users;
        },
        usersSorted () {
          return this.users.sort((a, b) => {
            return (b.role - a.role) || a.username.localeCompare(b.username);
          });
        },
        result () {
          let that = this;
          this.totalAmount = 0;
          return this.unfilteredResult.map(res => {
            this.totalAmount = this.totalAmount + parseInt(res.amount);
            return {
              'type': this.typeTranslations[res.type],
              'fromUser': res.fromUsername + ' ' + '(id: ' + res.fromUserId + ')',
              'toUser': res.toUsername + ' ' + '(id: ' + res.toUserId + ')',
              'amount': formatMoney(res.amount, this.currency),
              'dateTime': res.dateTime,
              'note': res.note,
              'referenceId': res.referenceId,
            };
          }, that);
        },
      },
      watch: {
        type(newValue, oldValue){
          this.firstPage = true;
          this.nextPage = '';
          this.tableFooterOptions = true;
        },
        sourceUser(newValue, oldValue){
          this.firstPage = true;
          this.nextPage = '';
        },
        fromDate(newValue, oldValue) {
          this.firstPage = true;
          this.nextPage = '';
        },
        toDate(newValue, oldValue) {
          this.firstPage = true;
          this.nextPage = '';
        },
      },
      created () {
        if (!document.getElementById('agent-financial-transactions')) {
          return;
        }
        setDate('week', this);

        api.getPlayer().done(res => {
          this.currency = res.currency;
        });

        this.getTranslations();
        this.fn = formatMoney;
      },
      mounted () {
        if (!document.getElementById('agent-financial-transactions')) {
          return;
        }

        // Initialize datepickers
        const that = this;
        const $startDate = $(this.$refs.fromDate);
        const $endDate = $(this.$refs.toDate);

        $startDate.datepicker({
          language: setDefaultLanguage(__APP__.langShort),
          dateFormat: 'dd-mm-yyyy',
          maxDate: new Date(),
          onSelect (formattedDate, date) {
            that.fromDate = formattedDate;
            $endDate.datepicker().data('datepicker').update('minDate', date);
          },
        });

        $endDate.datepicker({
          language: setDefaultLanguage(__APP__.langShort),
          dateFormat: 'dd-mm-yyyy',
          maxDate: new Date(),
          onSelect (formattedDate) {
            that.toDate = formattedDate;
          },
        });
      },
    });

  /* -----------------------------------------
   Agent Financial Transactions List
   ----------------------------------------- */
   const AgentTransactionsList = new Vue({
    el: '.agent-transactions-list-report',
    data: {
      nextPage: '',
      previousPage: '',
      sourceUser: '',
      transactionType: '',
      currency: '',
      error: '',
      isFetching: false,
      currentPage: 0,
      errorMessage: '',
      showLoadButton: false,
      currentUser: {},
      fromDate: '',
      toDate: '',
      createdFrom: '',
      createdTo: '',
      type: '',
      userId: '',
      hideButtons: true,
      tableData: [],
      users: [],
      unfilteredResult: [],
      translations: [],
      displaySearch: false,
      errorsTranslations: [],
      typeTranslations: {},
      tableHeadings: {},
      strings: [],
      loading: false,
      totalAmount: 0,
      firstPage: false,
      fn: '',
      restrictionDate: '27-05-2022',
      tableFooterOptions: false,
      loggedInRole: __APP__.agentRole,
      columns: [
        'referenceId',
        'dateTime',
        'type',
        'username',
        'amount',
        'balanceAfter'
      ],
      options: {
        perPage: 9999,
        headings: {
          'type': function (h) {
            return this.tableHeadings.type;
          },
          'amount': function (h) {
            return this.tableHeadings.amount;
          },
          'dateTime': function (h) {
            return this.tableHeadings.dateTime;
          },
          'username': function (h) {
            return this.tableHeadings.username;
          },
          'balanceAfter': function (h) {
            return this.tableHeadings.balanceAfter;
          },
          'referenceId': function (h) {
            return this.tableHeadings.referenceId;
          },
        },
        texts: {
          filter : $("#transaction_list_filter_results").val(),
          filterPlaceholder : $("#transaction_list_search_query").val(),
          // noResults: $("#no_matching_records").val(),
        },
      },
    },
    methods: {
      formatDate(date) {
        let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear(),
          hour = '' + d.getHours(),
          minutes = '' + d.getMinutes(),
          seconds = '' + d.getSeconds();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        if (hour.length < 2) hour = '0' + hour;
        if (minutes.length < 2) minutes = '0' + minutes;
        if (seconds.length < 2) seconds = '0' + seconds;

        return day + '/' + month + '/' + year + ' ' + hour + ':' + minutes + ':' + seconds;  
      },
      transformResponse(rows) {
        for (let i=0; i < rows.length; ++i) {
          this.tableFooterOptions = true;
          this.totalAmount = this.totalAmount + parseInt(rows[i].amount);
        }
        return rows.map(row => ({
          ...row,
          type: this.typeTranslations[row.type],
          amount: formatMoney(row.amount, this.currency),
          dateTime: row.createdAt,
          referenceId: row.id,
          balanceAfter: formatMoney(row.balanceAfter, this.currency),
          username: row.description ? row.description : '-'
        }));
      },
      loadMoreTransactions() {
        this.currentPage++;
        this.getTransactionListResults(this.nextPage, this.firstPage);
      },
      userTree () {
        let that = this;
        let tmpUsers = [];
        this.users.forEach(user => {
          if (typeof user === 'object') {
            if (user.position !== 'parent') {
              tmpUsers.push({
                'username': user.username,
                'text': user.username + (this.currentUser.id == user.userId ? ' [Self]' : ' [' + this.translations[parseInt(user.role)] + ']'),
                'id': parseInt(user.userId),
                'position': user.position,
              });
            }
          }
        }, that);
        this.users = tmpUsers;
      },
      contains(str1, str2) {
        return new RegExp(str2, "i").test(str1);
      },
      getParams() {
        this.createdFrom = this.fromDate;
        this.createdTo = this.toDate;
        this.transactionType = this.type;
        this.userId = this.sourceUser;
      },
      getTransactionListResults (page='', firstPage=this.firstPage) {
        if (firstPage) {
          this.tableData = [];
          this.totalAmount = 0;
          this.nextPage = page;
        }
        this.isFetching = true;
        this.hideButtons = true;
        this.loading = true;
        this.getParams();
        this.error = '';
        this.createdFrom = reverseDateFormat(this.createdFrom) < reverseDateFormat(this.restrictionDate) ? reverseDateFormat(this.restrictionDate) : reverseDateFormat(this.createdFrom);
        api.generateTransactionsListV2(this.userId, this.createdFrom, reverseDateFormat(this.createdTo), this.transactionType, this.nextPage).
          done(res => {
            if (res) {
              this.nextPage = res.pagination.nextPage === null ? '' : parseInt(res.pagination.nextPage);
              this.firstPage = false;
              this.showLoadButton = res.pagination.nextPage === null ? false : true;

              if (this.currentPage === 0) {
                this.totalAmount = 0;
                this.tableData = this.transformResponse(res.list);
              }
              else {
                this.tableData = this.tableData.concat(this.transformResponse(res.list));
              }
            }
            else if (res.list = []) {
              this.tableFooterOptions = false;
              this.options.texts.noResults = $("#history_no_matching_records").val();
            }
            else {
              this.options.texts.noResults = $("#history_no_matching_records").val();
            }
            this.isFetching = false;
            this.loading = false;
          }).
          fail(({ responseJSON: res }) => {
            this.error = true;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            }
          })
          .always(() => {
            this.hideButtons = false,
            this.loading = false;
            addSticky('th');
          });
      },
      usersSorted () {
        return this.users.sort((a, b) => {
          return (b.role - a.role) || a.username.localeCompare(b.username);
        });
      },
      cancel() {
        setDate('week', this);
        this.toDate = dayjs().format('DD-MM-YYYY');
        this.sourceUser = '';
        this.tableData = [];
        this.totalAmount = 0;
        this.totalClosingBalance = 0;
        this.tableFooterOptions = false;
        this.showLoadButton = false;
        this.nextPage = '';
        this.firstPage = true;
        $("#select2-chosen-1").text('');
        this.error = '';
        return;
      },
      getTranslations () {
        let translationsArray = [];
        $('#roles_translations span').each(function () {
          translationsArray[$(this).attr('data-id')] = $(this).html();
        });
        this.translations = translationsArray;
        let errorsArray = [];
        $('#errors_translations span').each(function () {
          errorsArray[$(this).attr('data-id')] = $(this).html();
        });
        this.errorsTranslations = errorsArray;
        let stringsArray = [];
        let typesObj = {};
        $('#strings_translations span').each(function () {
          stringsArray[$(this).attr('data-id')] = $(this).html();
          if ($(this).attr('data-name')) {
            typesObj[$(this).attr('data-name')] = $(this).html();
          }
        });
        this.strings = stringsArray;
        this.typeTranslations = typesObj;
        let tableHeadingsObj = {};
        $('#table_headings_translations span').each(function () {
          tableHeadingsObj[$(this).attr('data-name')] = $(this).html();
        });
        this.tableHeadings = tableHeadingsObj;
      },
    },
    created () {
      if (!document.getElementById('agent-transactions-list-report')) {
        return;
      }
      this.getTranslations();
      setDate('week', this);
      let that = this;

      api.getPlayer().done(res => {
        this.currency = res.currency;
        this.currentUser.role = localStorage.getItem('role');
        this.currentUser.id = res.user_id;
        this.currentUser.username = res.username;
      });

      api.getAgentHierarchyFull().done(res => {
        if (res[0] === false) { //TODO: Temporary fix because platform returns false if there is no parent
          res.shift();
        }
        this.users = res;
        this.userTree();
        this.hideButtons = false;

        $('#agent-transactions-list-report #transaction-list-report')
      .select2({
        data: this.users,
        minimumInputLength: 0,
        theme: "classic",
        query: function(q) {
          let pageSize = 50,
            results = this.data.filter(function(e) {
              return that.contains(e.text, q.term);
            });
          // Get a page sized slice of data from the results of filtering the data set.
          let paged = results.slice((q.page - 1) * pageSize, q.page * pageSize);
          q.callback({
            results: paged,
            more: results.length >= q.page * pageSize
          });
        }
      })
      .on('change', function () {
        that.sourceUser = this.value;
      });
      });
      this.fn = formatMoney;
    },
    mounted () {
      if (!document.getElementById('agent-transactions-list-report')) {
        return;
      }
      // Initialize datepickers
      const that = this;

      const $startDate = $(this.$refs.fromDate);
      const $endDate = $(this.$refs.toDate);
   
      $startDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        minDate: new Date(2022, 4, 27, 0, 0, 0, 0),
        maxDate: new Date(),
        onSelect (formattedDate, date) {
          that.fromDate = formattedDate;
          $endDate.datepicker().data('datepicker').update('minDate', date);
        },
      });
      $endDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate) {
          that.toDate = formattedDate;
        },
      });
    },
    watch: {
      type(newValue, oldValue){
        this.firstPage = true;
        this.nextPage = '';
        this.tableFooterOptions = true;
      },
      sourceUser(newValue, oldValue){
        this.firstPage = true;
        this.nextPage = '';
      },
      fromDate(newValue, oldValue) {
        this.firstPage = true;
        this.nextPage = '';
      },
      toDate(newValue, oldValue) {
        this.firstPage = true;
        this.nextPage = '';
      },
    }
  });

  /* -----------------------------------------
     Agent Cash In Hand Report
     ----------------------------------------- */
     const AgentCashInHandReport = new Vue({
      el: '.agent-cash-in-hand-report',
      data: {
        agentId: '',
        users: [],
        currentUser: '',
        currency: '',
        totalAmount: '',
        error: '',
        errorMessage: '',
        activeBtn: 'week',
        fromDate: '',
        toDate: '',
        fn: '',
        loading: false,
        disableButton: false,
        roleTranslations: [],
        stringsTranslations: [],
        tableHeadings: {},
        totals: {
          'deposit': 0,
          'withdraw': 0,
        },
        result: [],
        columns: [
          'username',
          'role',
          'totalDepositAmount',
          'totalWithdrawalAmount',
        ],
        options: {
          customSorting: {
            totalDepositAmount: function (ascending) {
              return function (a, b) {
                var amountA = parseFloat(a.totalDepositAmount.split(' ')[1]);
                var amountB = parseFloat(b.totalDepositAmount.split(' ')[1]);

                if (ascending) {
                  return amountA >= amountB ? 1 : -1;
                }

                return amountA <= amountB ? 1 : -1;
              };
            },
            totalWithdrawalAmount: function (ascending) {
              return function (a, b) {
                var amountA = parseFloat(a.totalWithdrawalAmount.split(' ')[1]);
                var amountB = parseFloat(b.totalWithdrawalAmount.split(' ')[1]);

                if (ascending) {
                  return amountA >= amountB ? 1 : -1;
                }

                return amountA <= amountB ? 1 : -1;
              };
            },
          },
          headings: {
            'username': function (h) {
              return this.tableHeadings.username;
            },
            'role': function (h) {
              return this.tableHeadings.role;
            },
            'totalDepositAmount': function (h) {
              return this.tableHeadings.totalDepositAmount;
            },
            'totalWithdrawalAmount': function (h) {
              return this.tableHeadings.totalWithdrawalAmount;
            },
          },
          texts: {
            noResults: ''
          }
        },
      },
      methods: {
        setSelfDate (from) {
          this.activeBtn = from;
          setDate(from, this);
        },
        getTranslations () {
          let translationsArray = [];
          $('#roles_translations span').each(function () {
            translationsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.translations = translationsArray;
          let stringsArray = [];
          $('#strings_translations span').each(function () {
            stringsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.stringsTranslations = stringsArray;
          let tableHeadingsObj = {};
          $('#table_headings_translations span').each(function () {
            tableHeadingsObj[$(this).attr('data-name')] = $(this).html();
          });
          this.tableHeadings = tableHeadingsObj;
        },
        getUserRole (id) {
          let returnVal = '';
          for (let user of this.users) {
            if (parseInt(user.userId) == parseInt(id)) {
              returnVal = this.translations[parseInt(user.role)];
              break;
            }
          }
          return returnVal;
        },
        submit () {
          this.disableButton = true;
          this.loading = true;
          this.options.texts.noResults = '';
          api.cashInHandReport(this.agentId, reverseDateFormat(this.fromDate), reverseDateFormat(this.toDate)).
          done(res => {
            if (res.length > 0) {
              this.totals.deposit = 0;
              this.totals.withdraw = 0;
              let that = this;
              this.error = false;
              this.result = res.map(item => {
                this.totals.deposit = this.totals.deposit +
                    parseInt(item.totalDepositAmount);
                this.totals.withdraw = this.totals.withdraw +
                    parseInt(item.totalWithdrawalAmount);
                return {
                  'username': item.username + ' (id: ' + item.userId + ')',
                  'role': this.getUserRole(item.userId),
                  'totalDepositAmount': formatMoney(item.totalDepositAmount,
                      this.currency),
                  'totalWithdrawalAmount': formatMoney(item.totalWithdrawalAmount,
                      this.currency),
                };
              }, that);
            }
            else {
              this.options.texts.noResults = $("#no_matching_records").val();
            }  
          }).
          fail(({ responseJSON: res }) => {
            this.error = true;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            }
          })
          .always(() => {
            this.disableButton = false;
            this.loading = false;
            addSticky('th');
          });
        },
      },
      created () {
        if (!document.getElementById('agent-cash-in-hand-report')) {
          return;
        }

        setDate('week', this);

        api.getPlayer().done(res => {
          this.agentId = res.user_id;
          this.currentUser = res.user_id;
          this.currency = res.currency;
        });

        api.getAgentHierarchyFull().done(res => {
          if (res[0] === false) { //TODO: Temporary fix because platform returns false if there is no parent
            res.shift();
          }
          this.users = res;
        });

        this.getTranslations();
        //Pass formatMoney to View for use in data tables vue slots
        this.fn = formatMoney;
      },
      mounted () {
        if (!document.getElementById('agent-cash-in-hand-report')) {
          return;
        }

        // Initialize datepickers
        const that = this;
        const $startDate = $(this.$refs.fromDate);
        const $endDate = $(this.$refs.toDate);

        $startDate.datepicker({
          language: setDefaultLanguage(__APP__.langShort),
          dateFormat: 'dd-mm-yyyy',
          maxDate: new Date(),
          onSelect (formattedDate, date) {
            that.fromDate = formattedDate;
            $endDate.datepicker().data('datepicker').update('minDate', date);
          },
        });

        $endDate.datepicker({
          language: setDefaultLanguage(__APP__.langShort),
          dateFormat: 'dd-mm-yyyy',
          maxDate: new Date(),
          onSelect (formattedDate) {
            that.toDate = formattedDate;
          },
        });
      },
    });

   /* -----------------------------------------
     Agent Cash In Hand Transactions
     ----------------------------------------- */
     const AgentCashInHandTransactions = new Vue({
      el: '.agent-cash-in-hand-transactions',
      data: {
        agentId: '',
        currency: '',
        users: [],
        error: '',
        errorMessage: '',
        currentUser: '',
        fromDate: '',
        toDate: '',
        activeBtn: 'week',
        unfilteredResult: [],
        translations: [],
        errorsTranslations: [],
        typeTranslations: {},
        tableHeadings: {},
        strings: [],
        parent: 0,
        self: 1,
        totalAmount: 0,
        fn: '',
        disableButton: false,
        loading: false,
        columns: [
          'type',
          'fromUser',
          'toUser',
          'amount',
          'dateTime',
          'note',
          'referenceId',
        ],
        options: {
          customSorting: {
            amount: function (ascending) {
              return function (a, b) {
                var amountA = parseFloat(a.amount.split(' ')[1]);
                var amountB = parseFloat(b.amount.split(' ')[1]);

                if (ascending) {
                  return amountA >= amountB ? 1 : -1;
                }

                return amountA <= amountB ? 1 : -1;
              };
            },
          },
          headings: {
            'type': function (h) {
              return this.tableHeadings.type;
            },
            'fromUser': function (h) {
              return this.tableHeadings.fromUser;
            },
            'toUser': function (h) {
              return this.tableHeadings.toUser;
            },
            'amount': function (h) {
              return this.tableHeadings.amount;
            },
            'dateTime': function (h) {
              return this.tableHeadings.dateTime;
            },
            'note': function (h) {
              return this.tableHeadings.note;
            },
            'referenceId': function (h) {
              return this.tableHeadings.referenceId;
            },
          },
          texts: {
            noResults: ''
          }
        },
      },
      methods: {
        setSelfDate (from) {
          this.activeBtn = from;
          setDate(from, this);
        },
        submit () {
          this.disableButton = true;
          this.loading = true;
          this.options.texts.noResults = '';
          api.cashInHandTransactions(this.currentUser, reverseDateFormat(this.fromDate), reverseDateFormat(this.toDate)).done(res => {
            if (res.length > 0) {
              this.unfilteredResult = res;
            }
            else {
              this.options.texts.noResults = $("#no_matching_records").val();
            }  
          }).fail(({ responseJSON: res }) => {
            this.error = true;
            if (res) {
              this.errorMessage = res.message;
            }
            else {
              this.errorMessage = __APP__.default_error_message;
            }
          })
          .always(() => {
            this.disableButton = false;
            this.loading = false;
            addSticky('th');
          });
        },
        cancel() {
          this.fromDate = '';
          this.toDate = '';
          this.currentUser = '';
          this.unfilteredResult = [];
          this.setSelfDate ("week");
          $("#select2-chosen-1").text('');
        },
        getUsername (id) {
          if (id == null) {
            return 'N/A';
          }

          let username = 'N/A';
          this.users.forEach(user => {
            if (user.userId == id) {
              username = user.username + ' (id: ' + id + ')';
            }
          });
          return (username !== 'undefined')
            ? username
            : 'N/A';
        },
        noteShowHide (status, id) {
          if (status === 'collapse') {
            $('.noteCollapsed[data-id=' + id + ']').removeClass('hidden');
            $('.noteExpanded[data-id=' + id + ']').addClass('hidden');
          }
          if (status === 'expand') {
            $('.noteCollapsed[data-id=' + id + ']').addClass('hidden');
            $('.noteExpanded[data-id=' + id + ']').removeClass('hidden');
          }
        },
        getTranslations () {
          let translationsArray = [];
          $('#roles_translations span').each(function () {
            translationsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.translations = translationsArray;
          let errorsArray = [];
          $('#errors_translations span').each(function () {
            errorsArray[$(this).attr('data-id')] = $(this).html();
          });
          this.errorsTranslations = errorsArray;
          let stringsArray = [];
          let typesObj = {};
          $('#strings_translations span').each(function () {
            stringsArray[$(this).attr('data-id')] = $(this).html();
            if ($(this).attr('data-name')) {
              typesObj[$(this).attr('data-name')] = $(this).html();
            }
          });
          this.strings = stringsArray;
          this.typeTranslations = typesObj;
          let tableHeadingsObj = {};
          $('#table_headings_translations span').each(function () {
            tableHeadingsObj[$(this).attr('data-name')] = $(this).html();
          });
          this.tableHeadings = tableHeadingsObj;
        },
      },
      computed: {
        uniqueRoles () {
          let sortedUsers = this.usersSorted;
          /* Find the first and last occurences of role */
          let roles = sortedUsers.map(user => {
            return parseInt(user.role);
          });
          return roles.filter(function (value, index, self) {
            return self.indexOf(value) === index;
          });
        },
        userTree () {
          let that = this;
          let users = [];
          this.users.forEach(user => {
            if (typeof user === 'object') {
              if (typeof (users[user.role]) !== 'object') {
                users[user.role] = [];
              }
              if (user.position == 'parent') {
                this.translations[parseInt(
                  user.role)] = this.translations[this.parent];
              }
              if (user.position == 'self') {
                this.translations[parseInt(
                  user.role)] = this.translations[this.self];
              }
              users[parseInt(user.role)].push({
                'username': user.username,
                'id': parseInt(user.userId),
                'position': user.position,
              });
            }
          }, that);
          const {
            translations,
          } = this;
          return users;
        },
        usersSorted () {
          return this.users.sort((a, b) => {
            return (b.role - a.role) || a.username.localeCompare(b.username);
          });
        },
        result () {
          let that = this;
          this.totalAmount = 0;
          return this.unfilteredResult.map(res => {
            this.totalAmount = this.totalAmount + parseInt(res.amount);
            return {
              'type': this.typeTranslations[res.type],
              'fromUser': this.getUsername(res.fromUserId),
              'toUser': this.getUsername(res.toUserId),
              'amount': formatMoney(res.amount, this.currency),
              'dateTime': res.dateTime,
              'note': res.note,
              'referenceId': res.referenceId,
            };
          }, that);
        },
      },
      created () {
        if (!document.getElementById('agent-cash-in-hand-transactions')) {
          return;
        }

        setDate('week', this);

        api.getAgentHierarchyFull().done(res => {
          if (res[0] === false) { //TODO: Temporary fix because platform returns false if there is no parent
            res.shift();
          }
          this.users = res;
        });

        api.getPlayer().done(res => {
          this.currentUser = res.user_id;
          this.currency = res.currency;
        });

        this.getTranslations();
        this.fn = formatMoney;
      },
      mounted () {
        if (!document.getElementById('agent-cash-in-hand-transactions')) {
          return;
        }

        // Initialize datepickers
        const that = this;
        const $startDate = $(this.$refs.fromDate);
        const $endDate = $(this.$refs.toDate);

        $startDate.datepicker({
          language: setDefaultLanguage(__APP__.langShort),
          dateFormat: 'dd-mm-yyyy',
          maxDate: new Date(),
          onSelect (formattedDate, date) {
            that.fromDate = formattedDate;
            $endDate.datepicker().data('datepicker').update('minDate', date);
          },
        });

        $endDate.datepicker({
          language: setDefaultLanguage(__APP__.langShort),
          dateFormat: 'dd-mm-yyyy',
          maxDate: new Date(),
          onSelect (formattedDate) {
            that.toDate = formattedDate;
          },
        });

        this.$nextTick(function () {
          let that = this;
          $('#financial_transactions_select').select2().on('change', function () {
            that.currentUser = this.value;
          });
        });
      },
    });

     /* -----------------------------------------
  Agent Commission - Show Plan To Agent
  ----------------------------------------- */
  const AgentCommissionPlan = new Vue({
    el: '.agent-commission-plan',
    data: {
      planName: '',
      planCurrency: '',
      planTemplate: '',
      planDetails: ''
    },
    created() {
      if (!document.getElementById('agent-commission-plan')) {
        return;
      }
      api.agentCommissionPlanCurrent()
        .done((res) => {
          this.planName = res.name;
          this.planTemplate = res.template;
          this.planCurrency = res.currency;
          this.planDetails = res.details;
        })
    }
  });

  /* -----------------------------------------
  Agent Commission - Create New Plan
  ----------------------------------------- */
  const AgentCommissionCreateNewPlan = new Vue({
    el: '.agent-commission-plans-create-new-plan',
    data: {
      notEditableName: '',
      name: '',
      paymentMethods: [],
      planType: -1,
      currency: '',
      errorMessage: '',
      createPlan: true,
      addRange: false,
      planId: '',
      method: '',
      amount: '',
      rangeFrom: '',
      rangeTo: '',
      revenueShare: '',
      checked: true,
      ranges: [],
      coefficients: [],
      tempCoefficients: [],
      defaultCoefficient: '',
      totalCoefficients: [],
      row: '',
      exception: '',
      loading: true,
      success: false,
      error: false,
      responseMessage: '',
      exceptionId: 0
    },
    methods: {
      closeAlert() {
        let that = this;
        that.error = false;
      },
      removeException(id, name) {
        let val='';
        switch (name) {
          case 'BIA':
            val = '201';
            break;
          case 'GameHub':
            val = '220';
            break;
          case 'Inbet':
            val = '221';
            break;
          case 'Evolution':
            val = '223';
            break;
          case 'WM':
            val = '224';
            break;
          case 'WM PlayLabs':
            val = '225';
            break;
        }
        let i = 0;
        let row;
        for (i=0; i<this.tempCoefficients.length; i++) {
          if (this.tempCoefficients[i].hasOwnProperty(val)) {
            this.tempCoefficients.splice(i, 1);
          }
        }
        row = $("tr[data-tr-id=" + id + "]").css('display', 'none');
      },
      submitCreate() {
        this.loading = true;
        const {
          name,
          planType
        } = this;
        api.agentCommmissionCreateNewPlan(name, planType)
          .done((res) => {
            this.success = true;
            this.responseMessage = 'addRanges';
            this.error = false;
            this.planId = res.planId;
            this.createPlan=false;
            this.addRange = true;
            this.updateRanges();
          })
          .fail(({ responseJSON: error }) => {
            this.responseMessage = error.message;
            //setTimeOut('.errorCreatePlanMessage');
            this.success = false;
            this.error = true;
          })
          .always(() => this.loading = false);
      },
      updateRanges() {
        if(this.planId !== '') {
          api.agentGetCommmissionPlan(this.planId)
            .done((res) => {
              this.notEditableName = res.name;
              this.currency = res.currency;
              this.method = res.template;
              this.ranges = res.details.ranges;
            })
            .fail(({ responseJSON: error }) => {
              this.responseMessage = error.message;
              this.success = false;
              this.error = true;
            })
            .always(() => this.loading = false);
        }
      },
      getServices(key) {
        switch(key) {
          case '201':
            return 'BIA';
            break;
          case '220':
            return 'GameHub';
            break;
          case '221':
            return 'Inbet';
            break;
          case '223':
            return 'Evolution';
            break;
          case '224':
            return 'WM';
            break;
          case '225':
            return 'WM PlayLabs';
            break;
        }
      },
      addNewException(key, val) {
        let that = this;
        this.tempCoefficients.push({
          [key]: fromCents(val)
        });

        let serviceName = this.getServices(key);

        that.row = '<tr class="togetHided" data-service-name="'+serviceName+'" data-service-coefficient="'+val+'" data-tr-id="'+ that.exceptionId++ +'"><td>Exception</td><td></td><td>'+serviceName+': '+val+'%</td><td><button class="btn btn-cps-button btn-remove-exception close">&times;</button></td></tr>';
        $('tBody.exceptionTr').append(that.row);
        that.exception='';
        that.coefficients = '';
      },
      addNewRange() {
        $('.togetHided').css('display', 'none');
        let localCoefficients = [];
        localCoefficients = JSON.stringify((Object.assign({}, ...this.tempCoefficients)));
        this.tempCoefficients = [];
        this.loading = true;
        const {
          planId,
          rangeFrom,
          rangeTo,
          defaultCoefficient,
        } = this;
        api.agentCommmissionAddRange(planId, rangeFrom, rangeTo, fromCents(defaultCoefficient), localCoefficients)
          .done((res) => {
            this.error = false;
            this.rangeFrom = '';
            this.rangeTo = '';
            this.defaultCoefficient = '';
            this.updateRanges();
          })
          .fail(({ responseJSON: error }) => {
            if (error.message) {
              this.responseMessage = error.message;
            }
            else {
              this.responseMessage = error[0].message;
            }
            this.success = false;
            this.error = true;
            //setTimeOut('.errorAddNewRangeMessageOverlapes');
          })
          .always(() => this.loading = false);
      },
      removeRange(from, to) {
        api.agentCommmissionRemoveRange(this.planId, from, to)
          .done((res) => {
            this.error = false;
            //setTimeOut('.successRemoveRangeMessage');
            this.updateRanges();
          })
          .fail(({ responseJSON: error }) => {
            this.responseMessage = error.message;
            this.success = false;
            this.error = true;
            //setTimeOut('.errorRemoveRangeMessage');
          })
          .always(() => this.loading = false);
      }
    },
    created() {
      if (!document.getElementById('agent-commission-plans-create-new-plan')) {
        return;
      }
      let that = this;

      $(document).on('keypress',function(e) {
        if(e.which == 13) {
          that.addNewRange();
        }
      });

      $('body').on('click', '.btn-remove-exception', function() {
        let tr_id = $(this).closest('tr').attr("data-tr-id");
        let service_name = $(this).closest('tr').attr("data-service-name");
        that.removeException(tr_id, service_name);
        //console.log(that.tempCoefficients);
      });

      if ($(".plan_id").val() !== '') {
        this.planId = $(".plan_id").val();
        this.createPlan = false;
        this.addRange = true;
        api.agentGetCommmissionPlan(this.planId)
          .done((res) => {
            this.error = false;
            this.currency = res.currency;
            this.method = res.template;
            this.ranges = res.details.ranges;
            this.notEditableName = res.name;
          })
          .fail(({ responseJSON: error }) => {
            this.responseMessage = error.message;
            this.success = false;
            this.error = true;
          })
          .always(() => this.loading = false);
      }

      api.agentCommissiontGetAvailableservices()
        .done((res) => {
          this.error = false;
          this.name = res.name;
          this.totalCoefficients = res;
        })
        .fail(({ responseJSON: error }) => {
          this.responseMessage = error.message;
          this.success = false;
          this.error = true;
        })
        .always(() => this.loading = false);

      api.getBalance().done(res => {
        this.currency = res.currency;
      });

      api.agentGetAvailablePaymentMethods()
        .done(res => {
          this.paymentMethods = res;
        })
        .fail(({ responseJSON: error }) => {
          this.responseMessage = error.message;
          this.success = false;
          this.error = true;
        });
    },
    computed: {
      buttonDisable() {
        return (!((this.planType !== -1) && this.currency && this.name));
      }
    }
  });

  /* -----------------------------------------
  Agent Commission Plan List
  ----------------------------------------- */
  const AgentCommissionShowPlanList = new Vue({
    el: '.agent-commission-plans-show-plan-list',
    data: {
      plans: [],
      loading: true,
    },
    created () {
      if (!document.getElementById('agent-commission-plans-show-plan-list')) {
        return;
      }

      api.agentCommissiontGetPlanList()
        .done((res) => {
          this.plans = res;
        })
        .fail((error) => {
          this.error = true;
          this.success = false;
        })
        .always(() => this.loading = false);
    },
  });

  /* -----------------------------------------
  Agent Commission Assign Plan to Agent
  ----------------------------------------- */
  const AgentCommissionAssignPlan = new Vue({
    el: '.agent-commission-plans-assign-plan',
    data: {
      planId: $("#assignPlanId").val(),
      planInfo: [],
      allUsers: {},
      partners: '',
      superagents: 0,
      agents: '',
      cashiers: '',
      users: '',
      userToBeAssigned: '',
      ranges: [],
      success: false,
      error: false,
      errorCode: '',
      loading: false,
      errorMessage: ''
    },
    methods: {
      closeAlert() {
        let that = this;
        that.error = false;
      },
      resetMessage() {
        this.error = false;
        this.success = true;
      },
      replacePlan() {
        api.agentCommissiontUnassignPlanFromAgent(this.agents)
          .done((res) => {
            this.assignPlanToAgent();
          })
          .fail((error) => {
            if (error.responseJSON.code == 0) {
              this.errorCode = 'fieldEc2';
              this.error = true;
              this.success = false;
            }
            this.success=false;
            this.error=true;
            this.errorMessage = error.message;
            setTimeOut('.alert-danger');
          })
          .always(() => this.loading = false);
      },
      assignPlanToAgent() {
        let that = this;
        that.userToBeAssigned = this.agents;
        api.agentCommissiontAssignAgent(that.userToBeAssigned, this.planId)
          .done((res) => {
            this.error = false;
            this.success = true;
            setTimeOut('.alert-success');
          })
          .fail((error) => {
            if (error.field = 'userId') {
              this.errorCode = 'fieldEc1';
              this.error = true;
              this.success = false;
            }
          })
          .always(() => this.loading = false);
      }
    },
    computed: {
      disabledButton() {
        return this.agents > 0;
      },
    },
    created () {
      if (!document.getElementById('agent-commission-plans-assign-plan')) {
        return;
      }

      api.getAgentHierarchyFull()
        .done((res) => {
          this.allUsers = res;
          this.error = false;
        })
        .fail((error) => {
          consoleLog(error);
          this.error = true;
          this.success = false;
        })
        .always(() => this.loading = false);

      api.agentGetCommmissionPlan(this.planId)
        .done((res) => {
          this.planInfo = res;
          this.ranges = res.details.ranges;
          this.error = false;
        })
        .fail((error) => {
          consoleLog(error);
          this.error = true;
          this.success = false;
        })
        .always(() => this.loading = false);
    },
  });

  /* -----------------------------------------
  Agent Commission Report
  ----------------------------------------- */
  const AgentCommissionReport = new Vue({
    el: '.agent-commission-report',
    data: {
      agentId: '',
      activeBtn: '',
      reports: {},
      users: [],
      agents: [],
      cashiers: [],
      simpleUsers: [],
      fromDate: '',
      toDate: '',
      totalPages: '',
      page: '',
      activePage: 1,
      pageSize: 20,
      groupBySelected: "day",
      loading: true,
      role: '',
      dateColumn: '',
      disableButton: false,
      currency: '',
      currentUser: [],
    },
    methods: {
      showReports(selectedPage='') {
        this.disableButton = true;
        this.reports = 0;
        this.loading = true;
        const {
          fromDate=this.fromDate ? this.fromDate : '',
          toDate=this.toDate ? this.toDate : '',
          current_page=selectedPage,
          page_size=this.pageSize,
          agent_id=this.agentId,
          selectedGroup=this.groupBySelected
        } = this;
        api.agentCommissionDailyReports(reverseDateFormat(fromDate), reverseDateFormat(toDate), current_page, page_size, agent_id, selectedGroup)
          .done((res) => {
            if (res) {
              this.reports = res;
              this.page = res[0].info.page;
              this.totalPages = res[0].info.totalPages;
              this.pageSize = res[0].info.pageSize;
              this.fromDate = reverseDateFormat(res[0].info.dateFrom);
              this.toDate = reverseDateFormat(res[0].info.dateTo);
            }
            else {
              this.reports = 0;
              this.error = true;
              this.success = false;
            }
          })  
          .fail((error) => {
            consoleLog(error);
            this.error = true;
            this.success = false;
          })
          .always(() => {
            this.loading = false;
            this.disableButton = false;
            addSticky('th');
          })
      },

      cancel() {
        this.fromDate="";
        this.toDate="";
        this.page="";
        this.pageSize=20,
        this.agentId = this.currentUser.role === "20" ? this.currentUser.username : "";
        this.groupBySelected="day";
      },

      setActivePage(page) {
        this.activePage = page;
      },

      goToPage(selectedPage) {
        this.showReports(selectedPage);
      },

      sortResults() {
        this.showReports();
      },

      submit() {
        this.showReports();
      },

      setSelfDate (from) {
        this.activeBtn = from;
        setDate(from, this);
      },
    },
    created () {
      if (!document.getElementById('agent-commission-report')) {
        return;
      }

      api.getPlayer()
        .done(res => {
            this.currentUser.role = localStorage.getItem('role');
            this.currentUser.agentId = res.user_id;
            this.currentUser.username = res.username;
            if (this.currentUser.role === "20") {
              this.agentId = this.currentUser.agentId;
              $(".group-by-commission-reports").css('display', 'none');
            }
        });

      api.getBalance().done(res => {
        this.currency = res.currency;
      });

      this.role = window.localStorage.getItem('role');

      this.showReports();

      api.getAgentHierarchyChildren()
        .done((res) => {
          let that = this;
          that.users = res;
          that.users.forEach(function(entry) {
            switch (entry.role) {
              case '20':
                that.agents.push(entry);
                break;
              /*case '15':
                that.cashiers.push(entry);
                break;
              case '10':
                that.simpleUsers.push(entry);
                break;*/
            }

          })
        })
        .fail((error) => {
          consoleLog(error);
        })
        .always(() => this.loading = false);

    },
    mounted () {
      if (!document.getElementById('agent-commission-report')) {
        return;
      }

      // Initialize datepickers
      const that = this;
      const $startDate = $(this.$refs.fromDate);
      const $endDate = $(this.$refs.toDate);

      $startDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        autoClose: true,
        onSelect (formattedDate, date) {
          that.fromDate = formattedDate;
          $endDate.datepicker().data('datepicker').update('minDate', date);
        },
      });

      $endDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate) {
          that.toDate = formattedDate;
          that.activeBtn = '';
        },
      });
    },
    computed: {
      formattedReports() {
        return this.reports[0].data
          .map(row => ({
            ...row,
            winnings: this.reports[0].data.map(item => (formatMoney(item.winnings, this.currency))),
            stakes: this.reports[0].data.map(item => (formatMoney(item.stakes, this.currency))),
            commission: this.reports[0].data.map(item => (formatMoney(item.commission, this.currency))),
            profit: this.reports[0].data.map(item => (formatMoney(item.profit, this.currency)))
          }));
      },

      formattedReportsTotalsPerPage() {
        return this.reports[0].pageTotals
          .map(row => ({
            ...row,
            winnings: this.reports[0].pageTotals.map(item => (formatMoney(item.winnings, this.currency))),
            stakes: this.reports[0].pageTotals.map(item => (formatMoney(item.stakes, this.currency))),
            commission: this.reports[0].pageTotals.map(item => (formatMoney(item.commission, this.currency))),
            profit: this.reports[0].pageTotals.map(item => (formatMoney(item.profit, this.currency)))
          }));
      },

      formattedReportsTotals() {
        return this.reports[0].totals
          .map(row => ({
            ...row,
            winnings: this.reports[0].totals.map(item => (formatMoney(item.winnings, this.currency))),
            stakes: this.reports[0].totals.map(item => (formatMoney(item.stakes, this.currency))),
            commission: this.reports[0].totals.map(item => (formatMoney(item.commission, this.currency))),
            profit: this.reports[0].totals.map(item => (formatMoney(item.profit, this.currency)))
          }));
      },
      formattedDate() {
        return (this.reports[0].data[0].date !== 'All') ? this.reports[0].data.map(item => reverseDateFormat(item.date)) : 'ALL';
      },
      agentUsername() {
        return (this.currentUser.role === "20") ? this.currentUser.username : $('#commission_report_select option:selected').html();
      }
    },

    watch: {
      groupBySelected() {
        if (this.groupBySelected === 'agent') {
          this.agentId = '';
        }
      },
      agentId() {
        if (this.agentId > 0) {
          this.groupBySelected = 'day';
        }
      },
    }
  });

  /* -----------------------------------------
  Agent Overall Activity Report
  ----------------------------------------- */
  const AgentOverallActivityReport = new Vue({
    el: '.agent-overall-activity-report',
    data: {
      activeBtn: 'week',
      currency: '',
      filters: [],
      fn: '',
      displaySearch: false,
      error: '',
      errorMessage: '',
      fromDate: '',
      toDate: '',
      agent: '',
      user: '',
      loggedInRole: __APP__.agentRole,
      agents: [],
      users: [],
      userId: '',
      constantLoggedInId: 0,
      constantPartnerId: 0,
      constantSuperAgentId: 0,
      constantAgentId: 0,
      constantUserId: 0,
      betmode: '',
      loading: false,
      selections: '',
      picked: 'date_created',
      totalPages: 0,
      activePage: 0,
      pageSize: 20,
      page: '',
      searchResults: [],
      tempSearchResults: [],
      overall: [],
      userHierarchy: [],
      subrows: [],
      subrows2: [],
      subrows3: [],
      subUserId: '',
      tempLvl1Idx: '',
      tempLvl2Idx: '',
      tempLvl3Idx: '',
      ds_date: '',
      dc_date: '',
      filteredPartners: [],
      filteredSuperagents: [],
      filteredAgents: [],
      filteredUsers: [],
      disableButton: false,
      showMessage: false,
      localClass: '',
      dateFrom:'',
      dateTo:'',
      totalSbStakesPerPage: 0,
      totalSbWinningsPerPage: 0,
      totalSbNetPerPage: 0,
      totalCasinoStakesPerPage: 0,
      totalCasinoWinningsPerPage: 0,
      totalCasinoNetPerPage: 0,
      totalStakesPerPage: 0,
      totalWinningsPerPage: 0,
      totalNetPerPage: 0,
      totalMarginPerPage: 0,
      totalMoneyInPerPage: 0,
      totalMoneyOutPerPage: 0,
      totalSbStakesOverall: 0,
      totalSbWinningsOverall: 0,
      totalSbNetOverall: 0,
      totalCasinoStakesOverall: 0,
      totalCasinoWinningsOverall: 0,
      totalCasinoNetOverall: 0,
      totalStakesOverall: 0,
      totalWinningsOverall: 0,
      totalNetOverall: 0,
      totalMarginOverall: 0,
      totalMoneyInOverall: 0,
      totalMoneyOutOverall: 0,
      totalMoneyResultPerPage: 0,
      totalMoneyResultOverall:0,
      notificationMessage: false,
      settledFrom: '',
      settledTo: '',
      paidFrom: '',
      paidTo: '',
    },

    methods: {

      showLvl1Children(lvl1AgentId, lvl1Idx) {
        if ($("#lvl1-bordered-collapse-" + lvl1Idx).hasClass("lvl1Closed")) {
          this.tempLvl1Idx = lvl1Idx;
          this.getAccountingResults(lvl1AgentId, 'lvl1', true);
          $("#lvl1-subrow-" + lvl1Idx).removeClass("d-none");
          $("#lvl1-bordered-collapse-" + lvl1Idx).removeClass("lvl1Closed").addClass("lvl1Opened").html('-');
        }
        else if ($("#lvl1-bordered-collapse-" + lvl1Idx).hasClass("lvl1Opened")) {
          this.subrows[lvl1Idx] = '';
          $("#lvl1-subrow-" + lvl1Idx).addClass("d-none");
          $("#lvl1-bordered-collapse-" + lvl1Idx).removeClass("lvl1Opened").addClass("lvl1Closed").html('+');
        }

      },
      showLvl2Children(lvl2AgentId, lvl2Idx, lvl1Idx='') {
        this.tempLvl3Idx = '';
        let subSuffix = lvl1Idx + "-" + lvl2Idx;
        if ($("#lvl2-sub-bordered-collapse-" + subSuffix).hasClass("lvl2Closed")) {
          this.tempLvl1Idx = lvl1Idx;
          this.tempLvl2Idx = lvl2Idx;
          this.subUserId = lvl2AgentId;
          this.getAccountingResults(lvl2AgentId, 'lvl2', true);
          $("#lvl2-subrow-" + subSuffix).removeClass("d-none");
          $("#lvl2-sub-bordered-collapse-" + subSuffix).removeClass("lvl2Closed").addClass("lvl2Opened").html('-');
        }
        else if ($("#lvl2-sub-bordered-collapse-" + subSuffix).hasClass("lvl2Opened")) {
          this.subrows2[subSuffix] = '';
          $("#lvl2-subrow-" + subSuffix).addClass("d-none");
          $("#lvl2-sub-bordered-collapse-" + subSuffix).removeClass("lvl2Opened").addClass("lvl2Closed").html('+');
        }

      },
      showLvl3Children(lvl3AgentId, lvl3Idx, lvl1Idx='', lvl2Idx='') {
        this.tempLvl3Idx = '';
        let subSuffix = lvl1Idx + "-" + lvl2Idx + "-" + lvl3Idx;
        if ($("#lvl3-sub-bordered-collapse-" + subSuffix).hasClass("lvl3Closed")) {
          this.tempLvl1Idx = lvl1Idx;
          this.tempLvl2Idx = lvl2Idx;
          this.tempLvl3Idx = lvl3Idx;
          this.subUserId = lvl3AgentId;
          this.getAccountingResults(lvl3AgentId, 'lvl3', "#lvl3-sub-bordered-collapse-" + subSuffix);
          $("#lvl3-subrow-" + subSuffix).removeClass("d-none");
          $("#lvl3-sub-bordered-collapse-" + subSuffix).removeClass("lvl3Closed").addClass("lvl3Opened").html('-');
        }
        else if ($("#lvl3-sub-bordered-collapse-" + subSuffix).hasClass("lvl3Opened")) {
          this.subrows3[lvl1Idx + '-' + lvl2Idx + '-' + lvl3Idx] = '';
          $("#lvl3-subrow-" + subSuffix).addClass("d-none");
          $("#lvl3-sub-bordered-collapse-" + subSuffix).removeClass("lvl3Opened").addClass("lvl3Closed").html('+');
        }
      },

      getUserHierarchy(selectedRole='') {
        api.getAgentDirectChildren(this.userId)
          .done(res => {
            this.userHierarchy = sortAlphabeticalArrayByValue(res);
            if (selectedRole === 'partner') {
              $("#select2-chosen-2").text('All');
              $("#select2-chosen-3").text('All');
              $("#select2-chosen-4").text('All');
              this.filteredSuperagents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_SUPER_AGENT
              );

              this.filteredAgents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_AGENT
              );

              this.filteredUsers = this.userHierarchy.filter(agent =>
                agent.role === ROLE_USER
              );
            }
            else if (selectedRole === 'superagent') {
              $("#select2-chosen-3").text('All');
              $("#select2-chosen-4").text('All');
              this.filteredAgents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_AGENT
              );

              this.filteredUsers = this.userHierarchy.filter(agent =>
                agent.role === ROLE_USER
              );

            }
            else if (selectedRole === 'agent') {
              $("#select2-chosen-3").text('All');
              this.filteredUsers = this.userHierarchy.filter(agent =>
                agent.role === ROLE_USER
              );

            }
            else if (selectedRole === 'user') {
              $("#select2-chosen-4").text('All');
              this.filteredUsers = this.userHierarchy.filter(agent =>
                agent.role === ROLE_USER
              );
              return;
            }
            else {
              this.filteredPartners = this.userHierarchy.filter(agent =>
                agent.role === ROLE_PARTNER
              );

              this.filteredSuperagents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_SUPER_AGENT
              );

              this.filteredAgents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_AGENT
              );

              this.filteredUsers = this.userHierarchy.filter(agent =>
                agent.role === ROLE_USER
              );
            }
          })
          .fail((error) => {
            consoleLog(error);
          })
          .always(() => {
            this.loading = false;
          });
      },

      goToPage(selectedPage) {
        this.activePage = selectedPage;
        this.getAccountingResults();
      },

      getResultsNo() {
        this.getAccountingResults();
      },

      removeFilter(selectedFilter) {
        let that = this;
        switch(selectedFilter) {

          case 'selectedDate':
            setDate('week', this);
            this.dateFrom='';
            this.dateTo='';
            break;

          case 'selectedStatus':
            this.status='';
            break;

          case 'selectedPaidout':
            this.paidout='';
            break;

          case 'selectedUser':
            this.userId= this.constantLoggedInId;
            this.filters['user'] = this.username;
            that.constantPartnertId = 0;
            that.constantSuperAgentId = 0;
            that.constantAgentId = 0;
            that.constantUserId = 0;
            $("#select2-chosen-1").text('All');
            $("#select2-chosen-2").text('All');
            $("#select2-chosen-3").text('All');
            $("#select2-chosen-4").text('All');
            break;
        }
        this.getUserHierarchy();
        this.getAccountingResults();
      },

      setSelfDate (from) {
        this.activeBtn = from;
        setDate(from, this);
      },

      modifyDates(wantedDate) {
        let today = new Date();
        switch(wantedDate) {
          case 'today':
            let dd = today.getDate() > 9 ? today.getDate() : '0' + today.getDate();
            let mm = today.getMonth() + 1 > 9 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1);
            let yyyy = today.getFullYear();
            return dd + '-' + mm + '-' + yyyy;
            break;

          case 'week':
            let day = today.getDay();
            let diff = today.getDate() - day + (day == 0 ? -6 : 1);
            return reverseDateFormat(this.formatDate(new Date(today.setDate(diff))));
            break;
        }
      },

      getParams(page=0) {
        let that = this;

        if (this.picked === 'date_created') {
          that.filters['picked'] = 'date_created';
          this.dateFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.dateTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.settledFrom = '';
          this.settledTo = '';
          this.paidFrom = '';
          this.paidTo = '';
          this.filters['settledFrom'] = '';
          this.filters['settledTo'] = '';
          that.filters['dateFrom'] = (this.dateFrom) ? this.dateFrom : '';
          that.filters['dateTo'] = (this.dateTo) ? this.dateTo : '';
          this.filters['paidFrom'] = '';
          this.filters['paidTo'] = '';
        }
        else if (this.picked === 'date_settled') {
          that.filters['picked'] = 'date_settled';
          this.dateFrom = '';
          this.dateTo = '';
          this.paidFrom = '';
          this.paidTo = '';
          this.settledFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.settledTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.filters['dateFrom'] = '';
          this.filters['dateTo'] = '';
          that.filters['settledFrom'] = (this.settledFrom) ? this.settledFrom : '';
          that.filters['settledTo'] = (this.settledTo) ? this.settledTo : '';
          this.filters['paidFrom'] = '';
          this.filters['paidTo'] = '';
        }
        else if (this.picked === 'date_paid') {
          that.filters['picked'] = 'date_paid';
          this.dateFrom = '';
          this.dateTo = '';
          this.settledFrom = '';
          this.settledTo = '';
          this.paidFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.paidTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.filters['dateFrom'] = '';
          this.filters['dateTo'] = '';
          this.filters['settledFrom'] = '';
          this.filters['settledTo'] = '';
          that.filters['paidFrom'] = (this.paidFrom) ? this.paidFrom : '';
          that.filters['paidTo'] = (this.paidTo) ? this.paidTo : '';
        }

        if (page > 0) {
          this.activePage = page;
        }

        if (this.subUserId > 0) {
          that.userId = this.subUserId;
        }
        else if (that.constantAgentId > 0) {
          that.userId = that.constantAgentId;
        }
        else if (that.constantSuperAgentId > 0) {
          that.userId = that.constantSuperAgentId;
        }
        else if (that.constantPartnerId > 0) {
          that.userId = that.constantPartnerId;
        }
        else if (that.constantUserId > 0) {
          that.userId = that.constantUserId;
        }
        else {
          that.userId = '';
        }
      },

      reset() {
        let that = this;
        this.dateFrom = "";
        this.dateTo = "";
        setDate('week', this);
        this.displaySearch = false;
        this.filters = [];
        this.activePage = 0;
        this.pageSize = 20;
        this.subUserId = 0;
        that.constantPartnerId = 0;
        that.constantSuperAgentId = 0;
        that.constantAgentId = 0;
        that.constantUserId = 0;
        $("#select2-chosen-1").text('All');
        $("#select2-chosen-2").text('All');
        $("#select2-chosen-3").text('All');
        $("#select2-chosen-4").text('All');
        this.picked = 'date_created';
      },

      formatDate(date) {
        let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      },

      getUserId(asCsv=false) {
        if (this.subUserId > 0 && !asCsv) {
          return this.subUserId;
        }
        else {
          if (this.constantAgentId > 0) {
            return this.constantAgentId;
          }
          else if (this.constantSuperAgentId > 0) {
            return this.constantSuperAgentId;
          }
          else if (this.constantPartnerId > 0) {
            return this.constantPartnerId;
          }
          else if (this.constantUserId > 0) {
            return this.constantUserId;
          }
          else {
            return '';
          }
        }
      },

      saveReport() {
        this.disableButton = true;
        this.loading = true;
        this.notificationMessage = true;

        api.generateOverallActivityReport(reverseDateFormat(this.dateFrom), reverseDateFormat(this.dateTo), reverseDateFormat(this.settledFrom), reverseDateFormat(this.settledTo), reverseDateFormat(this.paidFrom), reverseDateFormat(this.paidTo), this.getUserId(true), this.pageSize, this.activePage)
          .done(() => {
            this.notificationMessage = false;
            this.success = true;
            this.error = false;
            this.message = $("#csvSuccess").val();
            this.localClass = 'alert-success';
            this.showMessage = true;
          })
          .fail(() => {
            this.notificationMessage = false;
            this.message = $("#csvError").val();
            this.localClass = 'alert-danger';
            this.showMessage = true;
          })
          .always(() => {
            this.loading = false;
            this.disableButton = false;
            setTimeout(() => {
              this.showMessage = false;
              }, 3000);
          })
      },

      getAccountingResults(currentValue='', subRowsType='', isSubRow=false, asCsv=0) {
        if (subRowsType === '') {
          $(".innerBody").addClass("d-none");
          $(".bordered-collapse").each(function () {
            if ($(this).hasClass("lvl1Opened")) {
              $(this).removeClass("lvl1Opened").addClass("lvl1Closed").html('+');
            }
            if ($(this).hasClass("lvl2Opened")) {
              $(this).removeClass("lvl2Opened").addClass("lvl2Closed").html('+');
            }
          });
        }
        let that = this;
        this.disableButton = true;
        this.getParams();
        this.loading = true;
        this.filters['user'] = ($("#select2-chosen-4").length > 0 && $("#select2-chosen-4").text() !== 'All') ? $("#select2-chosen-4").text()
        :($("#select2-chosen-3").length > 0 && $("#select2-chosen-3").text() !== 'All') ? $("#select2-chosen-3").text()
          : ($("#select2-chosen-2").length > 0 && $("#select2-chosen-2").text() !== 'All') ? $("#select2-chosen-2").text()
            : ($("#select2-chosen-1").length > 0 && $("#select2-chosen-1").text() !== 'All') ? $("#select2-chosen-1").text()
              : this.username;

        this.subUserId = currentValue;

        this.getParams(this.activePage);

        api.generateOverallActivityReport(reverseDateFormat(this.dateFrom), reverseDateFormat(this.dateTo), reverseDateFormat(this.settledFrom), reverseDateFormat(this.settledTo), reverseDateFormat(this.paidFrom), reverseDateFormat(this.paidTo), that.userId, this.pageSize, this.activePage, asCsv)
          .done(res => {
            if (asCsv) {
              this.success = true;
              this.error = false;
              this.message = $("#csvSuccess").val();
              this.localClass = 'alert-success';
              this.showMessage = true;
            }
            else {
              if(res.list.length > 0) {
                this.displaySearch = true;
                let that = this;
                this.error = false;

                this.totalPages = parseInt(res.pagination.pageCount);
                this.error = false;

                if (!isSubRow) {
                  this.totalSbStakesPerPage = swapCurrency(formatMoney(res.summary.page.sbStakes, this.currency));
                  this.totalSbWinningsPerPage = swapCurrency(formatMoney(res.summary.page.sbWinnings, this.currency));
                  this.totalSbNetPerPage = swapCurrency(formatMoney(res.summary.page.sbNet, this.currency));
                  this.totalCasinoStakesPerPage = swapCurrency(formatMoney(res.summary.page.casinoStakes, this.currency));
                  this.totalCasinoWinningsPerPage = swapCurrency(formatMoney(res.summary.page.casinoWinnings, this.currency));
                  this.totalCasinoNetPerPage = swapCurrency(formatMoney(res.summary.page.casinoNet, this.currency));
                  this.totalStakesPerPage = swapCurrency(formatMoney(res.summary.page.totalStakes, this.currency));
                  this.totalWinningsPerPage = swapCurrency(formatMoney(res.summary.page.totalWinnings, this.currency));
                  this.totalNetPerPage = swapCurrency(formatMoney(res.summary.page.totalNet, this.currency));
                  this.totalMarginPerPage = res.summary.page.margin;
                  this.totalMoneyInPerPage = swapCurrency(formatMoney(res.summary.page.moneyIn, this.currency));
                  this.totalMoneyOutPerPage = swapCurrency(formatMoney(res.summary.page.moneyOut, this.currency));
                  this.totalMoneyResultPerPage = swapCurrency(formatMoney((res.summary.page.moneyIn - res.summary.page.moneyOut), this.currency));

                  this.totalSbStakesOverall = swapCurrency(formatMoney(res.summary.overall.sbStakes, this.currency));
                  this.totalSbWinningsOverall = swapCurrency(formatMoney(res.summary.overall.sbWinnings, this.currency));
                  this.totalSbNetOverall = swapCurrency(formatMoney(res.summary.overall.sbNet, this.currency));
                  this.totalCasinoStakesOverall = swapCurrency(formatMoney(res.summary.overall.casinoStakes, this.currency));
                  this.totalCasinoWinningsOverall = swapCurrency(formatMoney(res.summary.overall.casinoWinnings, this.currency));
                  this.totalCasinoNetOverall = swapCurrency(formatMoney(res.summary.overall.casinoNet, this.currency));
                  this.totalStakesOverall = swapCurrency(formatMoney(res.summary.overall.totalStakes, this.currency));
                  this.totalWinningsOverall = swapCurrency(formatMoney(res.summary.overall.totalWinnings, this.currency));
                  this.totalNetOverall = swapCurrency(formatMoney(res.summary.overall.totalNet, this.currency));
                  this.totalMarginOverall = res.summary.overall.margin;
                  this.totalMoneyInOverall = swapCurrency(formatMoney(res.summary.overall.moneyIn, this.currency));
                  this.totalMoneyOutOverall = swapCurrency(formatMoney(res.summary.overall.moneyOut, this.currency));
                  this.totalMoneyResultOverall = swapCurrency(formatMoney((res.summary.overall.moneyIn - res.summary.overall.moneyOut), this.currency));
                }

                this.tempSearchResults = res.list.map(item => {
                  return {
                    'userId': item.userId,
                    'username': item.username,
                    'intUserRole': parseInt(item.role),
                    'sbStakes': swapCurrency(formatMoney(item.sbStakes, this.currency)),
                    'sbWinnings': swapCurrency(formatMoney(item.sbWinnings, this.currency)),
                    'sbNet': swapCurrency(formatMoney(item.sbNet, this.currency)),
                    'casinoStakes': swapCurrency(formatMoney(item.casinoStakes, this.currency)),
                    'casinoWinnings': swapCurrency(formatMoney(item.casinoWinnings, this.currency)),
                    'casinoNet': swapCurrency(formatMoney(item.casinoNet, this.currency)),
                    'totalStakes': swapCurrency(formatMoney(item.totalStakes, this.currency)),
                    'totalWinnings': swapCurrency(formatMoney(item.totalWinnings, this.currency)),
                    'totalNet': swapCurrency(formatMoney(item.totalNet, this.currency)),
                    'margin': item.margin,
                    'moneyIn': swapCurrency(formatMoney(item.moneyIn, this.currency)),
                    'moneyOut': swapCurrency(formatMoney(item.moneyOut, this.currency)),
                    'moneyResult': swapCurrency(formatMoney((item.moneyIn - item.moneyOut), this.currency)),
                  };
                }, that);

                if (!currentValue) {
                  this.searchResults = this.tempSearchResults;
                }
                else {
                  if (subRowsType === 'lvl1') {
                    this.subrows[this.tempLvl1Idx] = this.tempSearchResults;
                  }
                  else if (subRowsType === 'lvl2') {
                    this.subrows2[this.tempLvl1Idx + "-" + this.tempLvl2Idx] = this.tempSearchResults;
                  }
                  else {
                    this.subrows3[this.tempLvl1Idx + '-' + this.tempLvl2Idx + '-' + this.tempLvl3Idx] = this.tempSearchResults;
                  }
                }
              }
              if (currentValue === '' && res.list.length === 0) {
                this.displaySearch = false;
              }
            }

          })
          .fail(({ responseJSON: res }) => {
            this.error = true;
            if (res.errors) {
              if (this.asCsv) {
                this.message = $("#csvError").val();
                this.localClass = 'alert-danger';
                this.showMessage = true;
              }
              else {
                this.errorMessage = res.errors[0].message;
              }
            }
          })
          .always(() => {
            this.loading = false;
            this.disableButton = false;
            setTimeout(() => {
              this.showMessage = false;
              }, 3000);
            addSticky('th');
          });
      },

    },

    created() {
      if (!document.getElementById('agent-overall-activity-report')) {
        return;
      }

      setDate('week', this);

      api.getBalance()
        .done(res => {
          this.currency = res.currency;
        });

      this.error = false;
      api.getPlayer().done(res => {
        this.username = res.username;
        this.userId = res.user_id;
        this.constantLoggedInId = res.user_id;
        this.getUserHierarchy();
      });

    },

    mounted() {
      if (!document.getElementById('agent-overall-activity-report')) {
        return;
      }

      // Initialize datepickers
      const that = this;
      const $startDate = $(this.$refs.fromDate);
      const $endDate = $(this.$refs.toDate);

      $startDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate, date) {
          that.fromDate = formattedDate;
          $endDate.datepicker().data('datepicker').update('minDate', date);
        },
      });

      $endDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate) {
          that.toDate = formattedDate;
        },
      });

      $('#agent-overall-activity-report-partner').select2()
        .on('change', function () {
          that.constantAgentId = 0;
          that.constantSuperAgentId = 0;
          that.constantUserId = 0;
          that.constantPartnerId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantLoggedInId;
          that.getUserHierarchy('partner');
        });

      $('#agent-overall-activity-report-superagent').select2()
        .on('change', function () {
          that.constantAgentId = 0;
          that.constantUserId = 0;
          that.constantSuperAgentId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantLoggedInId;
          that.getUserHierarchy('superagent');
        });

      $('#agent-overall-activity-report-agent').select2()
        .on('change', function () {
          that.constantUserId = 0;
          that.constantAgentId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantSuperAgentId;
          that.getUserHierarchy('agent');
        });

        $('#agent-overall-activity-report-user').select2()
        .on('change', function () {
          // that.constantUserId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantLoggedInId;
          that.getUserHierarchy('user');
        });
    }

  });    

  /* -----------------------------------------
  Agent Commission Period Report
  ----------------------------------------- */
  const AgentCommissionPeriodReport = new Vue({
    el: '.agent-commission-period-report',
    data: {
      agentId: '',
      activeBtn: '',
      reports: {},
      users: [],
      agents: [],
      totalPages: '',
      page: '',
      activePage: 1,
      pageSize: 20,
      loading: true,
      role: '',
      disableButton: false,
      currency: '',
      currentUser: [],
      showReport: false,
    },
    methods: {
      showReports(selectedPage='') {
        this.disableButton = true;
        this.reports = 0;
        this.loading = true;
        const {
          current_page=selectedPage,
          page_size=this.pageSize,
          agent_id=this.agentId,
        } = this;
        api.agentCommissionPeriodReports(current_page, page_size, agent_id)
          .done((res) => {
            this.showReport = true;
            res.data.length > 0 ? this.reports = res : this.reports=0;
            this.page = res.pagination.currentPage;
            this.totalPages = res.pagination.pageCount;
            this.pageSize = res.pagination.perPage;
          })
          .fail((error) => {
            consoleLog(error);
            this.error = true;
            this.success = false;
          })
          .always(() => {
            this.loading = false;
            this.disableButton = false;
            addSticky('th');
          })
      },

      cancel() {
        this.page="";
        this.agentId = this.currentUser.role === ROLE_AGENT ? this.currentUser.username : "";
        this.showReports();
      },

      setActivePage(page) {
        this.activePage = page;
      },

      goToPage(selectedPage) {
        this.showReports(selectedPage);
      },

      sortResults() {
        this.showReports();
      },

      submit() {
        this.showReports();
      },

      setSelfDate (from) {
        this.activeBtn = from;
        setDate(from, this);
      },

    },
    computed: {
      formattedReports() {
        return this.reports.data
          .map(row => ({
            ...row,
            winnings: this.reports.data.map(item => (formatMoney(item.winnings, this.currency))),
            stakes: this.reports.data.map(item => (formatMoney(item.stakes, this.currency))),
            commission: this.reports.data.map(item => (formatMoney(item.commission, this.currency))),
            profit: this.reports.data.map(item => (formatMoney(item.profit, this.currency))),
            start: reverseDateFormat(row.start),
            end: reverseDateFormat(row.end)
          }));
      },

      formattedReportsTotalsPerPage() {
        return {
          stakes: formatMoney(this.reports.summary.page.stakes, this.currency),
          winnings: formatMoney(this.reports.summary.page.winnings, this.currency),
          profit: formatMoney(this.reports.summary.page.profit, this.currency),
          commission: formatMoney(this.reports.summary.page.commission, this.currency),
        };
      },

      formattedReportsTotals() {
        return {
          stakes: formatMoney(this.reports.summary.overall.stakes, this.currency),
          winnings: formatMoney(this.reports.summary.overall.winnings, this.currency),
          profit: formatMoney(this.reports.summary.overall.profit, this.currency),
          commission: formatMoney(this.reports.summary.overall.commission, this.currency),
        };
      },
      agentUsername() {
        return (this.currentUser.role === ROLE_AGENT) ? this.currentUser.username : $('#commission_report_select option:selected').html();
      }
    },
    created () {
      if (!document.getElementById('agent-commission-period-report')) {
        return;
      }

      api.getPlayer()
        .done(res => {
          this.currentUser.role = localStorage.getItem('role');
          this.currentUser.agentId = res.user_id;
          this.currentUser.username = res.username;
          if (this.currentUser.role === ROLE_AGENT) {
            this.agentId = this.currentUser.agentId;
            $(".group-by-commission-reports").css('display', 'none');
          }
        });

      api.getBalance().done(res => {
        this.currency = res.currency;
      });

      this.role = window.localStorage.getItem('role');

      this.showReports();

      api.getAgentHierarchyChildren()
        .done((res) => {
          let that = this;
          that.users = res;
          that.users.forEach(function(entry) {
            switch (entry.role) {
              case ROLE_AGENT:
                that.agents.push(entry);
                break;
            }
          })
        })
        .fail((error) => {
          consoleLog(error);
        })
        .always(() => this.loading = false);
    },
  });

 /* -----------------------------------------
  Agent New Casino Report
  ----------------------------------------- */
  const AgentNewCasinoReport = new Vue({
    el: '.agent-new-casino-report',
    data: {
      activeBtn: 'week',
      currency: '',
      filters: [],
      fn: '',
      displaySearch: false,
      disableButton: false,
      error: '',
      errorMessage: '',
      fromDate: '',
      toDate: '',
      createdFrom: '',
      createdTo: '',
      loggedInRole: __APP__.agentRole,
      superagents: [],
      agents: [],
      users: [],
      agentChildren: [],
      username: '',
      userId: '',
      constantLoggedInId: 0,
      constantPartnerId: 0,
      constantSuperAgentId: 0,
      constantAgentId: 0,
      constantUserId: 0,
      status: '',
      subagents: '',
      clients: '',
      paidout: '',
      betmode: '',
      loading: false,
      selections: '',
      totalPages: 0,
      activePage: 0,
      pageSize: 20,
      page: '',
      defaultLoadMoreButtonPage: 1,
      loadMoreButton: '',
      searchResults: [],
      tempSearchResults: [],
      providerResults: [],
      totalsProvidersResults: [],
      overall: [],
      unfilteredResult: [],
      userHierarchy: [],
      firstLevelChildren: [],
      secondLevelChildren: [],
      thirdLevelChildren: [],
      subUserId: 0,
      tempLvl1Idx: '',
      tempLvl2Idx: '',
      tempLvl3Idx: '',
      filteredPartners: [],
      filteredSuperagents: [],
      filteredAgents: [],
      filteredUsers: [],
      totalOverallResults: [],
      totalPageResults: [],
      localClass: '',
      showMessage: false,
      message: '',
      loadMessage: false,
      pageCount: {
        firstLevel: 0,
      },
      currentPage: {
        firstLevel: 0,
      },
    },
    methods: {
      expandResults(accountId='', subRowsType='', hideSymbol='', origin, page) {
        if ( origin === 'loadMore' ) {
          this.loadMoreButton.setAttribute('disabled', '');
          this.loadMoreButton.classList.add('btn-loading');
        }
        this.getCasinoResults(accountId, subRowsType, hideSymbol, origin='expandResults', page);
      },
      showLvl1Children(lvl1AgentId, lvl1Idx, origin) {
        this.loadMoreButton = document.getElementById("load-more-" + lvl1Idx);
        if ($("#lvl1-bordered-collapse-" + lvl1Idx).hasClass("lvl1Closed") || origin === 'loadMore') {
          this.loadMessage = false;
          this.tempLvl1Idx = lvl1Idx;
          this.page = (origin === 'loadMore') ? this.loadMoreButton.getAttribute('data-next-page') : '';
          this.expandResults(lvl1AgentId, 'lvl1', "#lvl1-bordered-collapse-" + lvl1Idx, origin, this.page);
          $("#lvl1-subrow-" + lvl1Idx).removeClass("d-none");
          $("#lvl1-bordered-collapse-" + lvl1Idx).removeClass("lvl1Closed").addClass("lvl1Opened").html('-');
        }
        else if ($("#lvl1-bordered-collapse-" + lvl1Idx).hasClass("lvl1Opened") && origin === 'expandResults') {
          // clear third level children
          let thirdLevelChildrenIndexes = Object.assign({}, this.thirdLevelChildren);
          for (const index in thirdLevelChildrenIndexes) {
              if ( index.startsWith(lvl1Idx) ) {
                this.thirdLevelChildren[index] = '';
            }
          }
          //clear second level children
          let secondLevelChildrenIndexes = Object.keys(this.firstLevelChildren[lvl1Idx]);
          secondLevelChildrenIndexes.forEach(childrenIndex => {
            if ( this.secondLevelChildren[lvl1Idx + '-' + childrenIndex] ) {
              this.secondLevelChildren[lvl1Idx + '-' + childrenIndex] = '';
            }
          })
          // clear first level children & set proper HTML classes
          this.firstLevelChildren[lvl1Idx] = '';
          this.loadMoreButton.setAttribute('data-next-page', this.defaultLoadMoreButtonPage);
          $("#lvl1-subrow-" + lvl1Idx).addClass("d-none");
          $("#lvl1-bordered-collapse-" + lvl1Idx).removeClass("lvl1Opened").addClass("lvl1Closed").html('+');
        }

      },
      showLvl2Children(lvl2AgentId, lvl2Idx, lvl1Idx='', origin) {
        this.loadMessage = false;
        let subSuffix = lvl1Idx + "-" + lvl2Idx;
        this.loadMoreButton = document.getElementById("load-more-" + subSuffix);
        if ($("#lvl2-sub-bordered-collapse-" + subSuffix).hasClass("lvl2Closed") || origin === 'loadMore') {
          this.tempLvl1Idx = lvl1Idx;
          this.tempLvl2Idx = lvl2Idx;
          this.subUserId = lvl2AgentId;
          this.page = (origin === 'loadMore') ? this.loadMoreButton.getAttribute('data-next-page') : '';
          this.expandResults(lvl2AgentId, 'lvl2', "#lvl2-sub-bordered-collapse-" + subSuffix, origin, this.page);
          $("#lvl2-subrow-" + subSuffix).removeClass("d-none");
          $("#lvl2-sub-bordered-collapse-" + subSuffix).removeClass("lvl2Closed").addClass("lvl2Opened").html('-');
        }
        else if ($("#lvl2-sub-bordered-collapse-" + subSuffix).hasClass("lvl2Opened") && origin === 'expandResults') {
          // clear third level children
          let thirdLevelChildrenIndexes = Object.keys(this.secondLevelChildren[subSuffix]);
          thirdLevelChildrenIndexes.forEach(childrenIndex => {
            if ( this.thirdLevelChildren[subSuffix + '-' + childrenIndex] ) {
              this.thirdLevelChildren[subSuffix + '-' + childrenIndex] = '';
            }
          })
          this.secondLevelChildren[subSuffix] = '';
          this.loadMoreButton.setAttribute('data-next-page', this.defaultLoadMoreButtonPage);
          $("#lvl2-subrow-" + subSuffix).addClass("d-none");
          $("#lvl2-sub-bordered-collapse-" + subSuffix).removeClass("lvl2Opened").addClass("lvl2Closed").html('+');
        }

      },
      showLvl3Children(lvl3AgentId, lvl3Idx, lvl1Idx='', lvl2Idx='', origin) {
        let subSuffix = lvl1Idx + "-" + lvl2Idx + "-" + lvl3Idx;
        this.loadMoreButton = document.getElementById("load-more-" + subSuffix);
        if ($("#lvl3-sub-bordered-collapse-" + subSuffix).hasClass("lvl3Closed") || origin === 'loadMore') {
          this.loadMessage = false;
          this.tempLvl1Idx = lvl1Idx;
          this.tempLvl2Idx = lvl2Idx;
          this.tempLvl3Idx = lvl3Idx;
          this.subUserId = lvl3AgentId;
          this.page = (origin === 'loadMore') ? this.loadMoreButton.getAttribute('data-next-page') : '';
          this.expandResults(lvl3AgentId, 'lvl3', "#lvl3-sub-bordered-collapse-" + subSuffix, origin, this.page);
          $("#lvl3-subrow-" + subSuffix).removeClass("d-none");
          $("#lvl3-sub-bordered-collapse-" + subSuffix).removeClass("lvl3Closed").addClass("lvl3Opened").html('-');
        }
        else if ($("#lvl3-sub-bordered-collapse-" + subSuffix).hasClass("lvl3Opened") && origin === 'expandResults') {
          this.thirdLevelChildren[lvl1Idx + '-' + lvl2Idx + '-' + lvl3Idx] = '';
          this.loadMoreButton.setAttribute('data-next-page', this.defaultLoadMoreButtonPage);
          $("#lvl3-subrow-" + subSuffix).addClass("d-none");
          $("#lvl3-sub-bordered-collapse-" + subSuffix).removeClass("lvl3Opened").addClass("lvl3Closed").html('+');
        }
      },

      getUserHierarchy(selectedRole='') {
        api.getAgentDirectChildren(this.userId)
          .done(res => {
            this.userHierarchy = sortAlphabeticalArrayByValue(res);
            if (selectedRole === 'partner') {
              $("#select2-chosen-2").text('All');
              $("#select2-chosen-3").text('All');
              $("#select2-chosen-4").text('All');
              this.filteredSuperagents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_SUPER_AGENT
              );

              this.filteredAgents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_AGENT
              );

              this.filteredUsers = this.userHierarchy.filter(agent =>
                agent.role === ROLE_USER
              );
            }
            else if (selectedRole === 'superagent') {
              $("#select2-chosen-3").text('All');
              $("#select2-chosen-4").text('All');
              this.filteredAgents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_AGENT
              );

              this.filteredUsers = this.userHierarchy.filter(agent =>
                agent.role === ROLE_USER
              );
            }
            else if (selectedRole === 'agent') {
              $("#select2-chosen-4").text('All');
              this.filteredUsers = this.userHierarchy.filter(agent =>
                agent.role === ROLE_USER
              );
            }
            else if (selectedRole === 'user') {
              return;
            }
            else {
              this.filteredPartners = this.userHierarchy.filter(agent =>
                agent.role === ROLE_PARTNER
              );

              this.filteredSuperagents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_SUPER_AGENT
              );

              this.filteredAgents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_AGENT
              );

              this.filteredUsers = this.userHierarchy.filter(agent =>
                agent.role === ROLE_USER
              );
            }
          })
          .fail((error) => {
            consoleLog(error);
          })
          .always(() => {
            this.loading = false;
          });
      },

      goToPage(selectedPage) {
        this.currentPage.firstLevel = selectedPage;
        this.getCasinoResults('','lvl1','','goToPage');
      },

      getResultsNo() {
        this.getCasinoResults();
      },

      removeFilter(selectedFilter) {
        let that = this;
        switch(selectedFilter) {

          case 'selectedDate':
            setDate('week', this);
            this.createdFrom='';
            this.createdTo='';
            break;

          case 'selectedUser':
            this.userId= this.constantLoggedInId;
            this.filters['user'] = this.username;
            that.constantPartnertId = 0;
            that.constantSuperAgentId = 0;
            that.constantAgentId = 0;
            that.constantUserId = 0;
            $("#select2-chosen-1").text('All');
            $("#select2-chosen-2").text('All');
            $("#select2-chosen-3").text('All');
            $("#select2-chosen-4").text('All');
            break;
        }
        this.getUserHierarchy();
        this.getCasinoResults();
      },

      setSelfDate (from) {
        this.activeBtn = from;
        setDate(from, this);
      },

      modifyDates(wantedDate) {
        let today = new Date();
        switch(wantedDate) {
          case 'today':
            let dd = today.getDate() > 9 ? today.getDate() : '0' + today.getDate();
            let mm = today.getMonth() + 1 > 9 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1);
            let yyyy = today.getFullYear();
            return dd + '-' + mm + '-' + yyyy;
            break;

          case 'week':
            let day = today.getDay();
            let diff = today.getDate() - day + (day == 0 ? -6 : 1);
            return reverseDateFormat(this.formatDate(new Date(today.setDate(diff))));
            break;
        }
      },

      getParams(page=0) {
        let that = this;

        this.createdFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
        this.createdTo = (this.toDate) ? this.toDate : this.modifyDates('today');
        that.filters['createdFrom'] = (this.createdFrom) ? this.createdFrom : '';
        that.filters['createdTo'] = (this.createdTo) ? this.createdTo : '';

        if (page > 0) {
          this.currentPage.firstLevel = page;
        }

        that.userId = this.getUserId();
      },

      reset() {
        let that = this;
        this.createdFrom = "";
        this.createdTo = "";
        setDate('week', this);
        this.displaySearch = false;
        this.filters = [];
        this.currentPage.firstLevel = 0;
        this.pageSize = 20;
        that.constantPartnerId = 0;
        that.constantSuperAgentId = 0;
        that.constantAgentId = 0;
        that.constantUserId = 0;
        that.userId = '';
        this.subUserId = 0;
        $("#select2-chosen-1").text('All');
        $("#select2-chosen-2").text('All');
        $("#select2-chosen-3").text('All');
        $("#select2-chosen-4").text('All');
        $(".pagination-section").addClass("d-none");
        that.getUserHierarchy();
      },

      formatDate(date) {
        let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      },

      getUserId(asCsv=false) {
        if (this.subUserId > 0 && !asCsv) {
          return this.subUserId;
        }
        else {
           if (this.constantUserId > 0) {
            return this.constantUserId;
          }
          else if (this.constantAgentId > 0) {
            return this.constantAgentId;
          }
          else if (this.constantSuperAgentId > 0) {
            return this.constantSuperAgentId;
          }
          else if (this.constantPartnerId > 0) {
            return this.constantPartnerId;
          }          
          else {
            return '';
          }
        }
      },

      saveReport() {
        this.showMessage = false;
        this.disableButton = true;
        this.loading = true;
        this.loadMessage = true;
        api.saveCasinoReportAsCsv(reverseDateFormat(this.createdFrom), reverseDateFormat(this.createdTo), this.getUserId(true), this.pageSize, this.currentPage.firstLevel)
          .done(() => {
            this.loadMessage = false;
            this.success = true;
            this.error = false;
            this.message = $("#csvSuccess").val();
            this.localClass = 'alert-success';
            this.showMessage = true;
          })
          .fail(() => {
            this.message = $("#csvError").val();
            this.localClass = 'alert-danger';
            this.loadMessage = false;
            this.showMessage = true;
          })
          .always(() => {
            this.loading = false;
            this.disableButton = false;
            setTimeout(() => {
              this.showMessage = false;
              }, 3000);
          })
      },

      getCasinoResults(accountId='', subRowsType='lvl1', hideSymbol='', origin='', page=this.currentPage.firstLevel) {
        if (origin == '') {
          this.currentPage.firstLevel = 0;
          this.pageCount.firstLevel = 0;
        }
        else if ( origin === 'goToPage' ) {
          this.firstLevelChildren  = [];
          this.secondLevelChildren = [];
          this.thirdLevelChildren  = [];
        }
        
        let that = this;
        this.loading = true;

        if (accountId === '') {
          this.displaySearch = false;
          this.subUserId = 0;
          this.firstLevelChildren = [];
          this.secondLevelChildren = [];
          this.thirdLevelChildren = [];
        }

        this.filters['user'] = ($("#select2-chosen-3").length > 0 && $("#select2-chosen-3").text() !== 'All') ? $("#select2-chosen-3").text()
          : ($("#select2-chosen-2").length > 0 && $("#select2-chosen-2").text() !== 'All') ? $("#select2-chosen-2").text()
            : ($("#select2-chosen-1").length > 0 && $("#select2-chosen-1").text() !== 'All') ? $("#select2-chosen-1").text()
              : this.username;

        this.subUserId = accountId;

        this.getParams(this.currentPage.firstLevel);
        this.disableButton = true;
        api.generateNewCasinoReport(reverseDateFormat(this.createdFrom), reverseDateFormat(this.createdTo), that.userId, this.pageSize, page)
          .done(res => {
            if(res.list.length > 0) {
              this.displaySearch = true;
              this.error = false;
              if ( origin !== 'expandResults' ) {
                this.pageCount.firstLevel = res.pagination.pageCount;
              }

              this.tempSearchResults = res.list.map(item => {
                return {
                  'userId': item.userId,
                  'username': item.username,
                  'intUserRole': parseInt(item.userrole),
                  'userrole': item.userrole === ROLE_PARTNER ? $("#agent_role_partner").val() : item.userrole === ROLE_SUPER_AGENT ? $("#agent_role_superagent").val() : item.userrole === ROLE_AGENT ? $("#agent_role_agent").val() : item.userrole === ROLE_CASHIER ? $("#agent_role_cashier").val() : $("#agent_role_user").val(),
                  'totalStakes': swapCurrency(formatMoney(item.totalStakes, this.currency)),
                  'totalWinnings': swapCurrency(formatMoney(item.totalWinnings, this.currency)),
                  'net': swapCurrency(formatMoney(item.net, this.currency)),
                  'margin': item.margin
                };
              }, that);

              if (!accountId) {
                this.searchResults = this.tempSearchResults;

                this.totalOverallResults['stakes'] = swapCurrency(formatMoney(res.summary.overall.totalStakes, this.currency));
                this.totalOverallResults['winnings'] = swapCurrency(formatMoney(res.summary.overall.totalWinnings, this.currency));
                this.totalOverallResults['net'] = swapCurrency(formatMoney(res.summary.overall.net, this.currency));
                this.totalOverallResults['margin'] = res.summary.overall.margin;

                this.totalPageResults['stakes'] = swapCurrency(formatMoney(res.summary.page.totalStakes, this.currency));
                this.totalPageResults['winnings'] = swapCurrency(formatMoney(res.summary.page.totalWinnings, this.currency));
                this.totalPageResults['net'] = swapCurrency(formatMoney(res.summary.page.net, this.currency));
                this.totalPageResults['margin'] = res.summary.page.margin;
              }
              else {
                let indexSuffix;
                if (subRowsType === 'lvl1') {
                  indexSuffix = this.tempLvl1Idx;
                  this.firstLevelChildren[indexSuffix] = !this.firstLevelChildren[indexSuffix] ?
                                                          this.tempSearchResults :
                                                          [ ...this.firstLevelChildren[indexSuffix], 
                                                            ...this.tempSearchResults
                                                          ];
                }
                else if (subRowsType === 'lvl2') {
                  indexSuffix = this.tempLvl1Idx + "-" + this.tempLvl2Idx;
                  this.secondLevelChildren[indexSuffix] = !this.secondLevelChildren[indexSuffix] ?
                                                          this.tempSearchResults :
                                                          [ ...this.secondLevelChildren[indexSuffix], 
                                                            ...this.tempSearchResults
                                                          ];
                }
                else {
                  indexSuffix = this.tempLvl1Idx + '-' + this.tempLvl2Idx + '-' + this.tempLvl3Idx;

                  this.thirdLevelChildren[indexSuffix] = !this.thirdLevelChildren[indexSuffix] ?
                                                          this.tempSearchResults :
                                                          [ ...this.thirdLevelChildren[indexSuffix], 
                                                            ...this.tempSearchResults
                                                          ];
                }

                this.loadMoreButton = document.getElementById("load-more-" + indexSuffix);
                // if there are more data
                if ( res.pagination.pageCount - res.pagination.currentPage > 1 ) {
                  this.loadMoreButton.removeAttribute('disabled');
                  this.loadMoreButton.classList.remove('d-none', 'btn-loading');
                  this.loadMoreButton.setAttribute('data-next-page', parseInt(this.loadMoreButton.getAttribute('data-next-page')) + this.defaultLoadMoreButtonPage);
                }
                else {
                  this.loadMoreButton.classList.add('d-none');
                }
              }
            }
            if (accountId === '' && res.list.length === 0) {
              this.displaySearch = false;
            }
            if (hideSymbol !== '' && res.list.length === 0) {
              $(hideSymbol).addClass("d-none");
            }
          })
          .fail(({ responseJSON: res }) => {
            this.displaySearch = false;
            this.error = true;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            }
          })
          .always(() => {
            this.loading = false;
            this.disableButton = false;
            addSticky('th');
          });
      },

    },

    created () {
      if (!document.getElementById('agent-new-casino-report')) {
        return;
      }
      setDate('week', this);

      api.getBalance()
        .done(res => {
          this.currency = res.currency;
        });

      this.error = false;
      api.getPlayer().done(res => {
        this.username = res.username;
        this.userId = res.user_id;
        this.constantLoggedInId = res.user_id;
        this.getUserHierarchy();
      });

    },

    mounted () {
      if (!document.getElementById('agent-new-casino-report')) {
        return;
      }

      // Initialize datepickers
      const that = this;
      const $startDate = $(this.$refs.fromDate);
      const $endDate = $(this.$refs.toDate);

      $startDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate, date) {
          that.fromDate = formattedDate;
          $endDate.datepicker().data('datepicker').update('minDate', date);
        },
      });

      $endDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate) {
          that.toDate = formattedDate;
        },
      });

      $('#agent-new-casino-report-partner').select2()
        .on('change', function () {
          that.constantAgentId = 0;
          that.constantUserId = 0;
          that.constantSuperAgentId = 0;
          that.constantPartnerId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantLoggedInId;
          that.getUserHierarchy('partner');
        });

      $('#agent-new-casino-report-superagent').select2()
        .on('change', function () {
          that.constantAgentId = 0;
          that.constantUserId = 0;
          that.constantSuperAgentId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantLoggedInId;
          that.getUserHierarchy('superagent');
        });

      $('#agent-new-casino-report-agent').select2()
        .on('change', function () {
          that.constantUserId = 0;
          that.constantAgentId = this.value;
          that.userId =  this.value > 0 ? this.value : that.constantLoggedInId;
          that.getUserHierarchy('agent');
        });

        $('#agent-new-casino-report-user').select2()
        .on('change', function () {
          that.constantUserId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantAgentId;
          that.getUserHierarchy('user');
        });
    },
  });

  /* -----------------------------------------
  Agent User Casino Transactions
  ----------------------------------------- */
  const AgentUserCasinoTransactions = new Vue({
    el: '.agent-user-casino-transactions',
    data: {
      activeBtn: 'today',
      currency: '',
      filters: [],
      displaySearch: false,
      error: '',
      errorMessage: '',
      fromDate: '',
      toDate: '',
      createdFrom: '',
      createdTo: '',
      loggedInRole: __APP__.agentRole,
      username: '',
      userId: '',
      loading: false,
      totalPages: 0,
      activePage: 1,
      pageSize: 20,
      page: '',
      selfRole: '',
      searchResults: [],
      tempSearchResults: [],
      disableButton: false,
      showFooterTotals: false,
      totalPageResults: [],
      totalOverallResults: [],
      users: [],
      balance: '',
      currentUserId: '',
      gameNames: [],
    },
    methods: {
      goToPage(selectedPage) {
        this.activePage = selectedPage;
        this.getUserCasinoTransactions();
      },

      getResultsNo() {
        this.getUserCasinoTransactions();
      },

      setSelfDate (from) {
        this.activeBtn = from;
        setDate(from, this);
      },

      modifyDates(wantedDate) {
        let today = new Date();
        switch(wantedDate) {
          case 'today':
            let dd = today.getDate() > 9 ? today.getDate() : '0' + today.getDate();
            let mm = today.getMonth() + 1 > 9 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1);
            let yyyy = today.getFullYear();
            return dd + '-' + mm + '-' + yyyy;
            break;

          case 'week':
            let day = today.getDay();
            let diff = today.getDate() - day + (day == 0 ? -6 : 1);
            return reverseDateFormat(this.formatDate(new Date(today.setDate(diff))));
            break;
        }
      },

      getGameName(item) {
        if(typeof this.gameNames[parseInt(item.game_id)] !== 'undefined'){
          return this.gameNames[parseInt(item.game_id)];
        } else {
          return item.game_id === null ? '-' : item.game_id;
        }
      },

      formatDate(date) {
        let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      },

      getUserCasinoTransactions() {
        let that = this;
        this.loading = true;
        this.disableButton = true;
        this.displaySearch = true;

         // set the url parameters on session storage
         sessionStorage.setItem('fromDate', this.fromDate);
         sessionStorage.setItem('toDate', this.toDate);
         sessionStorage.setItem('userId', this.userId);
        
        api.getUserCasinoTransactions(that.userId, reverseDateFormat(this.fromDate), reverseDateFormat(this.toDate), this.pageSize, this.activePage)
          .done(res => {
            if(res.list.length > 0) {
              this.displaySearch = true;
              this.error = false;
             
              this.tempSearchResults = res.list.map(item => {
                return {
                  'userId': item.user_id,
                  'date':item.date,
                  'gameName': this.getGameName(item),
                  'stake': swapCurrency(formatMoney(item.stake, this.currency)),
                  'status': item.status === "won" ? item.status + ' ' + '(' + swapCurrency(formatMoney(item.winning, this.currency)) + ')' : item.status === "lost" ? item.status : item.status
                };
              }, that);
              this.searchResults = this.tempSearchResults;

            } 
            else {
              this.displaySearch = false;
              this.searchResults = [];
            }
            this.totalPages = parseInt(res.pagination.pageCount);
          })
          .fail(({ responseJSON: res }) => {
            this.displaySearch = false;
            this.error = true;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            }
          })
          .always(() => {
            this.loading = false;
            this.disableButton = false;
          });
        },

    },

    created () {
      if (!document.getElementById('agent-user-casino-transactions')) {
        return;
      }
      setDate('week', this);

      this.currency = localStorage.getItem('currency');
       //get url parameters
       let urlParams = window.location.href;
       let newUrl = new URL(urlParams);
       this.fromDate =  newUrl.searchParams.get('from') ? newUrl.searchParams.get('from') : sessionStorage.getItem('fromDate');
       this.toDate =  newUrl.searchParams.get('to') ? newUrl.searchParams.get('to') : sessionStorage.getItem('toDate');
       this.userId = newUrl.searchParams.get('userId') ? newUrl.searchParams.get('userId') : sessionStorage.getItem('userId');
 
       if (this.userId) {
         api.fetchAllGamesNames().done(res => {
           res.find(game => {
             this.gameNames[parseInt(game.id)] = game.name;
           });
           this.getUserCasinoTransactions();
         });
   
         api.getAgentHierarchyFull().done(res => {
           this.username = res.filter(user =>{
             return  user.userId == this.userId;
           }).map(row => {
             return row.username !== '' ? row.username: $("#agent_user_not_found").val();
           });     
         });
       }   
    },

    mounted () {
      if (!document.getElementById('agent-user-casino-transactions')) {
        return;
      }

      // Initialize datepickers
      const that = this;
      const $startDate = $(this.$refs.fromDate);
      const $endDate = $(this.$refs.toDate);
    
      $startDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate, date) {
          that.fromDate = formattedDate;
          $endDate.datepicker().data('datepicker').update('minDate', date);
        },
      });

      $endDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate) {
          that.toDate = formattedDate;
        },
      });
    },

  });   

   /* -----------------------------------------
  Agent Sportsbook Tickets List
  ----------------------------------------- */
  const AgentSportsbookTicketsList = new Vue({
    el: '.agent-tickets-list',
    data: {
      activeBtn: 'week',
      currency: '',
      filters: [],
      fn: '',
      displaySearch: false,
      error: '',
      errorMessage: '',
      fromDate: '',
      toDate: '',
      createdFrom: '',
      createdTo: '',
      settledFrom: '',
      settledTo: '',
      paidFrom: '',
      paidTo: '',
      loggedInRole: __APP__.agentRole,
      userId: '',
      status: '',
      subagents: '',
      clients: '',
      paidout: '',
      betmode: '',
      loading: false,
      selections: '',
      picked: 'date_created',
      activePage: 0,
      totalPages: 0,
      totalAmountPerPage: 0,
      totalSettledAmountPerPage: 0,
      totalAmountOverall: 0,
      totalSettledAmountOverall: 0,
      totalCountOverall: 0,
      totalRevenueOverall: 0,
      totalMarginOverall: 0,
      pageSize: 20,
      searchResults: [],
      overall: [],
      unfilteredResult: [],
      userHierarchy: [],
      disabled: true,
      searchSuperagent: '',
      searchAgent: '',
      searchUser: '',
      username: '',
      filteredPartners: [],
      filteredSuperagents: [],
      filteredAgents: [],
      filteredCashiers: [],
      filteredUsers: [],
      constantPartnerId: 0,
      constantSuperAgentId: 0,
      constantAgentId: 0,
      constantCashierId: 0,
      constantUserId: 0,
      disableButton: false
    },

    methods: {
      getUserHierarchy(selectedRole='') {
        api.getAgentDirectChildren(this.userId)
          .done(res => {
            this.userHierarchy = sortAlphabeticalArrayByValue(res);
            switch (selectedRole) {
              case 'partner' :
                $("#select2-chosen-2").text('All');
                $("#select2-chosen-3").text('All');
                $("#select2-chosen-4").text('All');
                $("#select2-chosen-5").text('All');
                this.filteredSuperagents = this.userHierarchy.filter(agent =>
                  agent.role === ROLE_SUPER_AGENT
                );
                this.filteredAgents = this.userHierarchy.filter(agent =>
                  agent.role === ROLE_AGENT
                );
                this.filteredCashiers = this.userHierarchy.filter(agent =>
                  agent.role === ROLE_CASHIER
                );
                this.filteredUsers = this.userHierarchy.filter(agent =>
                  agent.role === ROLE_USER
                );
                break;

              case 'superagent':
                $("#select2-chosen-3").text('All');
                $("#select2-chosen-4").text('All');
                $("#select2-chosen-5").text('All');
                this.filteredAgents = this.userHierarchy.filter(agent =>
                  agent.role === ROLE_AGENT
                );
                this.filteredCashiers = this.userHierarchy.filter(agent =>
                  agent.role === ROLE_CASHIER
                );
                this.filteredUsers = this.userHierarchy.filter(agent =>
                  agent.role === ROLE_USER
                );
                break;

              case 'agent':
                $("#select2-chosen-4").text('All');
                $("#select2-chosen-5").text('All');
                this.filteredCashiers = this.userHierarchy.filter(agent =>
                  agent.role === ROLE_CASHIER
                );
                this.filteredUsers = this.userHierarchy.filter(agent =>
                  agent.role === ROLE_USER
                );
                break;

                case 'cashier':
                  $("#select2-chosen-5").text('All');
                  this.filteredUsers = this.userHierarchy.filter(agent =>
                    agent.role === ROLE_USER
                  );
                  break;

              case 'user':
                return;
                break;

              default:
                this.filteredPartners = this.userHierarchy.filter(agent =>
                  agent.role === ROLE_PARTNER
                );

                this.filteredSuperagents = this.userHierarchy.filter(agent =>
                  agent.role === ROLE_SUPER_AGENT
                );

                this.filteredAgents = this.userHierarchy.filter(agent =>
                  agent.role === ROLE_AGENT
                );

                this.filteredCashiers = this.userHierarchy.filter(agent =>
                  agent.role === ROLE_CASHIER
                );

                this.filteredUsers = this.userHierarchy.filter(agent =>
                  agent.role === ROLE_USER
                );
                break;
            }
          })
          .fail((error) => {
            consoleLog(error);
          })
          .always(() => {
            this.loading = false;
          });
      },

      goToPage(selectedPage) {
        this.activePage = selectedPage
        this.getTicketsList();
      },

      reverseDate(date){
        if (date) {
          let tempTime = [];
          let tempDate = [];
          let reverseDate = date.split(' ');
          let transformDate = reverseDate[0].split('-');
          tempDate[0] = transformDate[2];
          tempDate[1] = transformDate[1];
          tempDate[2] = transformDate[0];
          tempTime[0] = reverseDate[1];

          reverseDate = tempDate[0] + "-" + tempDate[1] + "-" + tempDate[2] + " " + tempTime[0];
          return reverseDate;
        }
        else {
          return '';
        }
      },

      removeFilter(selectedFilter) {
        let that = this;
        switch(selectedFilter) {

          case 'selectedDate':
            setDate('week', this);
            this.createdFrom='';
            this.createdTo='';
            break;

          case 'selectedStatus':
            this.status='';
            break;

          case 'selectedPaidout':
            this.paidout='';
            break;

          case 'selectedUser':
            this.userId= this.constantLoggedInId;
            this.filters['user'] = this.username;
            that.constantPartnerId = 0;
            that.constantSuperAgentId = 0;
            that.constantAgentId = 0;
            that.constantCashierId = 0;
            that.constantUserId = 0;
            $("#select2-chosen-1").text('All');
            $("#select2-chosen-2").text('All');
            $("#select2-chosen-3").text('All');
            $("#select2-chosen-4").text('All');
            $("#select2-chosen-5").text('All');
            break;
        }
        this.getUserHierarchy();
        this.getTicketsList();
      },

      setSelfDate (from) {
        this.activeBtn = from;
        setDate(from, this);
      },

      modifyDates(wantedDate) {
        let today = new Date();
        switch(wantedDate) {
          case 'today':
            let dd = today.getDate() > 9 ? today.getDate() : '0' + today.getDate();
            let mm = today.getMonth() + 1 > 9 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1);
            let yyyy = today.getFullYear();
            return dd + '-' + mm + '-' + yyyy;
            break;

          case 'week':
            let day = today.getDay();
            let diff = today.getDate() - day + (day == 0 ? -6 : 1);
            return reverseDateFormat(this.formatDate(new Date(today.setDate(diff))));
            break;
        }
      },

      getParams() {
        let that = this;
        if (this.picked === 'date_created') {
          that.filters['picked'] = 'date_created';
          this.createdFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.createdTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.settledFrom = '';
          this.settledTo = '';
          this.paidFrom = '';
          this.paidTo = '';
          this.filters['settledFrom'] = '';
          this.filters['settledTo'] = '';
          that.filters['createdFrom'] = (this.createdFrom) ? this.createdFrom : '';
          that.filters['createdTo'] = (this.createdTo) ? this.createdTo : '';
          this.filters['paidFrom'] = '';
          this.filters['paidTo'] = '';
        }
        else if (this.picked === 'date_settled') {
          that.filters['picked'] = 'date_settled';
          this.createdFrom = '';
          this.createdTo = '';
          this.paidFrom = '';
          this.paidTo = '';
          this.settledFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.settledTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.filters['createdFrom'] = '';
          this.filters['createdTo'] = '';
          that.filters['settledFrom'] = (this.settledFrom) ? this.settledFrom : '';
          that.filters['settledTo'] = (this.settledTo) ? this.settledTo : '';
          this.filters['paidFrom'] = '';
          this.filters['paidTo'] = '';
        }
        else if (this.picked === 'date_paid') {
          that.filters['picked'] = 'date_paid';
          this.createdFrom = '';
          this.createdTo = '';
          this.settledFrom = '';
          this.settledTo = '';
          this.paidFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.paidTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.filters['createdFrom'] = '';
          this.filters['createdTo'] = '';
          that.filters['settledFrom'] = '';
          that.filters['settledTo'] = '';
          that.filters['paidFrom'] = (this.paidFrom) ? this.paidFrom : '';
          that.filters['paidTo'] = (this.paidTo) ? this.paidTo : '';
        }

        if (that.constantUserId > 0) {
          that.userId = that.constantUserId;
        }
        else if (that.constantCashierId > 0) {
          that.userId = that.constantCashierId;
        }
        else if (that.constantAgentId > 0) {
          that.userId = that.constantAgentId;
        }
        else if (that.constantSuperAgentId > 0) {
          that.userId = that.constantSuperAgentId;
        }
        else if (that.constantPartnerId > 0) {
          that.userId = that.constantPartnerId;
        }
        else {
          that.userId = '';
        }
      },

      reset() {
        let that = this;
        this.createdFrom = "";
        this.createdTo = "";
        this.paidout = "";
        this.status = "";
        this.picked = 'date_created';
        setDate('week', this);
        this.displaySearch = false;
        this.filters = [];
        this.activePage = 0;
        this.pageSize = 20;
        that.constantPartnerId = 0;
        that.constantSuperAgentId = 0;
        that.constantAgentId = 0;
        that.constantCashierId = 0;
        that.constantUserId = 0;
        $("#select2-chosen-1").text('All');
        $("#select2-chosen-2").text('All');
        $("#select2-chosen-3").text('All');
        $("#select2-chosen-4").text('All');
      },

      formatDate(date) {
        let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      },

      getTicketsList() {
        let that = this;
        this.disableButton = true;
        this.displaySearch = false;
        this.loading = true;
        this.filters['paidout'] = (this.paidout == PAIDOUT_YES) ? $("#agent_status_yes").val() : (this.paidout == PAIDOUT_NO) ? $("#agent_status_no").val() : $("#agent_status_any").val();
        this.filters['status'] = (this.status) ? this.status : '';
        this.filters['user'] = this.username;
        this.getParams();

        this.filters['user'] = ($("#select2-chosen-5").length > 0 && $("#select2-chosen-5").text() !== 'All') ? $("#select2-chosen-5").text()
          :($("#select2-chosen-4").length > 0 && $("#select2-chosen-4").text() !== 'All') ? $("#select2-chosen-4").text()
            :($("#select2-chosen-3").length > 0 && $("#select2-chosen-3").text() !== 'All') ? $("#select2-chosen-3").text()
              :($("#select2-chosen-2").length > 0 && $("#select2-chosen-2").text() !== 'All') ? $("#select2-chosen-2").text()
                : ($("#select2-chosen-1").length > 0 && $("#select2-chosen-1").text() !== 'All') ? $("#select2-chosen-1").text()
                  : this.username;

        api.generateNewSbTicketsListReport(reverseDateFormat(this.createdFrom), reverseDateFormat(this.createdTo), reverseDateFormat(this.settledFrom), reverseDateFormat(this.settledTo), reverseDateFormat(this.paidFrom), reverseDateFormat(this.paidTo), this.status, this.paidout, that.userId, this.pageSize, this.activePage)
          .done(res => {
            if (res.list.length > 0) {
              this.displaySearch = true;

              this.totalPages = parseInt(res.pagination.pageCount);
              this.error = false;
              let that = this;
              this.totalAmountPerPage = swapCurrency(formatMoney(res.summary.page.amount, this.currency));
              this.totalSettledAmountPerPage = swapCurrency(formatMoney(res.summary.page.settledAmount, this.currency));

              this.totalAmountOverall = swapCurrency(formatMoney(res.summary.overall.amount, this.currency));
              this.totalSettledAmountOverall = swapCurrency(formatMoney(res.summary.overall.settledAmount, this.currency));
              this.searchResults = res.list.map(item => {
                return {
                  'username': item.username,
                  'betId': item.betId,
                  'createdAt': this.reverseDate(item.createdAt),
                  'paidAt': this.reverseDate(item.paidAt),
                  'settledAt': item.settledAt ? this.reverseDate(item.settledAt) : '-',
                  'amount': item.amount ? swapCurrency(formatMoney(item.amount, this.currency)) : '-',
                  'settledAmount': item.status !== 'open' && item.settledAmount ? swapCurrency(formatMoney(item.settledAmount, this.currency)) : '-',
                  'status': item.status
                };
              }, that);
            }
          })
          .fail(({ responseJSON: res }) => {
            this.error = true;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            }
          })
          .always(() => {
            this.loading = false;
            this.disableButton = false;
            addSticky('th');
          });
      }

    },

    created () {
      if (!document.getElementById('agent-tickets-list')) {
        return;
      }
      setDate('week', this);

      api.getBalance()
        .done(res => {
          this.currency = res.currency;
        });

      api.getPlayer().done(res => {
        this.username = res.username;
        this.userId = res.user_id;
        this.constantLoggedInId = res.user_id;
        this.getUserHierarchy(this.userId);
      });

      this.error = false;

    },

    mounted () {
      if (!document.getElementById('agent-tickets-list')) {
        return;
      }

      // Initialize datepickers
      const that = this;
      const $startDate = $(this.$refs.fromDate);
      const $endDate = $(this.$refs.toDate);

      $startDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate, date) {
          that.fromDate = formattedDate;
          $endDate.datepicker().data('datepicker').update('minDate', date);
        },
      });

      $endDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate) {
          that.toDate = formattedDate;
        },
      });

      $('#agent-sb-tickets-list-partner').select2()
        .on('change', function () {
          that.constantUserId = 0;
          that.constantCashierId = 0;
          that.constantAgentId = 0;
          that.constantSuperAgentId = 0;
          that.constantPartnerId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantLoggedInId;
          that.getUserHierarchy('partner');
        });

      $('#agent-sb-tickets-list-superagent').select2()
        .on('change', function () {
          that.constantUserId = 0;
          that.constantAgentId = 0;
          that.constantSuperAgentId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantPartnerId;
          that.getUserHierarchy('superagent');
        });

      $('#agent-sb-tickets-list-agent').select2()
        .on('change', function () {
          that.constantUserId = 0;
          that.constantCashierId = 0;
          that.constantAgentId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantSuperAgentId;
          that.getUserHierarchy('agent');
        });

      $('#agent-sb-tickets-list-cashier').select2()
        .on('change', function () {
          that.constantCashierId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantAgentId;
          that.getUserHierarchy('cashier');
        });

      $('#agent-sb-tickets-list-user').select2()
        .on('change', function () {
          that.constantUserId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantAgentId;
          that.getUserHierarchy('user');
        });
    }
  });

   /* -----------------------------------------
  Agent Commission Period Report (Owner page)
  ----------------------------------------- */
  const AgentOwnerCommissionPeriodReport = new Vue({
    el: '.agent-owner-commission-period-report',
    data: {
      activeBtn: '',
      reports: {},
      users: [],
      periods: [],
      periodsId: '',
      paid: '0',
      totalPages: '',
      page: '',
      activePage: 1,
      pageSize: 20,
      loading: true,
      role: '',
      currency: '',
      currentUser: [],
      showReport: false,
      totalAgentsForPayment: {},
      totalAmountForPayment: {},
      totalAmountForPaymentFormatted: 0,
      excludedIds: {},
      error: '',
      errorMessage: '',
      success: '',
    },
    methods: {

      submit() {
      },

      makePayment() {
        api.agentCommissionPayment(this.periodsId, this.excludedIds[this.periodsId])
        .done((res) => {
          if (res.errors) {
            this.error = true;
            this.errorMessage = res.errors[0].message;
          }
          else {
            this.error = false;
            this.success = true;
          }
          })
        .fail(({ responseJSON: res }) => {
          this.error = true;
          this.errorMessage = res[0].message;
        })
        .always(() => {
          setTimeout(() => this.error ? this.error=false : this.success=false, 2000);
          this.loading = false;
        });
      },

      refreshInfo() {
        this.totalAmountForPaymentFormatted = skinFormatMoney.formatAmount(this.totalAmountForPayment[this.periodsId], this.currency);
      },

    },
    created () {
      if (!document.getElementById('agent-owner-commission-period-report')) {
        return;
      }

      api.getPlayer()
        .done(res => {
          this.currentUser.role = localStorage.getItem('role');
          this.currentUser.agentId = res.user_id;
          this.currentUser.username = res.username;
          if (this.currentUser.role === ROLE_AGENT) {
            this.agentId = this.currentUser.agentId;
            $(".group-by-commission-reports").css('display', 'none');
          }
        });

      api.getBalance().done(res => {
        this.currency = res.currency;
      });

      this.role = window.localStorage.getItem('role');

      api.agentGetPeriodsList()
        .done((res) => {
          if (res.length > 0) {
          let that = this;
          res.forEach( dRange => {
            let dates = dRange.split(':');
            that.periods.push({
              id: dRange,
              name: reverseDateFormat(dates[0]) + ' - ' + reverseDateFormat(dates[1]),
            });
          });
          this.periodsId = that.periods[0].id;
        }
        })
        .fail((error) => {
          consoleLog(error);
        })
        .always(() => this.loading = false);
    },
    mounted () {
      if (!document.getElementById('agent-owner-commission-period-report')) {
        return;
      }

      let summary;
      let pagination;
      let that = this;
      $(document).ready(function() {

        let table = $('#commissions-reports-payment').DataTable({
          'ajax': {
            method: 'GET',
            dataType: 'json',
            data: function( result ) {
              delete result.columns;//remove columns as filters
              result.periodDate = that.periodsId;
              result.paid = that.paid;
              result.page = ((result.start/result.length)+1);
              result['per-page'] = result.length;
              return result;
            },
            url: `/platform-api-v2/cps/report/pay-period`,
            beforeSend(req) {
              req.setRequestHeader('Authorization', 'Bearer ' + jwt());
              req.setRequestHeader('user-ip', __APP__.IP );
              req.setRequestHeader('user-country', __APP__.country_2 );
            },
            dataSrc: function ( data ) {
              that.showReport = data.data.length > 0;
              summary = data.summary;
              pagination = data.pagination;
              return data.data;
            },
            dataFilter: function (response, type) {
              response = JSON.parse(response);
              //response['draw'] = 1;
              response['recordsTotal'] = response.pagination.totalCount;
              response['recordsFiltered'] = response.pagination.totalCount;
              return JSON.stringify(response);
            }
          },
          'processing': true,
          'serverSide': true,
          'deferLoading': 0, //do not run without a trigger
          'columns': [
            { data: 'userId' },
            { data: 'username' },
            { data: 'plan' },
            { data: 'parentUsername' },
            { data: 'sportsbook',
              'render': function ( data, type, row, meta ) {
                return skinFormatMoney.formatAmount(data, that.currency);
              }
            },
            { data: 'elbet',
              'render': function ( data, type, row, meta ) {
                return skinFormatMoney.formatAmount(data, that.currency);
              }
            },
            { data: 'commission',
              'render': function ( data, type, row, meta ) {
                return skinFormatMoney.formatAmount(data, that.currency);
              }
            },
            { data: 'paid',
              'render': function ( data, type, row, meta ) {
                return (data === '1' ? 'Paid' : (data === '0' ? 'Not Paid' : data));
              }
            },
            { data: 'note' },
          ],
          'footerCallback': function ( tfoot, data, start, end, display ) {
            if (typeof data !== 'undefined' && data.length > 0) {
              $('tfoot .page-sportsbook').html(skinFormatMoney.formatAmount(summary.page.sportsbook, that.currency));
              $('tfoot .page-elbet').html(skinFormatMoney.formatAmount(summary.page.elbet, that.currency));
              $('tfoot .page-total').html(skinFormatMoney.formatAmount(summary.page.commission, that.currency));

              $('tfoot .overall-sportsbook').html(skinFormatMoney.formatAmount(summary.overall.sportsbook, that.currency));
              $('tfoot .overall-elbet').html(skinFormatMoney.formatAmount(summary.overall.elbet, that.currency));
              $('tfoot .overall-total').html(skinFormatMoney.formatAmount(summary.overall.commission, that.currency));

              if(! that.totalAgentsForPayment.hasOwnProperty(that.periodsId) && that.paid === '0') {
                that.totalAgentsForPayment[that.periodsId] = pagination.totalCount;
                that.totalAmountForPayment[that.periodsId] = summary.overall.commission;
                that.refreshInfo();
              }
            }
            else {
              $('tfoot .page-sportsbook').html(skinFormatMoney.formatAmount(0, that.currency));
              $('tfoot .page-elbet').html(skinFormatMoney.formatAmount(0, that.currency));
              $('tfoot .page-total').html(skinFormatMoney.formatAmount(0, that.currency));

              $('tfoot .overall-sportsbook').html(skinFormatMoney.formatAmount(0, that.currency));
              $('tfoot .overall-elbet').html(skinFormatMoney.formatAmount(0, that.currency));
              $('tfoot .overall-total').html(skinFormatMoney.formatAmount(0, that.currency));

              if(! that.totalAgentsForPayment.hasOwnProperty(that.periodsId) && that.paid === '0') {
                that.totalAgentsForPayment[that.periodsId] = 0;
                that.totalAmountForPayment[that.periodsId] = 0;
                that.refreshInfo();
              }
            }
          },
          'columnDefs': [
            {
              'targets': 0,
              'checkboxes': {
                'selectRow': true
              }
            }
          ],
          'select': {
            'style': 'multi'
          },
          "ordering": false,
          "lengthMenu": [ [10, 20, 50], [10, 20, 50] ],
          "pageLength": 20,
          "searching": false,
        });

        table
          .on( 'select', function ( e, dt, type, indexes ) {
            let rowData = table.rows( indexes ).data().toArray();
            rowData.forEach( item => {
              if(that.excludedIds.hasOwnProperty(that.periodsId)) {
                if(! that.excludedIds[that.periodsId].includes(item.userId)) {
                  that.excludedIds[that.periodsId].push(item.userId);
                  that.totalAgentsForPayment[that.periodsId] -= 1;
                  that.totalAmountForPayment[that.periodsId] = parseInt(that.totalAmountForPayment[that.periodsId])-parseInt(item.commission);
                  that.refreshInfo();
                }
              }
              else {
                that.excludedIds[that.periodsId] = item.userId.split();
                that.totalAgentsForPayment[that.periodsId] -= 1;
                that.totalAmountForPayment[that.periodsId] = parseInt(that.totalAmountForPayment[that.periodsId])-parseInt(item.commission);
                that.refreshInfo();
              }
            });
          })
          .on( 'deselect', function ( e, dt, type, indexes ) {
            let rowData = table.rows( indexes ).data().toArray();
            rowData.forEach( item => {
              if(that.excludedIds[that.periodsId].includes(item.userId)) {
                that.excludedIds[that.periodsId] = that.excludedIds[that.periodsId].filter(exitem => exitem !== item.userId);
                that.totalAgentsForPayment[that.periodsId] += 1;
                that.totalAmountForPayment[that.periodsId] = parseInt(that.totalAmountForPayment[that.periodsId]) + parseInt(item.commission);
                that.refreshInfo();
              }
            });
          });

        // Grab the datatables input box and alter how it is bound to events
        $("#commissions-reports-payment_filter input")
          .unbind() // Unbind previous default bindings
          .bind("input", function(e) { // Bind our desired behavior
            // If the length is 3 or more characters, or the user pressed ENTER, search
            if(this.value.length >= 3 || e.keyCode == 13) {
              // Call the API search function
              table.search(this.value).draw();
            }
            // Ensure we clear the search if they backspace far enough
            if(this.value == "") {
              table.search("").draw();
            }
            return;
          });
      });
    },
    computed: {
      disable() {
        return (this.paid !== "0" || !this.showReport);
      }
    },
    watch: {
      periodsId(newValue, oldValue) {
        $('#commissions-reports-payment').DataTable().ajax.reload(this.refreshInfo());
      },
      paid(newValue, oldValue) {
        $('#commissions-reports-payment').DataTable().ajax.reload();
        if(this.paid !== '0') {
          $('#commissions-reports-payment').DataTable().select.style( 'api' );
          $('#commissions-reports-payment .dt-checkboxes-select-all input[type="checkbox"]').prop('disabled', true);
        }
        else {
          $('#commissions-reports-payment').DataTable().select.style( 'multi' );
          $('#commissions-reports-payment .dt-checkboxes-select-all input[type="checkbox"]').prop('disabled', false);
        }
      },
    },
  });

  /* -----------------------------------------
  Agent Sportsbook Daily Accounting Report
  ----------------------------------------- */
  const AgentSBDailyAccountingReport = new Vue({
    el: '.agent-sb-daily-accounting-report',
    data: {
      activeBtn: 'week',
      currency: '',
      filters: [],
      fn: '',
      displaySearch: false,
      error: '',
      errorMessage: '',
      fromDate: '',
      toDate: '',
      createdFrom: '',
      createdTo: '',
      settledFrom: '',
      settledTo: '',
      paidFrom: '',
      paidTo: '',
      loggedInRole: __APP__.agentRole,
      userId: '',
      constantLoggedInId: '',
      constantPartnerId: 0,
      constantSuperAgentId: 0,
      constantAgentId: 0,
      status: '',
      paidout: '',
      betmode: '',
      loading: false,
      selections: '',
      picked: 'date_created',
      activePage: 0,
      pageSize: 20,
      totalAmountPerPage: 0,
      totalSettledAmountPerPage: 0,
      totalRevenuePerPage: 0,
      totalMarginPerPage: 0,
      totalAmountOverall: 0,
      totalSettledAmountOverall: 0,
      totalCountOverall: 0,
      totalRevenueOverall: 0,
      totalMarginOverall: 0,
      page: '',
      searchResults: [],
      tempSearchResults: [],
      tempDateSearchResults: [],
      tempLvlSearchResults: [],
      overall: [],
      userHierarchy: [],
      ds_date: '',
      dc_date: '',
      subrows: [],
      subrows2: [],
      subrows3: [],
      subrows4: [],
      subUserId: '',
      tempLvl1Idx: '',
      tempLvl2Idx: '',
      tempLvl3Idx: '',
      tempLvl4Idx: '',
      resources: '',
      filteredPartners: [],
      filteredSuperagents: [],
      filteredAgents: [],
      disableButton: false,
      showTotals: true,
      showMessage: false,
      localClass: '',
      notificationMessage: false,
    },

    methods: {

      showDateChildren(dateValue, dateIdx) {
        this.tempLvl1Idx = '';
        this.tempLvl2Idx = '';
        this.tempLvl3Idx = '';
        this.tempLvl4Idx = '';
        this.subUserId = 0;
        if ($("#date-bordered-collapse-" + dateIdx).hasClass("dateClosed")) {
          this.tempLvl1Idx = dateIdx;
          this.getAccountingResults(dateValue, 'date');
          $("#date-subrow-" + dateIdx).removeClass("d-none");
          $("#date-bordered-collapse-" + dateIdx).removeClass("dateClosed").addClass("dateOpened").html('-');
        }
        else if ($("#date-bordered-collapse-" + dateIdx).hasClass("dateOpened")) {
          this.subrows[dateIdx] = '';
          $("#date-subrow-" + dateIdx).addClass("d-none");
          $("#date-bordered-collapse-" + dateIdx).removeClass("dateOpened").addClass("dateClosed").html('+');
        }

      },
      showLvl1Children(lvl1AgentId, lvl1Idx, agentDate, dateIdx='') {
        if ($("#lvl1-sub-bordered-collapse-" + dateIdx + '-' + lvl1Idx).hasClass("lvl1Closed")) {
          this.tempLvl1Idx = dateIdx;
          this.tempLvl2Idx = lvl1Idx;
          this.subUserId = lvl1AgentId;
          this.getAccountingResults(lvl1AgentId, 'lvl1', agentDate);
          $("#lvl1-subrow-" + dateIdx + '-' + lvl1Idx).removeClass("d-none");
          $("#lvl1-sub-bordered-collapse-" + dateIdx + '-' + lvl1Idx).removeClass("lvl1Closed").addClass("lvl1Opened").html('-');
        }
        else if ($("#lvl1-sub-bordered-collapse-" + dateIdx + '-' + lvl1Idx).hasClass("lvl1Opened")) {
          this.subrows[dateIdx + '-' + lvl1Idx] = '';
          $("#lvl1-subrow-" + dateIdx + '-' + lvl1Idx).addClass("d-none");
          $("#lvl1-sub-bordered-collapse-" + dateIdx + '-' + lvl1Idx).removeClass("lvl1Opened").addClass("lvl1Closed").html('+');
        }
      },
      showLvl2Children(lvl2AgentId, lvl2Idx, agentDate, dateIdx='', lvl1Idx='') {
        this.tempLvl3Idx = '';
        let subSuffix = dateIdx + "-" + lvl1Idx + "-" + lvl2Idx;
        if ($("#lvl2-sub-bordered-collapse-" + subSuffix).hasClass("lvl2Closed")) {
          this.tempLvl1Idx = dateIdx;
          this.tempLvl2Idx = lvl1Idx;
          this.tempLvl3Idx = lvl2Idx;
          this.subUserId = lvl2AgentId;
          this.getAccountingResults(lvl2AgentId, 'lvl2', agentDate);
          $("#lvl2-subrow-" + subSuffix).removeClass("d-none");
          $("#lvl2-sub-bordered-collapse-" + subSuffix).removeClass("lvl2Closed").addClass("lvl2Opened").html('-');
        }
        else if ($("#lvl2-sub-bordered-collapse-" + subSuffix).hasClass("lvl2Opened")) {
          this.subrows2[subSuffix] = '';
          $("#lvl2-subrow-" + subSuffix).addClass("d-none");
          $("#lvl2-sub-bordered-collapse-" + subSuffix).removeClass("lvl2Opened").addClass("lvl2Closed").html('+');
        }
      },
      showLvl3Children(lvl3AgentId, lvl3Idx, agentDate, dateIdx='', lvl1Idx='', lvl2Idx='') {
        this.tempLvl4Idx = '';
        let subSuffix = dateIdx + "-" + lvl1Idx + "-" + lvl2Idx + "-" + lvl3Idx;
        if ($("#lvl3-sub-bordered-collapse-" + subSuffix).hasClass("lvl3Closed")) {
          this.tempLvl1Idx = dateIdx;
          this.tempLvl2Idx = lvl1Idx;
          this.tempLvl3Idx = lvl2Idx;
          this.tempLvl4Idx = lvl3Idx;
          this.subUserId = lvl3AgentId;
          this.getAccountingResults(lvl3AgentId, 'lvl3', agentDate);
          $("#lvl3-subrow-" + subSuffix).removeClass("d-none");
          $("#lvl3-sub-bordered-collapse-" + subSuffix).removeClass("lvl3Closed").addClass("lvl3Opened").html('-');
        }
        else if ($("#lvl3-sub-bordered-collapse-" + subSuffix).hasClass("lvl3Opened")) {
          this.subrows3[subSuffix] = '';
          $("#lvl3-subrow-" + subSuffix).addClass("d-none");
          $("#lvl3-sub-bordered-collapse-" + subSuffix).removeClass("lvl3Opened").addClass("lvl3Closed").html('+');
        }
      },

      getUserHierarchy(selectedRole='') {
        api.getAgentDirectChildren(this.userId)
          .done(res => {
            this.userHierarchy = sortAlphabeticalArrayByValue(res);
            if (selectedRole === 'partner') {
              $("#select2-chosen-2").text('All');
              $("#select2-chosen-3").text('All');
              this.filteredSuperagents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_SUPER_AGENT
              );
              this.filteredAgents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_AGENT
              );
            }
            if (selectedRole === 'superagent') {
              $("#select2-chosen-3").text('All');
              this.filteredAgents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_AGENT
              );
            }
            else if (selectedRole === 'agent') {
              $("#select2-chosen-3").text('All');
            }
            else {
              this.filteredPartners = this.userHierarchy.filter(agent =>
                agent.role === ROLE_PARTNER
              );
              this.filteredSuperagents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_SUPER_AGENT
              );
              this.filteredAgents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_AGENT
              );
            }
          })
          .fail((error) => {
            consoleLog(error);
          })
          .always(() => {
            this.loading = false;
          });
      },

      goToPage(selectedPage) {
        this.activePage = selectedPage;
        this.getDailyAccounting();
      },

      removeFilter(selectedFilter) {
        let that = this;
        switch(selectedFilter) {

          case 'selectedDate':
            setDate('week', this);
            this.createdFrom='';
            this.createdTo='';
            break;

          case 'selectedStatus':
            this.status='';
            break;

          case 'selectedPaidout':
            this.paidout='';
            break;

          case 'selectedUser':
            this.userId= this.constantLoggedInId;
            this.filters['user'] = this.username;
            that.constantPartnertId = 0;
            that.constantSuperAgentId = 0;
            that.constantAgentId = 0;
            $("#select2-chosen-1").text('All');
            $("#select2-chosen-2").text('All');
            $("#select2-chosen-3").text('All');
            break;
        }
        this.getUserHierarchy();
        this.getDailyAccounting();
      },

      setSelfDate (from) {
        this.activeBtn = from;
        setDate(from, this);
      },

      modifyDates(wantedDate) {
        let today = new Date();
        switch(wantedDate) {
          case 'today':
            let dd = today.getDate() > 9 ? today.getDate() : '0' + today.getDate();
            let mm = today.getMonth() + 1 > 9 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1);
            let yyyy = today.getFullYear();
            return dd + '-' + mm + '-' + yyyy;
            break;

          case 'week':
            let day = today.getDay();
            let diff = today.getDate() - day + (day == 0 ? -6 : 1);
            return reverseDateFormat(this.formatDate(new Date(today.setDate(diff))));
            break;
        }
      },

      getParams(page=0) {
        let that = this;
        if (this.picked === 'date_created') {
          that.filters['picked'] = 'date_created';
          this.createdFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.createdTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.settledFrom = '';
          this.settledTo = '';
          this.paidFrom = '';
          this.paidTo = '';
          this.filters['settledFrom'] = '';
          this.filters['settledTo'] = '';
          that.filters['createdFrom'] = (this.createdFrom) ? this.createdFrom : '';
          that.filters['createdTo'] = (this.createdTo) ? this.createdTo : '';
          this.filters['paidFrom'] = '';
          this.filters['paidTo'] = '';
        }
        else if (this.picked === 'date_settled') {
          that.filters['picked'] = 'date_settled';
          this.createdFrom = '';
          this.createdTo = '';
          this.paidFrom = '';
          this.paidTo = '';
          this.settledFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.settledTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.filters['createdFrom'] = '';
          this.filters['createdTo'] = '';
          that.filters['settledFrom'] = (this.settledFrom) ? this.settledFrom : '';
          that.filters['settledTo'] = (this.settledTo) ? this.settledTo : '';
          this.filters['paidFrom'] = '';
          this.filters['paidTo'] = '';
        }
        else if (this.picked === 'date_paid') {
          that.filters['picked'] = 'date_paid';
          this.createdFrom = '';
          this.createdTo = '';
          this.settledFrom = '';
          this.settledTo = '';
          this.paidFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.paidTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.filters['createdFrom'] = '';
          this.filters['createdTo'] = '';
          that.filters['settledFrom'] = '';
          that.filters['settledTo'] = '';
          that.filters['paidFrom'] = (this.paidFrom) ? this.paidFrom : '';
          that.filters['paidTo'] = (this.paidTo) ? this.paidTo : '';
        }

        if (page > 0) {
          this.activePage = page;
        }

        that.userId = this.getUserId();
      },

      getUserId(asCsv=false) {
        if (this.subUserId > 0 && !asCsv) {
          return this.subUserId;
        }
        else {
          if (this.constantAgentId > 0) {
            return this.constantAgentId;
          }
          else if (this.constantSuperAgentId > 0) {
            return this.constantSuperAgentId;
          }
          else if (this.constantPartnerId > 0) {
            return this.constantPartnerId;
          }
          else {
            return '';
          }
        }
      },

      reset() {
        let that = this;
        this.createdFrom = "";
        this.createdTo = "";
        this.paidout = "";
        this.status = "";
        this.picked = 'date_created';
        setDate('week', this);
        this.displaySearch = false;
        this.filters = [];
        this.activePage = 0;
        this.pageSize = 20;
        this.subUserId = 0;
        that.constantPartnerId = 0;
        that.constantSuperAgentId = 0;
        that.constantAgentId = 0;
        $("#select2-chosen-1").text('All');
        $("#select2-chosen-2").text('All');
        $("#select2-chosen-3").text('All');
      },

      formatDate(date) {
        let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      },

      saveReport() {
        this.disableButton = true;
        this.loading = true;
        this.notificationMessage = true;

        api.generateNewSbDailyReport(reverseDateFormat(this.createdFrom), reverseDateFormat(this.createdTo), reverseDateFormat(this.settledFrom), reverseDateFormat(this.settledTo), reverseDateFormat(this.paidFrom), reverseDateFormat(this.paidTo), this.status, this.paidout, this.getUserId(true), this.pageSize, this.activePage)
          .done(() => {
            this.notificationMessage = false;
            this.success = true;
            this.error = false;
            this.message = $("#csvSuccess").val();
            this.localClass = 'alert-success';
            this.showMessage = true;
          })
          .fail(() => {
            this.notificationMessage = false;
            this.message = $("#csvError").val();
            this.localClass = 'alert-danger';
            this.showMessage = true;
          })
          .always(() => {
            this.loading = false;
            this.disableButton = false;
            setTimeout(() => {
              this.showMessage = false;
              }, 3000);
          })
      },

      getAccountingResults(currentValue, subRowsType = 'date', agentDate='') {
        this.getParams();
        this.loading = true;
        this.displaySearch = true;
        if ( subRowsType === 'date' ) {
          if ( this.picked === 'date_created' ) {
            this.dc_date = currentValue;
            this.ds_date = '';
          } 
          else {
            this.ds_date = currentValue;
            this.dc_date = '';
          }
        }
        else {
          if (this.picked === 'date_created') {
            this.dc_date = agentDate;
            this.ds_date = '';
          } 
          else {
            this.ds_date = agentDate;
            this.dc_date = '';
          }
        }

        api.generateNewSbAccountingReportFull(reverseDateFormat(this.dc_date), reverseDateFormat(this.dc_date), reverseDateFormat(this.ds_date), reverseDateFormat(this.ds_date), this.status, this.paidout, this.userId)
          .done(res => {
            if(res.list.length > 0) {

              this.displaySearch = true;
              let that = this;
              this.error = false;

              this.tempLvlSearchResults = res.list.map(item => {
                return {
                  'userId': item.userId,
                  'date': item.date,
                  'username': item.username,
                  'intUserRole': parseInt(item.role),
                  'noOfBets': item.count,
                  'amount': swapCurrency(formatMoney(item.amount, this.currency)),
                  'canceledAmount': swapCurrency(formatMoney(item.canceledAmount, this.currency)),
                  'paidAmount': swapCurrency(formatMoney(item.paidAmount, this.currency)),
                  'revenue': swapCurrency(formatMoney(item.revenue, this.currency)),
                  'margin': item.margin
                };
              }, that);

              if ( subRowsType === 'date' ) {
                this.subrows[this.tempLvl1Idx] = this.tempLvlSearchResults;
              }
              else if ( subRowsType === 'lvl1' ) {
                this.subrows2[this.tempLvl1Idx + '-' + this.tempLvl2Idx] = this.tempLvlSearchResults;
              }
              else if ( subRowsType === 'lvl2' ) {
                this.subrows3[this.tempLvl1Idx + '-' + this.tempLvl2Idx + '-' + this.tempLvl3Idx] = this.tempLvlSearchResults;
              }
              else {
                this.subrows4[this.tempLvl1Idx + '-' + this.tempLvl2Idx + '-' + this.tempLvl3Idx + '-' + this.tempLvl4Idx] = this.tempLvlSearchResults;
              }
            }

          })
          .fail(({ responseJSON: res }) => {
            this.error = true;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            }
          })
          .always(() => {
            this.loading = false;
          });
      },

      getDailyAccounting(page=0, asCsv=0) {
        this.subUserId = 0;
        this.displaySearch = false;
        $(".innerBody").addClass("d-none");
        $(".bordered-collapse").each(function(){
          if ( $( this ).hasClass( "dateOpened" ) ) {
            $( this ).removeClass("dateOpened").addClass("dateClosed").html('+');
          }
          if ( $( this ).hasClass( "lvl1Opened" ) ) {
            $( this ).removeClass("lvl1Opened").addClass("lvl1Closed").html('+');
          }
          if ( $( this ).hasClass( "lvl2Opened" ) ) {
            $( this ).removeClass("lvl2Opened").addClass("lvl2Closed").html('+');
          }
        });
        this.loading = true;
        this.disableButton = true;
        this.filters['paidout'] = (this.paidout == PAIDOUT_YES) ? $("#agent_status_yes").val() : (this.paidout == PAIDOUT_NO) ? $("#agent_status_no").val() : $("#agent_status_any").val();
        this.filters['status'] = (this.status) ? this.status : '';
        this.filters['user'] = ($("#select2-chosen-3").length > 0 && $("#select2-chosen-3").text() !== 'All') ? $("#select2-chosen-3").text()
          : ($("#select2-chosen-2").length > 0 && $("#select2-chosen-2").text() !== 'All') ? $("#select2-chosen-2").text()
            : ($("#select2-chosen-1").length > 0 && $("#select2-chosen-1").text() !== 'All') ? $("#select2-chosen-1").text()
              : this.username;
        this.getParams(page);

        api.generateNewSbDailyReport(reverseDateFormat(this.createdFrom), reverseDateFormat(this.createdTo), reverseDateFormat(this.settledFrom), reverseDateFormat(this.settledTo), reverseDateFormat(this.paidFrom), reverseDateFormat(this.paidTo), this.status, this.paidout, this.userId, this.pageSize, this.activePage, asCsv)
          .done(res => {
            if (asCsv) {
              this.success = true;
              this.error = false;
              this.message = $("#csvSuccess").val();
              this.localClass = 'alert-success';
              this.showMessage = true;
            }
            else {
              if(res.list.length > 0) {
                this.displaySearch = true;
                let that = this;
                this.error = false;
  
                this.totalCountPerPage = res.summary.page.count;
                this.totalAmountPerPage = swapCurrency(formatMoney(res.summary.page.amount, this.currency));
                this.totalCanceledAmountPerPage = swapCurrency(formatMoney(res.summary.page.canceledAmount, this.currency));
                this.totalPaidAmountPerPage = swapCurrency(formatMoney(res.summary.page.paidAmount, this.currency));
                this.totalRevenuePerPage = swapCurrency(formatMoney(res.summary.page.revenue, this.currency));
                this.totalMarginPerPage = res.summary.page.margin;
  
                this.totalCountOverall = res.summary.overall.count;
                this.totalAmountOverall = swapCurrency(formatMoney(res.summary.overall.amount, this.currency));
                this.totalCanceledAmountOverall = swapCurrency(formatMoney(res.summary.overall.canceledAmount, this.currency));
                this.totalPaidAmountOverall = swapCurrency(formatMoney(res.summary.overall.paidAmount, this.currency));
                this.totalRevenueOverall = swapCurrency(formatMoney(res.summary.overall.revenue, this.currency));
                this.totalMarginOverall = res.summary.overall.margin;
  
  
                this.tempSearchResults = res.list.map(item => {
                  return {
                    'userId': item.userId,
                    'date': reverseDateFormat(item.date),
                    'username': item.username,
                    'noOfBets': item.count,
                    'amount': swapCurrency(formatMoney(item.amount, this.currency)),
                    'canceledAmount': swapCurrency(formatMoney(item.canceledAmount, this.currency)),
                    'paidAmount': swapCurrency(formatMoney(item.paidAmount, this.currency)),
                    'revenue': swapCurrency(formatMoney(item.revenue, this.currency)),
                    'margin': item.margin
                  };
                }, that);
  
                this.searchResults = this.tempSearchResults;
              }
            }
          })
          .fail(({ responseJSON: res }) => {
            this.error = true;
            if (res.errors) {
              if (this.asCsv) {
                this.message = $("#csvError").val();
                this.localClass = 'alert-danger';
                this.showMessage = true;
              }
              else {
                this.errorMessage = res.errors[0].message;
              }
            }
          })
          .always(() => {
            this.loading = false;
            this.disableButton = false;
            addSticky('th');
          });
      }

    },

    created () {
      if (!document.getElementById('agent-sb-daily-accounting-report')) {
        return;
      }
      setDate('week', this);

      api.getBalance()
        .done(res => {
          this.currency = res.currency;
        });

      this.error = false;
      api.getPlayer().done(res => {
        this.username = res.username;
        this.userId = res.user_id;
        this.constantLoggedInId = res.user_id;
        this.getUserHierarchy();
      });

    },

    mounted () {
      if (!document.getElementById('agent-sb-daily-accounting-report')) {
        return;
      }

      // Initialize datepickers
      const that = this;
      const $startDate = $(this.$refs.fromDate);
      const $endDate = $(this.$refs.toDate);

      $startDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate, date) {
          that.fromDate = formattedDate;
          $endDate.datepicker().data('datepicker').update('minDate', date);
        },
      });

      $endDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate) {
          that.toDate = formattedDate;
        },
      });

      $('#agent-sb-daily-accounting-report-partner').select2()
      .on('change', function () {
        that.constantAgentId = 0;
        that.constantSuperAgentId = 0;
        that.constantPartnerId = this.value;
        that.userId = this.value > 0 ? this.value : that.constantLoggedInId;
        that.getUserHierarchy('partner');
      });

      $('#agent-sb-daily-accounting-report-superagent').select2()
        .on('change', function () {
          that.constantAgentId = 0;
          that.constantSuperAgentId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantLoggedInId;
          that.getUserHierarchy('superagent');
        });

      $('#agent-sb-daily-accounting-report-agent').select2()
        .on('change', function () {
          that.constantAgentId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantSuperAgentId;
          that.getUserHierarchy('agent');
        });
    }

  });

  /* -----------------------------------------
  Agent Sportsbook Accounting Report
  ----------------------------------------- */
  const AgentSBAccountingReport = new Vue({
    el: '.agent-sb-accounting-report',
    data: {
      activeBtn: 'week',
      currency: '',
      filters: [],
      fn: '',
      displaySearch: false,
      error: '',
      errorMessage: '',
      fromDate: '',
      toDate: '',
      createdFrom: '',
      createdTo: '',
      settledFrom: '',
      settledTo: '',
      paidFrom: '',
      paidTo: '',
      agent: '',
      user: '',
      loggedInRole: __APP__.agentRole,
      agents: [],
      users: [],
      userId: '',
      constantLoggedInId: 0,
      constantPartnerId: 0,
      constantSuperAgentId: 0,
      constantAgentId: 0,
      status: '',
      paidout: '',
      betmode: '',
      loading: false,
      selections: '',
      picked: 'date_created',
      totalPages: 0,
      activePage: 0,
      pageSize: 20,
      totalAmountPerPage: 0,
      totalSettledAmountPerPage: 0,
      totalRevenuePerPage: 0,
      totalMarginPerPage: 0,
      totalAmountOverall: 0,
      totalSettledAmountOverall: 0,
      totalCountOverall: 0,
      totalRevenueOverall: 0,
      totalMarginOverall: 0,
      page: '',
      searchResults: [],
      tempSearchResults: [],
      overall: [],
      userHierarchy: [],
      subrows: [],
      subrows2: [],
      subrows3: [],
      subUserId: '',
      tempLvl1Idx: '',
      tempLvl2Idx: '',
      tempLvl3Idx: '',
      ds_date: '',
      dc_date: '',
      filteredPartners: [],
      filteredSuperagents: [],
      filteredAgents: [],
      disableButton: false,
      showMessage: false,
      localClass: '',
      notificationMessage: false
    },

    methods: {

      showLvl1Children(lvl1AgentId, lvl1Idx) {
        if ($("#lvl1-bordered-collapse-" + lvl1Idx).hasClass("lvl1Closed")) {
          this.tempLvl1Idx = lvl1Idx;
          this.getAccountingResults(lvl1AgentId, 'lvl1', true);
          $("#lvl1-subrow-" + lvl1Idx).removeClass("d-none");
          $("#lvl1-bordered-collapse-" + lvl1Idx).removeClass("lvl1Closed").addClass("lvl1Opened").html('-');
        }
        else if ($("#lvl1-bordered-collapse-" + lvl1Idx).hasClass("lvl1Opened")) {
          this.subrows[lvl1Idx] = '';
          $("#lvl1-subrow-" + lvl1Idx).addClass("d-none");
          $("#lvl1-bordered-collapse-" + lvl1Idx).removeClass("lvl1Opened").addClass("lvl1Closed").html('+');
        }

      },
      showLvl2Children(lvl2AgentId, lvl2Idx, lvl1Idx='') {
        this.tempLvl3Idx = '';
        let subSuffix = lvl1Idx + "-" + lvl2Idx;
        if ($("#lvl2-sub-bordered-collapse-" + subSuffix).hasClass("lvl2Closed")) {
          this.tempLvl1Idx = lvl1Idx;
          this.tempLvl2Idx = lvl2Idx;
          this.subUserId = lvl2AgentId;
          this.getAccountingResults(lvl2AgentId, 'lvl2', true);
          $("#lvl2-subrow-" + subSuffix).removeClass("d-none");
          $("#lvl2-sub-bordered-collapse-" + subSuffix).removeClass("lvl2Closed").addClass("lvl2Opened").html('-');
        }
        else if ($("#lvl2-sub-bordered-collapse-" + subSuffix).hasClass("lvl2Opened")) {
          this.subrows2[subSuffix] = '';
          $("#lvl2-subrow-" + subSuffix).addClass("d-none");
          $("#lvl2-sub-bordered-collapse-" + subSuffix).removeClass("lvl2Opened").addClass("lvl2Closed").html('+');
        }
      },

      showLvl3Children(lvl3AgentId, lvl3Idx, lvl1Idx='', lvl2Idx='') {
        this.tempLvl3Idx = '';
        let subSuffix = lvl1Idx + "-" + lvl2Idx + "-" + lvl3Idx;
        if ($("#lvl3-sub-bordered-collapse-" + subSuffix).hasClass("lvl3Closed")) {
          this.tempLvl1Idx = lvl1Idx;
          this.tempLvl2Idx = lvl2Idx;
          this.tempLvl3Idx = lvl3Idx;
          this.subUserId = lvl3AgentId;
          this.getAccountingResults(lvl3AgentId, 'lvl3', "#lvl3-sub-bordered-collapse-" + subSuffix);
          $("#lvl3-subrow-" + subSuffix).removeClass("d-none");
          $("#lvl3-sub-bordered-collapse-" + subSuffix).removeClass("lvl3Closed").addClass("lvl3Opened").html('-');
        }
        else if ($("#lvl3-sub-bordered-collapse-" + subSuffix).hasClass("lvl3Opened")) {
          this.subrows3[lvl1Idx + '-' + lvl2Idx + '-' + lvl3Idx] = '';
          $("#lvl3-subrow-" + subSuffix).addClass("d-none");
          $("#lvl3-sub-bordered-collapse-" + subSuffix).removeClass("lvl3Opened").addClass("lvl3Closed").html('+');
        }
      },

      getUserHierarchy(selectedRole='') {
        api.getAgentDirectChildren(this.userId)
          .done(res => {
            this.userHierarchy = sortAlphabeticalArrayByValue(res);
            if (selectedRole === 'partner') {
              $("#select2-chosen-2").text('All');
              $("#select2-chosen-3").text('All');
              this.filteredSuperagents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_SUPER_AGENT
              );

              this.filteredAgents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_AGENT
              );
            }
            else if (selectedRole === 'superagent') {
              $("#select2-chosen-3").text('All');
              this.filteredAgents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_AGENT
              );
            }
            else if (selectedRole === 'agent') {
              return;
            }
            else {
              this.filteredPartners = this.userHierarchy.filter(agent =>
                agent.role === ROLE_PARTNER
              );
              this.filteredSuperagents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_SUPER_AGENT
              )
              this.filteredAgents = this.userHierarchy.filter(agent =>
                agent.role === ROLE_AGENT
              );
            }
          })
          .fail((error) => {
            consoleLog(error);
          })
          .always(() => {
            this.loading = false;
          });
      },

      goToPage(selectedPage) {
        this.activePage = selectedPage;
        this.getAccountingResults();
      },

      getResultsNo() {
        this.getAccountingResults();
      },

      removeFilter(selectedFilter) {
        let that = this;
        switch(selectedFilter) {

          case 'selectedDate':
            setDate('week', this);
            this.createdFrom='';
            this.createdTo='';
            break;

          case 'selectedStatus':
            this.status='';
            break;

          case 'selectedPaidout':
            this.paidout='';
            break;

          case 'selectedUser':
            this.userId= this.constantLoggedInId;
            this.filters['user'] = this.username;
            that.constantPartnertId = 0;
            that.constantSuperAgentId = 0;
            that.constantAgentId = 0;
            $("#select2-chosen-1").text('All');
            $("#select2-chosen-2").text('All');
            break;
        }
        this.getUserHierarchy();
        this.getAccountingResults();
      },

      setSelfDate (from) {
        this.activeBtn = from;
        setDate(from, this);
      },

      modifyDates(wantedDate) {
        let today = new Date();
        switch(wantedDate) {
          case 'today':
            let dd = today.getDate() > 9 ? today.getDate() : '0' + today.getDate();
            let mm = today.getMonth() + 1 > 9 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1);
            let yyyy = today.getFullYear();
            return dd + '-' + mm + '-' + yyyy;
            break;

          case 'week':
            let day = today.getDay();
            let diff = today.getDate() - day + (day == 0 ? -6 : 1);
            return reverseDateFormat(this.formatDate(new Date(today.setDate(diff))));
            break;
        }
      },

      getParams(page=0) {
        let that = this;
        if (this.picked === 'date_created') {
          that.filters['picked'] = 'date_created';
          this.createdFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.createdTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.settledFrom = '';
          this.settledTo = '';
          this.paidFrom = '';
          this.paidTo = '';
          this.filters['settledFrom'] = '';
          this.filters['settledTo'] = '';
          that.filters['createdFrom'] = (this.createdFrom) ? this.createdFrom : '';
          that.filters['createdTo'] = (this.createdTo) ? this.createdTo : '';
          this.filters['paidFrom'] = '';
          this.filters['paidTo'] = '';
        }
        else if (this.picked === 'date_settled') {
          that.filters['picked'] = 'date_settled';
          this.createdFrom = '';
          this.createdTo = '';
          this.paidFrom = '';
          this.paidTo = '';
          this.settledFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.settledTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.filters['createdFrom'] = '';
          this.filters['createdTo'] = '';
          that.filters['settledFrom'] = (this.settledFrom) ? this.settledFrom : '';
          that.filters['settledTo'] = (this.settledTo) ? this.settledTo : '';
          this.filters['paidFrom'] = '';
          this.filters['paidTo'] = '';
        }
        else if (this.picked === 'date_paid') {
          that.filters['picked'] = 'date_paid';
          this.createdFrom = '';
          this.createdTo = '';
          this.settledFrom = '';
          this.settledTo = '';
          this.paidFrom = (this.fromDate) ? this.fromDate : this.modifyDates('week');
          this.paidTo = (this.toDate) ? this.toDate : this.modifyDates('today');
          this.filters['createdFrom'] = '';
          this.filters['createdTo'] = '';
          that.filters['settledFrom'] = '';
          that.filters['settledTo'] = '';
          that.filters['paidFrom'] = (this.paidFrom) ? this.paidFrom : '';
          that.filters['paidTo'] = (this.paidTo) ? this.paidTo : '';
        }

        if (page > 0) {
          this.activePage = page;
        }
        that.userId = this.getUserId();
      },

      reset() {
        let that = this;
        this.createdFrom = "";
        this.createdTo = "";
        this.paidout = "";
        this.status = "";
        this.picked = 'date_created';
        setDate('week', this);
        this.displaySearch = false;
        this.filters = [];
        this.activePage = 0;
        this.pageSize = 20;
        this.subUserId = 0;
        that.constantPartnerId = 0;
        that.constantSuperAgentId = 0;
        that.constantAgentId = 0;
        $("#select2-chosen-1").text('All');
        $("#select2-chosen-2").text('All');
        $("#select2-chosen-3").text('All');
      },

      formatDate(date) {
        let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      },

      getUserId(asCsv=false) {
        if (this.subUserId > 0 && !asCsv) {
          return this.subUserId;
        }
        else {
          if (this.constantAgentId > 0) {
            return this.constantAgentId;
          }
          else if (this.constantSuperAgentId > 0) {
            return this.constantSuperAgentId;
          }
          else if (this.constantPartnerId > 0) {
            return this.constantPartnerId;
          }
          else {
            return '';
          }
        }
      },

      saveReport() {
        this.disableButton = true;
        this.loading = true;
        this.notificationMessage = true;

        api.generateNewSbAccountingReport(reverseDateFormat(this.createdFrom), reverseDateFormat(this.createdTo), reverseDateFormat(this.settledFrom), reverseDateFormat(this.settledTo), reverseDateFormat(this.paidFrom), reverseDateFormat(this.paidTo),  this.status, this.paidout, this.getUserId(true), this.pageSize, this.activePage, this.userRole)
          .done(() => {
            this.notificationMessage = false;
            this.success = true;
            this.error = false;
            this.message = $("#csvSuccess").val();
            this.localClass = 'alert-success';
            this.showMessage = true;
          })
          .fail(() => {
            this.message = $("#csvError").val();
            this.localClass = 'alert-danger';
            this.showMessage = true;
          })
          .always(() => {
            this.notificationMessage = false;
            this.loading = false;
            this.disableButton = false;
            setTimeout(() => {
              this.showMessage = false;
              }, 3000);
          })
      },

      getAccountingResults(currentValue='', subRowsType='', isSubRow=false, asCsv=0) {
        if (subRowsType === '') {
          $(".innerBody").addClass("d-none");
          $(".bordered-collapse").each(function () {
            if ($(this).hasClass("lvl1Opened")) {
              $(this).removeClass("lvl1Opened").addClass("lvl1Closed").html('+');
            }
            if ($(this).hasClass("lvl2Opened")) {
              $(this).removeClass("lvl2Opened").addClass("lvl2Closed").html('+');
            }
          });
        }
        let that = this;
        this.disableButton = true;
        this.getParams();
        this.loading = true;

        this.filters['paidout'] = (this.paidout == PAIDOUT_YES) ? $("#agent_status_yes").val() : (this.paidout == PAIDOUT_NO) ? $("#agent_status_no").val() : $("#agent_status_any").val();
        this.filters['status'] = (this.status) ? this.status : '';
        this.filters['user'] = ($("#select2-chosen-3").length > 0 && $("#select2-chosen-3").text() !== 'All') ? $("#select2-chosen-3").text()
        : ($("#select2-chosen-2").length > 0 && $("#select2-chosen-2").text() !== 'All') ? $("#select2-chosen-2").text()
          : ($("#select2-chosen-1").length > 0 && $("#select2-chosen-1").text() !== 'All') ? $("#select2-chosen-1").text()
            : this.username;

        this.subUserId = currentValue;

        this.getParams(this.activePage);

        api.generateNewSbAccountingReport(reverseDateFormat(this.createdFrom), reverseDateFormat(this.createdTo), reverseDateFormat(this.settledFrom), reverseDateFormat(this.settledTo), reverseDateFormat(this.paidFrom), reverseDateFormat(this.paidTo), this.status, this.paidout, that.userId, this.pageSize, this.activePage, asCsv)
          .done(res => {
            if(res.list.length > 0) {
              this.displaySearch = true;
              let that = this;
              this.error = false;

              this.totalPages = parseInt(res.pagination.pageCount);
              this.error = false;

              if (!isSubRow) {
              this.totalCountPerPage = res.summary.page.count;
              this.totalAmountPerPage = swapCurrency(formatMoney(res.summary.page.amount, this.currency));
              this.totalCanceledAmountPerPage = swapCurrency(formatMoney(res.summary.page.canceledAmount, this.currency));
              this.totalPaidAmountPerPage = swapCurrency(formatMoney(res.summary.page.paidAmount, this.currency));
              this.totalRevenuePerPage = swapCurrency(formatMoney(res.summary.page.revenue, this.currency));
              this.totalMarginPerPage = res.summary.page.margin;

              this.totalCountOverall = res.summary.overall.count;
              this.totalAmountOverall = swapCurrency(formatMoney(res.summary.overall.amount, this.currency));
              this.totalCanceledAmountOverall = swapCurrency(formatMoney(res.summary.overall.canceledAmount, this.currency));
              this.totalPaidAmountOverall = swapCurrency(formatMoney(res.summary.overall.paidAmount, this.currency));
              this.totalRevenueOverall = swapCurrency(formatMoney(res.summary.overall.revenue, this.currency));
              this.totalMarginOverall = res.summary.overall.margin;
              }

              this.tempSearchResults = res.list.map(item => {
                return {
                  'userId': item.userId,
                  'username': item.username,
                  'intUserRole': parseInt(item.role),
                  'noOfBets': item.count,
                  'amount': swapCurrency(formatMoney(item.amount, this.currency)),
                  'canceledAmount': swapCurrency(formatMoney(item.canceledAmount, this.currency)),
                  'paidAmount': swapCurrency(formatMoney(item.paidAmount, this.currency)),
                  'revenue': swapCurrency(formatMoney(item.revenue, this.currency)),
                  'margin': item.margin
                };
              }, that);

              if (!currentValue) {
                this.searchResults = this.tempSearchResults;
              }
              else {
                if (subRowsType === 'lvl1') {
                  this.subrows[this.tempLvl1Idx] = this.tempSearchResults;
                }
                else if (subRowsType === 'lvl2') {
                  this.subrows2[this.tempLvl1Idx + "-" + this.tempLvl2Idx] = this.tempSearchResults;
                }
                else {
                  this.subrows3[this.tempLvl1Idx + '-' + this.tempLvl2Idx + '-' + this.tempLvl3Idx] = this.tempSearchResults;
                }
              }
            }
            else {
              this.displaySearch = false;
            }

          })
          .fail(({ responseJSON: res }) => {
            this.error = true;
            if (res.errors) {
              this.errorMessage = res.errors[0].message;
            }
          })
          .always(() => {
            this.loading = false;
            this.disableButton = false;
            addSticky('th');
          });
      },

    },

    created() {
      if (!document.getElementById('agent-sb-accounting-report')) {
        return;
      }
      if (this.loggedInRole === "90" || this.loggedInRole === "100") {
        this.showTotals = false;
      }
      setDate('week', this);

      api.getBalance()
        .done(res => {
          this.currency = res.currency;
        });

      this.error = false;
      api.getPlayer().done(res => {
        this.username = res.username;
        this.userId = res.user_id;
        this.constantLoggedInId = res.user_id;
        this.getUserHierarchy();
      });

    },

    mounted() {
      if (!document.getElementById('agent-sb-accounting-report')) {
        return;
      }

      // Initialize datepickers
      const that = this;
      const $startDate = $(this.$refs.fromDate);
      const $endDate = $(this.$refs.toDate);

      $startDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate, date) {
          that.fromDate = formattedDate;
          $endDate.datepicker().data('datepicker').update('minDate', date);
        },
      });

      $endDate.datepicker({
        language: setDefaultLanguage(__APP__.langShort),
        dateFormat: 'dd-mm-yyyy',
        maxDate: new Date(),
        onSelect (formattedDate) {
          that.toDate = formattedDate;
        },
      });
      
      $('#agent-sb-accounting-report-partner').select2()
      .on('change', function () {
        that.constantAgentId = 0;
        that.constantSuperAgentId = 0;
        that.constantPartnerId = this.value;
        that.userId = this.value > 0 ? this.value : that.constantLoggedInId;
        that.getUserHierarchy('partner');
      });

      $('#agent-sb-accounting-report-superagent').select2()
        .on('change', function () {
          that.constantAgentId = 0;
          that.constantSuperAgentId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantLoggedInId;
          that.getUserHierarchy('superagent');
        });

      $('#agent-sb-accounting-report-agent').select2()
        .on('change', function () {
          that.constantAgentId = this.value;
          that.userId = this.value > 0 ? this.value : that.constantSuperAgentId;
          that.getUserHierarchy('agent');
        });
    }

  });

  /* -----------------------------------------
  Agent Sidebar Menu
  ----------------------------------------- */

  const AgentSidebarMenu = new Vue({
    el: '.sidebar-menu',
    methods: {
      changeCollapseIcon(id) {
        if ($("#fa-" + id).hasClass('fa fa-chevron-right')) {
          $("#fa-" + id).removeClass('fa fa-chevron-right');
          $("#fa-" + id).addClass('fa fa-chevron-down');
        }
        else {
          $("#fa-" + id).removeClass('fa fa-chevron-down');
          $("#fa-" + id).addClass('fa fa-chevron-right');
        }
      }
    },

    created () {
      if (!document.getElementById('sidebar-menu')) {
        return;
      }
    }
  });

  function modalFlash() {
    try {
      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
      if (!fo) {
        $('#modal-flash').modal('show');
      }
    }
    catch (e) {
      if ( navigator.mimeTypes
        && navigator.mimeTypes['application/x-shockwave-flash'] == undefined ) {
        $('#modal-flash').modal('show');
      }
    }
  }

  function reverseDateFormat(date) {
    if (date) {
      let temp = [];
      let fixedDate = date.split("-");
      temp[0] = fixedDate[2];
      temp[1] = fixedDate[1];
      temp[2] = fixedDate[0];
      fixedDate = temp[0] + "-" + temp[1] + "-" + temp[2];
      return fixedDate;
    }
    else {
      return '';
    }
  }

  function setDate (from, that) {
    let d = new Date();
    switch (from) {
      case 'today':
        that.fromDate = new Date();
        break;
      case 'yesterday':
        that.fromDate = new Date();
        let now = Date.now();
        that.fromDate.setTime(now - 24 * 60 * 60 * 1000);
        break;
      case 'week':
        let day = d.getDay();
        let diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day
                                                            // is sunday
        that.fromDate = new Date(d.setDate(diff));
        break;
      case 'month':
        that.fromDate = new Date(d.getFullYear(), d.getMonth(), 1, 12);//1st of
                                                                       // this
                                                                       // month
        break;
      default:
    }
    let dateString = that.fromDate.toISOString().split("T");
    that.fromDate = reverseDateFormat(dateString[0]);
    that.toDate = new Date();
    if (from === 'yesterday') {
      that.toDate.setDate(that.toDate.getDate() - 1);
    }
    dateString = that.toDate.toISOString().split("T");
    that.toDate = reverseDateFormat(dateString[0]);
  }

  function setTimeOut(localClass) {
    $(localClass).show();
    setInterval(function() { $(localClass).hide(); }, 2500);
    return true;
  }

  // set as a global function to be included in all pages of airdatepicker
 // and set default Lang as 'en' if selected language is missing.
 function setDefaultLanguage(lang) {
  if ( typeof $.fn.datepicker.language[lang] === "undefined" ) {
    return "en";
  }
  return lang;
 }

 function swapCurrency(amount) {
  let RIGHT_POSITION = 1;
  let LEFT_POSITION = 0;
  let currencySymbol;
  let currencySymbolPosition;
  let fixedCurrencyPosition = amount.split(" ");
  switch(fixedCurrencyPosition[0]) {
    case 'EUR':
      currencySymbol = '\u20AC';
      currencySymbolPosition = RIGHT_POSITION; // Right position
      break;
    case 'USD':
      currencySymbol = '\u0024';
      currencySymbolPosition = LEFT_POSITION; // Left position
      break;  
    default:
        currencySymbol = fixedCurrencyPosition[0];
        currencySymbolPosition = LEFT_POSITION; // Left position
    }
    if (currencySymbolPosition === LEFT_POSITION) {
      return currencySymbol + fixedCurrencyPosition[1];
    }
    else {
      return fixedCurrencyPosition[1] + currencySymbol;
    }
  }

  function sortAlphabeticalArrayByValue(myArray) {
    return myArray.sort((a, b) => (a.username > b.username) ? 1 : -1);
  }

  function formatDateTime(dateTime) {
    if (dateTime) {
      let d = new Date(dateTime);
      d.setTime( d.getTime() - d.getTimezoneOffset()*60*1000 );
      return ("0" + d.getDate()).slice(-2)+"-"+("0" + (d.getMonth()+1)).slice(-2)+"-"+d.getFullYear()+" "+("0" + d.getHours()).slice(-2)+":"+("0" + d.getMinutes()).slice(-2)+":"+("0" + d.getSeconds()).slice(-2);
    }
    else {
      return "";
    }
  }

  function addSticky(element) {
    if ( !$(element).hasClass('sticky')) {
      $(element).addClass('sticky')
    }
  }

  function oldPasswordswitchVisibility(contextKey, fieldType, showField) {
    contextKey[fieldType] = contextKey[fieldType] === 'password' ? 'text' : 'password';
    contextKey[showField] = !contextKey[showField];
    
  }

  function switchVisibility(contextKey, fieldType, showField) {
    contextKey[fieldType] = contextKey[fieldType] === 'password' ? 'text' : 'password';
    contextKey[showField] = !contextKey[showField];
    
  }
  
  function repeatPasswordSwitchVisibility(contextKey, repeatFieldType, showRepeatField) {
    contextKey[repeatFieldType] = contextKey[repeatFieldType] === 'password' ? 'text' : 'password';
    contextKey[showRepeatField] = !contextKey[showRepeatField];
  }
  
  function popoverInfoMessage(message, element) {
    element = document.getElementById(element);
    element.innerHTML = `<i data-toggle="popover" data-content="${message}" data-placement="top" class="fa fa-info-circle info-circle"></i>`;
    $(function () {
      $('[data-toggle="popover"]').popover({
        trigger: 'hover'
    });     
   });
  }

});
